window.theme = window.theme || {}, theme.Sections = function() {
        this.constructors = {}, this.instances = [], $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
    }, theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function(e, t) {
            var a = $(e),
                s = a.attr("data-section-id"),
                o = a.attr("data-section-type");
            if (t = t || this.constructors[o], !_.isUndefined(t)) {
                var r = _.assignIn(new t(e), {
                    id: s,
                    type: o,
                    container: e
                });
                this.instances.push(r)
            }
        },
        _onSectionLoad: function(e) {
            var t = $("[data-section-id]", e.target)[0];
            if (t) {
                this._createInstance(t);
                var a = _.find(this.instances, function(t) {
                    return t.id === e.detail.sectionId
                });
                !_.isUndefined(a) && _.isFunction(a.onLoad) && a.onLoad(e)
            }
        },
        _onSectionUnload: function(e) {
            this.instances = _.filter(this.instances, function(t) {
                var a = t.id === e.detail.sectionId;
                return a && _.isFunction(t.onUnload) && t.onUnload(e), !a
            })
        },
        _onSelect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e)
        },
        _onDeselect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e)
        },
        _onBlockSelect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e)
        },
        _onBlockDeselect: function(e) {
            var t = _.find(this.instances, function(t) {
                return t.id === e.detail.sectionId
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e)
        },
        register: function(e, t) {
            this.constructors[e] = t, $("[data-section-type=" + e + "]").each(function(e, a) {
                this._createInstance(a, t)
            }.bind(this))
        }
    }), window.slate = window.slate || {}, slate.rte = {
        wrapTable: function(e) {
            e.$tables.wrap("<div class=\"" + e.tableWrapperClass + "\"></div>")
        },
        wrapIframe: function(e) {
            e.$iframes.each(function() {
                $(this).wrap("<div class=\"" + e.iframeWrapperClass + "\"></div>"), this.src = this.src
            })
        }
    }, window.slate = window.slate || {}, slate.a11y = {
        pageLinkFocus: function(e) {
            e.first().attr("tabIndex", "-1").focus().addClass("js-focus-hidden").one("blur", function() {
                e.first().removeClass("js-focus-hidden").removeAttr("tabindex")
            })
        },
        focusHash: function() {
            var e = window.location.hash;
            e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e))
        },
        bindInPageLinks: function() {
            $("a[href*=#]").on("click", function(e) {
                this.pageLinkFocus($(e.currentTarget.hash))
            }.bind(this))
        },
        trapFocus: function(e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr("tabindex", "-1"), e.$elementToFocus.focus(), $(document).off("focusin"), $(document).on(t, function(t) {
                e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus()
            })
        },
        removeTrapFocus: function(e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t)
        }
    }, theme.Images = function() {
        return {
            preload: function(e, t) {
                "string" == typeof e && (e = [e]);
                for (var a, s = 0; s < e.length; s++) a = e[s], this.loadImage(this.getSizedImageUrl(a, t))
            },
            loadImage: function(e) {
                new Image().src = e
            },
            switchImage: function(e, t, a) {
                var s = this.imageSize(t.src),
                    o = this.getSizedImageUrl(e.src, s);
                a ? a(o, e, t) : t.src = o
            },
            imageSize: function(e) {
                var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
                return null === t ? null : void 0 === t[2] ? t[1] : t[1] + t[2]
            },
            getSizedImageUrl: function(e, t) {
                if (null === t) return e;
                if ("master" === t) return this.removeProtocol(e);
                var a = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null !== a) {
                    var s = e.split(a[0]),
                        o = a[0];
                    return this.removeProtocol(s[0] + "_" + t + o)
                }
                return null
            },
            removeProtocol: function(e) {
                return e.replace(/http(s)?:/, "")
            }
        }
    }(), theme.Currency = function() {
        return {
            formatMoney: function(e, t) {
                function a(e, t, a, s) {
                    if (a = a || ",", s = s || ".", isNaN(e) || null === e) return 0;
                    e = (e / 100).toFixed(t);
                    var o = e.split("."),
                        r = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a),
                        n = o[1] ? s + o[1] : "";
                    return r + n
                }
                "string" == typeof e && (e = e.replace(".", ""));
                var s = "",
                    o = /\{\{\s*(\w+)\s*\}\}/,
                    r = t || "${{amount}}";
                switch (r.match(o)[1]) {
                    case "amount":
                        s = a(e, 2);
                        break;
                    case "amount_no_decimals":
                        s = a(e, 0);
                        break;
                    case "amount_with_comma_separator":
                        s = a(e, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        s = a(e, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        s = a(e, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        s = a(e, 2, "'");
                }
                return r.replace(o, s)
            }
        }
    }(), slate.Variants = function() {
        function e(e) {
            this.$container = e.$container, this.product = e.product, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentVariant = this._getVariantFromOptions(), $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _getCurrentOptions: function() {
                var e = _.map($(this.singleOptionSelector, this.$container), function(e) {
                    var t = $(e),
                        a = t.attr("type"),
                        s = {};
                    return "radio" === a || "checkbox" === a ? !!t[0].checked && (s.value = t.val(), s.index = t.data("index"), s) : (s.value = t.val(), s.index = t.data("index"), s)
                });
                return e = _.compact(e), e
            },
            _getVariantFromOptions: function() {
                var e = this._getCurrentOptions(),
                    t = this.product.variants,
                    a = _.find(t, function(t) {
                        return e.every(function(e) {
                            return _.isEqual(t[e.index], e.value)
                        })
                    });
                return a
            },
            _onSelectChange: function() {
                var e = this._getVariantFromOptions();
                this.$container.trigger({
                    type: "variantChange",
                    variant: e
                }), e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), this.currentVariant = e, this.enableHistoryState && this._updateHistoryState(e))
            },
            _updateImages: function(e) {
                var t = e.featured_image || {},
                    a = this.currentVariant.featured_image || {};
                e.featured_image && t.src !== a.src && this.$container.trigger({
                    type: "variantImageChange",
                    variant: e
                })
            },
            _updatePrice: function(e) {
                e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.$container.trigger({
                    type: "variantPriceChange",
                    variant: e
                })
            },
            _updateSKU: function(e) {
                e.sku === this.currentVariant.sku || this.$container.trigger({
                    type: "variantSKUChange",
                    variant: e
                })
            },
            _updateHistoryState: function(e) {
                if (history.replaceState && e) {
                    var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                    window.history.replaceState({
                        path: t
                    }, "", t)
                }
            },
            _updateMasterSelect: function(e) {
                $('.mainselect').val(e.id)
            }
        }), e
    }(), theme.Drawers = function() {
        function e(e, t, a) {
            return this.nodes = {
                $parent: $("html").add("body"),
                $page: $("#PageContainer")
            }, this.config = $.extend({
                close: ".js-drawer-close",
                open: ".js-drawer-open-" + t,
                openClass: "js-drawer-open",
                dirOpenClass: "js-drawer-open-" + t
            }, a), this.position = t, this.$drawer = $("#" + e), !!this.$drawer.length && void(this.drawerIsOpen = !1, this.init())
        }
        return e.prototype.init = function() {
            $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this))
        }, e.prototype.open = function(e) {
            var t = !1;
            return (e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.$activeSource = $(e.currentTarget)), this.drawerIsOpen && !t) ? this.close() : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass), this.drawerIsOpen = !0, slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && !t && this.config.onDrawerOpen(), this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"), this.bindEvents(), this)
        }, e.prototype.close = function() {
            this.drawerIsOpen && ($(document.activeElement).trigger("blur"), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass), this.drawerIsOpen = !1, slate.a11y.removeTrapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }), this.unbindEvents())
        }, e.prototype.bindEvents = function() {
            this.nodes.$parent.on("keyup.drawer", $.proxy(function(e) {
                return 27 !== e.keyCode || (this.close(), !1)
            }, this)), this.nodes.$page.on("touchmove.drawer", function() {
                return !1
            }), this.nodes.$page.on("click.drawer", $.proxy(function() {
                return this.close(), !1
            }, this))
        }, e.prototype.unbindEvents = function() {
            this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer")
        }, e
    }(), theme.Helpers = function() {
        function e() {
            return t
        }
        var t = !1;
        return {
            setTouch: function() {
                t = !0
            },
            isTouch: e
        }
    }(), theme.LibraryLoader = function() {
        function e(e, t) {
            var a = document.createElement("script");
            return a.src = e.src, a.addEventListener("load", function() {
                e.status = s.loaded, t()
            }), a
        }

        function t(e, t) {
            var a = document.createElement("link");
            return a.href = e.src, a.rel = "stylesheet", a.type = "text/css", a.addEventListener("load", function() {
                e.status = s.loaded, t()
            }), a
        }
        var a = {
                link: "link",
                script: "script"
            },
            s = {
                requested: "requested",
                loaded: "loaded"
            },
            o = "https://cdn.shopify.com/shopifycloud/",
            r = {
                youtubeSdk: {
                    tagId: "youtube-sdk",
                    src: "https://www.youtube.com/iframe_api",
                    type: a.script
                },
                plyrShopifyStyles: {
                    tagId: "plyr-shopify-styles",
                    src: o + "shopify-plyr/v1.0/shopify-plyr.css",
                    type: a.link
                },
                modelViewerUiStyles: {
                    tagId: "shopify-model-viewer-ui-styles",
                    src: o + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                    type: a.link
                }
            };
        return {
            load: function(o, n) {
                var d = r[o];
                if (d && d.status !== s.requested) {
                    if (n = n || function() {}, d.status === s.loaded) return void n();
                    d.status = s.requested;
                    var l;
                    switch (d.type) {
                        case a.script:
                            l = e(d, n);
                            break;
                        case a.link:
                            l = t(d, n);
                    }
                    l.id = d.tagId, d.element = l;
                    var c = document.getElementsByTagName(d.type)[0];
                    c.parentNode.insertBefore(l, c)
                }
            }
        }
    }(), theme.Search = function() {
        function e() {
            $(s.searchAjax).each(function() {
                var e = $(this),
                    t = e.find(s.searchInput),
                    a = null,
                    r = e.data("limit"),
                    n = e.data("featured"),
                    d = e.data("featured_limit");
                t.off("keyup"), t.on("keyup", function() {
                    clearTimeout(a), a = setTimeout(function() {
                        var a = t.val();
                        if (!(1 < a.length)) $(s.searchResults).empty();
                        else if (a in o) {
                            var l = o[a];
                            $(s.searchResults).html(l.html), $(l.html).find(".not__found").length && !$(l.html).find(".featured_title").length ? e.closest(s.searchScreen).removeClass("searching") : e.closest(s.searchScreen).addClass("searching")
                        } else {
                            $(s.searchResults).empty();
                            $.ajax({
                                url: "/search",
                                data: {
                                    view: "search",
                                    type: "product",
                                    searched_limit: r,
                                    featured: n,
                                    featured_limit: d,
                                    q: "*" + a + "*",
                                    cache: !1
                                },
                                dataType: "html",
                                type: "GET",
                                beforeSend: function() {
                                    e.addClass("loading").addClass("searching")
                                },
                                complete: function() {
                                    e.removeClass("loading")
                                },
                                success: function(t) {
                                    setTimeout(function() {
                                        $(s.searchResults).html(t), $(t).find(".not__found").length && !$(t).find(".featured_title").length ? e.closest(s.searchScreen).removeClass("searching") : e.closest(s.searchScreen).addClass("searching"), o[a] = {
                                            found: !0,
                                            html: t
                                        }
                                    }, 650)
                                }
                            })
                        }
                    }, 500)
                }), e.removeClass("no-js")
            })
        }

        function t(e) {
            if ("undefined" == typeof $.fn.typed) return !1;
            var t = "^800 " + $(".search__label-text", e).data("typedtext"),
                a = $(".search__label-text", e).data("typedtext_2");
            $(".search__label-text", e).typed({
                strings: [t, a],
                typeSpeed: 30,
                backSpeed: 20
            }), $(".search__label", e).on("click", function() {
                $(this).fadeOut(200, function() {
                    $(this).addClass("hide")
                }), $(s.searchInput, e).focus()
            })
        }

        function a() {
            $(document).off("click", s.searchToggle), $(document).on("click", s.searchToggle, function(e) {
                e.preventDefault();
                var a = $("body"),
                    o = $(this).closest(".header__search"),
                    r = $(".search__label-text", o);
                o.hasClass("opened") ? (a.removeClass("search-opened"), o.removeClass("opened")) : (a.addClass("search-opened"), o.addClass("opened"), $(s.searchInput, o).val(""), $(s.searchResults, o).empty(), $(s.searchInput, o).focus()), r.length && "0" == r.attr("data-first_time") && (r.attr("data-first_time", "1"), t(o))
            }), $(document).keyup(function(e) {
                if (27 == e.keyCode) {
                    var t = $(s.search);
                    t.hasClass("opened") && ($("body").removeClass("search-opened"), t.removeClass("opened"))
                }
            }), $(document).mouseup(function(e) {
                var t = $(s.searchToggle),
                    a = $(s.searchScreen);
                if (!t.is(e.target) && 0 === t.has(e.target).length && !a.is(e.target) && 0 === a.has(e.target).length) {
                    var o = $(s.search);
                    o.hasClass("opened") && ($("body").removeClass("search-opened"), o.removeClass("opened"))
                }
            })
        }
        var s = {
                search: ".header__search, .mobile-header__search",
                searchInput: ".search__input",
                searchToggle: ".search__toggle",
                searchScreen: ".search__fullscreen",
                searchAjax: ".search__ajax.no-js",
                searchResults: ".search__results"
            },
            o = {};
        return {
            init: function() {
                $(s.search).length && (e(), a())
            }
        }
    }(), theme.CurrencyPicker = function() {
        var e = {
            container: ".currency__picker",
            currency: ".currency__picker .ml__switcher .currency:not(.active)"
        };
        return {
            init: function() {
                $(e.container).length && ($(e.currency).off("click"), $(e.currency).on("click", function(e) {
                    e.preventDefault();
                    var t = $(this).data("iso_code"),
                        a = $(this).closest("form");
                    a.find("[data-iso_code-input]").val(t), a.submit()
                }))
            },
            formatMoney: function(e) {
                var t = theme.Currency.formatMoney(e, theme.settings.moneyFormat);
                return t = t.replace(theme.settings.currencySymbol, ""), "<span class=\"money\"><span class=\"currency_symbol\">" + theme.settings.currencySymbol + "</span>" + t + "</span>"
            }
        }
    }(), theme.LanguagePicker = function() {
        var e = {
            container: ".language__picker",
            language: ".language__picker .ml__switcher .locale:not(.active)"
        };
        return {
            init: function() {
                $(e.container).length && ($(e.language).off("click"), $(e.language).on("click", function(e) {
                    e.preventDefault();
                    var t = $(this).data("iso_code"),
                        a = $(this).closest("form");
                    a.find("[data-iso_code-input]").val(t), a.submit()
                }))
            }
        }
    }(), theme.MiniCart = function() {
        function e(e) {
            return "undefined" == typeof e && (e = 0), $(d.miniCart).addClass("loading"), $.get("/search", function(t) {
                if ($(d.miniCart).each(function() {
                        var e = $(this),
                            a = "";
                        e.hasClass("minicart-frame") ? a = ".minicart-frame" : e.hasClass("minicart-sidebar") && (a = ".minicart-sidebar");
                        var s = $(t).find(d.miniCart + a);
                        e.removeClass("loading").html(s.html());
                        var o = e.prev();
                        o.html(s.prev().html()), o.addClass("anim"), setTimeout(function() {
                            o.removeClass("anim")
                        }, 2e3)
                    }), 0 < e) {
                    var a = ".product__" + e;
                    $(a + " .addcart_btn").removeClass("added")
                }
            })
        }

        function t() {
            $(document).off("click", d.headerCart), $(document).on("click", d.headerCart, function(e) {
                var t = $(this),
                    a = t.parent().find(d.miniCart);
                a.length && a.hasClass("minicart-sidebar") && ($(d.miniCart).each(function() {
                    a.attr("id") != $(this).attr("id") && $(this).removeClass("opened")
                }), a.hasClass("opened") ? a.removeClass("opened") : (a.addClass("opened"), $("body").addClass("cart-opened"), theme.MiniCart.anim()), e.preventDefault())
            })
        }

        function a() {
            $(document).off("change", d.miniCartAgree), $(document).on("change", d.miniCartAgree, function() {
                var e = $(this);
                e.is(":checked") ? ($(d.miniCartAgree).prop("checked", !0), $(d.miniCartCheckout).removeClass("btn-disabled")) : ($(d.miniCartAgree).prop("checked", !1), $(d.miniCartCheckout).addClass("btn-disabled"))
            }), $(document).off("click", d.miniCartCheckout), $(document).on("click", d.miniCartCheckout, function(e) {
                if ($(d.miniCartAgree).length) {
                    var t = $(d.miniCartAgree);
                    if (!t.is(":checked")) {
                        var a = t.data("message");
                        alert(a), e.preventDefault()
                    }
                }
            })
        }

        function s() {
            $(document).off("click", d.miniCartRemove), $(document).on("click", d.miniCartRemove, function(t) {
                t.preventDefault();
                var a = $(this),
                    s = a.attr("href"),
                    o = a.data("product_id");
                $(d.miniCart).addClass("loading"), $.post(s, function() {
                    e(o)
                })
            })
        }

        function o() {
            $(document).off("click", d.miniCartClose), $(document).on("click", d.miniCartClose, function() {
                $(d.miniCart).removeClass("loading").removeClass("opened"), $("body").removeClass("cart-opened")
            })
        }

        function r(t, a) {
            $.ajax({
                type: "POST",
                url: "/cart/update.js",
                async: !0,
                cache: !1,
                data: a.serialize(),
                dataType: "json",
                beforeSend: function() {
                    t.addClass("loading")
                },
                success: function() {
                    e()
                }
            })
        }

        function n() {
            $(document).off("click", d.miniCartQty + " .plus"), $(document).on("click", d.miniCartQty + " .plus", function() {
                var e = $(this).parent(),
                    t = e.find(".qty"),
                    a = parseInt(t.val());
              	var max=e.find(".qty").attr('max');
              	console.log(max+"sasas");
                if(a>=max){
                   alert('No more product in stock at the moment!!');
                }else{
                  ++a, t.val(a).trigger("change")
                }
            }), $(document).off("click", d.miniCartQty + " .minus"), $(document).on("click", d.miniCartQty + " .minus", function() {
                var e = $(this).parent(),
                    t = e.find(".qty"),
                    a = parseInt(t.val());
                1 < a && (--a, t.val(a).trigger("change"))
            }), $(document).off("change", d.miniCartQty + " .qty"), $(document).on("change", d.miniCartQty + " .qty", function() {
                var e = $(this).closest("form"),
                    t = $(this).closest(".minicart");
                r(t, e)
            })
        }
        var d = {
            headerSticky: ".header-sticky__placeholder",
            headerCart: ".header__cart .cart__link",
            miniCart: ".minicart",
            miniCartAgree: ".minicart .cart__agree",
            miniCartCheckout: ".minicart .btn-checkout",
            miniCartRemove: ".minicart .item__remove",
            miniCartClose: ".minicart .cart__close, .minicart__overlay",
            miniCartQty: ".minicart .item__qty"
        };
        return {
            init: function() {
                t(), a(), s(), o(), n()
            },
            update: e,
            open: function() {
                if ($(d.miniCart).length) {
                    if ($(d.headerSticky).length && $(d.headerSticky).hasClass("stick")) {
                        var e = $(d.headerSticky).find(d.headerCart);
                        if (e.length) {
                            var t = e.closest(".header__cart").find(d.miniCart);
                            if (t.length && t.hasClass("minicart-sidebar") && !t.hasClass("opened")) return e.trigger("click"), !1
                        }
                    }
                    $(d.headerCart).each(function() {
                        var e = $(this);
                        if (e.is(":visible")) {
                            var t = e.closest(".header__cart").find(d.miniCart);
                            if (t.length && t.hasClass("minicart-sidebar") && !t.hasClass("opened")) return e.trigger("click"), !1
                        }
                    })
                }
            },
            anim: function() {
                var e = new TimelineLite,
                    t = $(".minicart .cart__content"),
                    a = $(".minicart .cart__item"),
                    s = $(".minicart .cart__total"),
                    o = $(".minicart .cart__free-shipping"),
                    r = $(".minicart .cart__actions"),
                    n = $(".minicart .cart__empty"),
                    d = $(".minicart .cart__return");
                theme.settings.rtl ? (e.fromTo(t, .5, {
                    autoAlpha: 0
                }, {
                    autoAlpha: 1,
                    ease: Power4.easeIn
                }, .1), e.staggerFromTo(a, .5, {
                    opacity: 0,
                    skewX: -20,
                    x: -60
                }, {
                    opacity: 1,
                    skewX: 0,
                    x: 0
                }, .1, .2), e.fromTo(s, .8, {
                    opacity: 0,
                    x: -80
                }, {
                    opacity: 1,
                    x: 0
                }, .2), e.fromTo(o, .8, {
                    opacity: 0,
                    x: -80
                }, {
                    opacity: 1,
                    x: 0
                }, .3), e.fromTo(r, .8, {
                    opacity: 0,
                    x: -80
                }, {
                    opacity: 1,
                    x: 0
                }, .4), e.fromTo(n, .8, {
                    opacity: 0,
                    x: -80
                }, {
                    opacity: 1,
                    x: 0
                }, .2), e.fromTo(d, .8, {
                    opacity: 0,
                    x: -80
                }, {
                    opacity: 1,
                    x: 0
                }, .3)) : (e.fromTo(t, .5, {
                    autoAlpha: 0
                }, {
                    autoAlpha: 1,
                    ease: Power4.easeIn
                }, .1), e.staggerFromTo(a, .5, {
                    opacity: 0,
                    skewX: 20,
                    x: 60
                }, {
                    opacity: 1,
                    skewX: 0,
                    x: 0
                }, .1, .2), e.fromTo(s, .8, {
                    opacity: 0,
                    x: 80
                }, {
                    opacity: 1,
                    x: 0
                }, .2), e.fromTo(o, .8, {
                    opacity: 0,
                    x: 80
                }, {
                    opacity: 1,
                    x: 0
                }, .3), e.fromTo(r, .8, {
                    opacity: 0,
                    x: 80
                }, {
                    opacity: 1,
                    x: 0
                }, .4), e.fromTo(n, .8, {
                    opacity: 0,
                    x: 80
                }, {
                    opacity: 1,
                    x: 0
                }, .2), e.fromTo(d, .8, {
                    opacity: 0,
                    x: 80
                }, {
                    opacity: 1,
                    x: 0
                }, .3))
            }
        }
    }(),
    function() {
        function e(e) {
            var t = document.createElement("a");
            return t.ref = e, t.hostname
        }
        var t = $({
            backButton: ".return-link"
        }.backButton);
        document.referrer && t.length && window.history.length && t.one("click", function(t) {
            t.preventDefault();
            var a = e(document.referrer),
                s = e(window.location.href);
            return s === a && history.back(), !1
        })
    }(), theme.SlideshowSection = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = this.sectionId = t.attr("data-section-id"),
                s = this.slideshow = "#Slideshow-" + a;
            $(".slideshow__video", s).each(function() {
                var e = $(this);
                theme.SlideshowVideo.init(e), theme.SlideshowVideo.loadVideo(e.attr("id"))
            }), this.beforeInit(s), this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            beforeInit: function(e) {
                var t = .01 * window.innerHeight;
                document.documentElement.style.setProperty("--vh", t + "px"), window.addEventListener("resize", function() {
                    var t = .01 * window.innerHeight;
                    if (document.documentElement.style.setProperty("--vh", t + "px"), $(e).hasClass("slideshow--auto") && 0 < $(e).find(".slideshow__slide.is-selected .slideshow__image_tag").length) {
                        var a = $(e).find(".slideshow__slide.is-selected .slideshow__image_tag").height();
                        $(e).find(".flickity-viewport").css("height", a + "px")
                    }
                })
            },
            init: function() {
                var e = this,
                    t = $(e.slideshow),
                    a = t.data("autoplay"),
                    s = t.data("speed"),
                    o = t.find(".slideshow__image"),
                    r = new Flickity(e.slideshow, {
                        rightToLeft: theme.settings.rtl,
                        bgLazyLoad: 1,
                        imagesLoaded: !0,
                        accessibility: !0,
                        prevNextButtons: !0,
                        pageDots: !0,
                        contain: !0,
                        wrapAround: !0,
                        setGallerySize: !1,
                        autoPlay: !!a && s,
                        arrowShape: {
                            x0: 10,
                            x1: 60,
                            y1: 50,
                            x2: 60,
                            y2: 45,
                            x3: 15
                        },
                        on: {
                            ready: function() {
                                if (t.hasClass("slideshow--auto") && 0 < t.find(".slideshow__slide.is-selected .slideshow__image_tag").length) {
                                    var e = t.find(".slideshow__slide.is-selected .slideshow__image_tag").height();
                                    t.find(".flickity-viewport").css("height", e + "px")
                                }
                                if (theme.settings.animation) {
                                    var a = new TimelineLite,
                                        s = t.find(".flickity-slider"),
                                        o = t.find(".slider-content-wrapper"),
                                        r = t.find(".flickity-button svg"),
                                        n = t.find(".flickity-page-dots");
                                    a.fromTo(s, 2, {
                                        scale: 1.2
                                    }, {
                                        ease: Power4.easeInOut,
                                        scale: 1
                                    }, 0), a.fromTo(o, 2.4, {
                                        opacity: 0
                                    }, {
                                        ease: Power4.easeInOut,
                                        opacity: 1
                                    }, 1), a.fromTo([r, n], 2, {
                                        opacity: 0
                                    }, {
                                        ease: Power4.easeInOut,
                                        opacity: 1
                                    }, 1.3)
                                }
                            },
                            change: function(e) {
                                if (0 < $(t.find(".slideshow__slide")[e]).length) {
                                    var a = $(t.find(".slideshow__slide")[e]).find(".slideshow__image_tag").height();
                                    t.find(".flickity-viewport").css("height", a + "px")
                                }
                                if ($(t.find(".slideshow__slide")[e]).hasClass("slideshow__video_background")) {
                                    var s = "SlideshowVideo-" + $(t.find(".slideshow__slide")[e]).data("block_id");
                                    0 < $("#" + s).length && theme.SlideshowVideo.playVideo(s)
                                } else 0 < t.find(".slideshow__video_item").length && t.find(".slideshow__video_item").each(function() {
                                    var e = "SlideshowVideo-" + $(this).data("block_id");
                                    0 < $("#" + e).length && theme.SlideshowVideo.pauseVideo(e)
                                })
                            }
                        }
                    });
                r.on("scroll", function() {
                    r.slides.forEach(function(e, t) {
                        var a = o[t],
                            s = 0;
                        a && (s = 0 === t ? Math.abs(r.x) > r.slidesWidth ? r.slidesWidth + r.x + r.slides[r.slides.length - 1].outerWidth + e.target : e.target + r.x : t === r.slides.length - 1 ? Math.abs(r.x) + r.slides[t].outerWidth < r.slidesWidth ? e.target - r.slidesWidth + r.x - r.slides[t].outerWidth : e.target + r.x : e.target + r.x, "undefined" != typeof window.mobileCheck && !window.mobileCheck() && !theme.settings.rtl && (a.style.transform = "translateX(" + s * (-1 / 2) + "px)"))
                    })
                })
            },
            onSelect: function() {
                "undefined" != typeof theme.roarAdminJs && theme.roarAdminJs.refresh()
            }
        }), e
    }(), theme.Slideshow = function() {
        function e(e) {
            this.$slideshow = $(e), this.$wrapper = this.$slideshow.closest("." + n.wrapper), this.$pause = this.$wrapper.find("." + n.pauseButton);
            var t = this.$slideshow.data("arrows") || !1,
                a = this.$slideshow.data("dots") || !1,
                s = this.$slideshow.data("autoplay") || !1,
                o = parseInt(this.$slideshow.data("speed")) || 7e3,
                r = parseInt(this.$slideshow.data("per_view")) || 1;
            this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 768px)",
                mediaQuerySmall: "screen and (max-width: 767px)",
                arrows: t,
                dots: a,
                autoplay: s,
                speed: o,
                per_view: r,
                sliderImagesActive: !1
            }, this.initBreakpoints()
        }

        function t(e, t) {
            var a = t.$slider,
                s = t.$list,
                o = this.$wrapper,
                r = this.settings.autoplay;
            s.removeAttr("aria-live"), o.on("focusin", function(e) {
                o.has(e.target).length && (s.attr("aria-live", "polite"), r && a.slick("slickPause"))
            }), o.on("focusout", function(e) {
                if (o.has(e.target).length && (s.removeAttr("aria-live"), r)) {
                    if ($(e.target).hasClass(n.closeVideoBtn)) return;
                    a.slick("slickPlay")
                }
            }), t.$dots && t.$dots.on("keydown", function(e) {
                37 === e.which && a.slick("slickPrev"), 39 === e.which && a.slick("slickNext"), (37 === e.which || 39 === e.which) && t.$dots.find(".slick-active button").focus()
            }), a.find("." + n.currentSlide).addClass("slick-anim");
            var d = new TimelineLite,
                l = a.find(".slideshow__text-text"),
                c = a.find(".slick-arrow svg"),
                p = a.find(".slick-dots");
            d.fromTo(a, 2, {
                scale: 1.2
            }, {
                ease: Power4.easeInOut,
                scale: 1
            }, 0), d.fromTo(l, 2.4, {
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                opacity: 1
            }, 1), d.fromTo([c, p], 2, {
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                opacity: 1
            }, 1.3)
        }

        function a(e, t, a, s, r) {
            var d = t.$slider,
                l = d.find("." + n.currentSlide),
                c = d.find(".slick-slide[data-slick-index=\"" + s + "\"]");
            if (o(l)) {
                var p = l.find("." + n.video),
                    u = p.attr("id");
                theme.SlideshowVideo.pauseVideo(u), p.attr("tabindex", "-1")
            }
            if (o(c)) {
                var g = c.find("." + n.video),
                    m = g.attr("id"),
                    h = g.hasClass(n.videoBackground);
                h ? theme.SlideshowVideo.playVideo(m) : g.attr("tabindex", "0")
            }
            l.removeClass("slick-anim"), d.find(".slick-slide[data-slick-index=\"" + r + "\"]").addClass("slick-anim"), d.find(".slick-arrow").addClass("disabled")
        }

        function s(e, t) {
            t.$slider.find(".slick-arrow").removeClass("disabled")
        }

        function o(e) {
            return e.find("." + n.video).length
        }

        function r(e) {
            return "#Slideshow-" + e.data("id")
        }
        this.$slideshow = null;
        var n = {
            wrapper: "slideshow-wrapper",
            slideshow: "slideshow",
            currentSlide: "slick-current",
            video: "slideshow__video",
            videoBackground: "slideshow__video--background",
            closeVideoBtn: "slideshow__video-control--close",
            pauseButton: "slideshow__pause",
            isPaused: "is-paused"
        };
        return e.prototype = _.assignIn({}, e.prototype, {
            initBreakpoints: function() {
                var e = this;
                enquire.register(e.settings.mediaQuerySmall, {
                    match: function() {
                        e.settings.sliderImagesActive && e.destroyImageSlider(), e.initImageSlider()
                    }
                }), enquire.register(e.settings.mediaQueryMediumUp, {
                    match: function() {
                        e.settings.sliderImagesActive && e.destroyImageSlider(), e.initImageSlider(!1)
                    }
                })
            },
            destroyImageSlider: function() {
                $(this.$slideshow).slick("unslick"), this.settings.sliderImagesActive = !1
            },
            initImageSlider: function(e) {
                "undefined" == typeof e && (e = !0);
                var o = {
                    rtl: theme.settings.rtl,
                    accessibility: !0,
                    arrows: this.settings.arrows,
                    dots: this.settings.dots,
                    fade: !this.settings.per_view,
                    speed: 1e3,
                    delay: 1600,
                    draggable: !0,
                    autoplay: this.settings.autoplay,
                    autoplaySpeed: this.settings.speed,
                    slidesToShow: this.settings.per_view,
                    slidesToScroll: 1,
                    prevArrow: "<button class=\"slick-prev\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-prev\"></use></svg></button>",
                    nextArrow: "<button class=\"slick-next\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-next\"></use></svg></button>"
                };
                !0 == e && (o.fade = !1, o.draggable = !0, o.slidesToShow = 1, o.arrows = !1, o.dots = !0), this.$slideshow.on("beforeChange", a.bind(this)), this.$slideshow.on("afterChange", s.bind(this)), this.$slideshow.on("init", t.bind(this)), this.$slideshow.slick(o), this.$pause.on("click", this.togglePause.bind(this)), this.settings.sliderImagesActive = !0
            },
            togglePause: function() {
                var e = r(this.$pause);
                this.$pause.hasClass(n.isPaused) ? (this.$pause.removeClass(n.isPaused), $(e).slick("slickPlay")) : (this.$pause.addClass(n.isPaused), $(e).slick("slickPause"))
            }
        }), e
    }();

function onYouTubeIframeAPIReady() {
    theme.SlideshowVideo.loadVideos(), theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube)
}
theme.SlideshowVideo = function() {
        function e(e) {
            if (e.length && (T[e.attr("id")] = {
                    id: e.attr("id"),
                    videoId: e.data("id"),
                    type: e.data("type"),
                    status: "chrome" === e.data("type") ? "closed" : "background",
                    videoSelector: e.attr("id"),
                    $parentSlide: e.closest("." + P.slide),
                    $parentSlideshowWrapper: e.closest("." + P.slideshowWrapper),
                    controls: "background" === e.data("type") ? 0 : 1,
                    slideshow: e.data("slideshow")
                }, !S)) {
                var t = document.createElement("script");
                t.src = "https://www.youtube.com/iframe_api";
                var a = document.getElementsByTagName("script")[0];
                a.parentNode.insertBefore(t, a)
            }
        }

        function t(e) {
            (w || x) && (!e || "function" != typeof I[e].playVideo || s(e))
        }

        function a(e) {
            if (S) {
                var t = $.extend({}, A, T[e]);
                t.playerVars.controls = t.controls, I[e] = new YT.Player(e, t), b()
            }
        }

        function s(e, t) {
            var a = T[e],
                s = I[e],
                o = T[e].$parentSlide;
            if (x) c(a);
            else if (t || C && k) return o.removeClass(P.loading), c(a), void s.playVideo();
            C || r(s, o)
        }

        function o(e) {
            var t = e ? P.supportsAutoplay : P.supportsNoAutoplay;
            $(document.documentElement).addClass(t), e || (x = !0), C = !0
        }

        function r(e, t) {
            e.playVideo(), n(e).then(function() {
                o(!0)
            }).fail(function() {
                o(!1), e.stopVideo()
            }).always(function() {
                C = !0, t.removeClass(P.loading)
            })
        }

        function n(e) {
            var t, a, s = $.Deferred();
            return t = setInterval(function() {
                0 >= e.getCurrentTime() || (k = !0, clearInterval(t), clearTimeout(a), s.resolve())
            }, 500), a = setTimeout(function() {
                clearInterval(t), s.reject()
            }, 4e3), s
        }

        function d() {
            w || (750 > $(window).width() ? x = !0 : "undefined" != typeof window.mobileCheck && window.mobileCheck() && (x = !0), x && o(!1), w = !0)
        }

        function l(e) {
            switch (e.type) {
                case "background":
                    I[e.id].seekTo(0);
                    break;
                case "background-chrome":
                    I[e.id].seekTo(0), u(e.id);
                    break;
                case "chrome":
                    u(e.id);
            }
        }

        function c(e) {
            var t = e.$parentSlideshowWrapper,
                a = e.$parentSlide;
            if (a.removeClass(P.loading), "background" !== e.status) {
                switch ($("#" + e.id).attr("tabindex", "0"), e.type) {
                    case "chrome":
                    case "background-chrome":
                        t.removeClass(P.paused).addClass(P.playing), a.removeClass(P.paused).addClass(P.playing);
                }
                a.find("." + P.closeVideoBtn).focus()
            }
        }

        function p(e) {
            var t = e.$parentSlideshowWrapper,
                a = e.$parentSlide;
            return "background-chrome" === e.type ? void u(e.id) : void("closed" !== e.status && "background" !== e.type && (t.addClass(P.paused), a.addClass(P.paused)), "chrome" === e.type && "closed" === e.status && (t.removeClass(P.paused), a.removeClass(P.paused)), t.removeClass(P.playing), a.removeClass(P.playing))
        }

        function u(e) {
            var t = T[e],
                a = t.$parentSlideshowWrapper,
                s = t.$parentSlide,
                o = [P.pause, P.playing].join(" ");
            switch ($("#" + t.id).attr("tabindex", "-1"), t.status = "closed", t.type) {
                case "background-chrome":
                    I[e].mute(), v(e);
                    break;
                case "chrome":
                    I[e].stopVideo(), p(t);
            }
            a.removeClass(o), s.removeClass(o)
        }

        function g(e) {
            var t = e.target.getIframe().id;
            return T[t]
        }

        function m(e) {
            var t = T[e];
            switch (t.$parentSlide.addClass(P.loading), t.status = "open", t.type) {
                case "background-chrome":
                    y(e, t), I[e].unMute(), s(e, !0);
                    break;
                case "chrome":
                    s(e, !0);
            }
            $(document).on("keydown.videoPlayer", function(t) {
                27 === t.keyCode && u(e)
            })
        }

        function h() {
            $("." + P.videoBackground).each(function(e, t) {
                f($(t))
            })
        }

        function f(e) {
            var t = e.closest("." + P.slide);
            if (!t.hasClass(P.slickClone)) {
                var a = t.width(),
                    s = e.width(),
                    o = e.height();
                a / A.ratio < o ? (s = Math.ceil(o * A.ratio), e.width(s).height(o).css({
                    left: (a - s) / 2,
                    top: 0
                })) : (o = Math.ceil(a / A.ratio), e.width(a).height(o).css({
                    left: 0,
                    top: (o - o) / 2
                })), e.prepareTransition().addClass(P.loaded)
            }
        }

        function y(e) {
            $("#" + e).removeAttr("style").removeClass(P.videoBackground).addClass(P.videoChrome), T[e].$parentSlideshowWrapper.removeClass(P.slideBackgroundVideo).addClass(P.playing), T[e].$parentSlide.removeClass(P.slideBackgroundVideo).addClass(P.playing), T[e].status = "open"
        }

        function v(e) {
            var t = $("#" + e).addClass(P.videoBackground).removeClass(P.videoChrome);
            T[e].$parentSlide.addClass(P.slideBackgroundVideo), T[e].status = "background", f(t)
        }

        function b() {
            $(document).on("click.videoPlayer", "." + P.playVideoBtn, function(e) {
                var t = $(e.currentTarget).data("controls");
                m(t)
            }), $(document).on("click.videoPlayer", "." + P.closeVideoBtn, function(e) {
                var t = $(e.currentTarget).data("controls");
                u(t)
            }), $(window).on("resize.videoPlayer", $.debounce(250, function() {
                S && h()
            }))
        }
        var C = !1,
            k = !1,
            w = !1,
            x = !1,
            S = !1,
            T = {},
            I = [],
            A = {
                ratio: 16 / 9,
                playerVars: {
                    iv_load_policy: 3,
                    modestbranding: 1,
                    autoplay: 0,
                    controls: 0,
                    showinfo: 0,
                    wmode: "opaque",
                    branding: 0,
                    autohide: 0,
                    rel: 0
                },
                events: {
                    onReady: function(e) {
                        e.target.setPlaybackQuality("hd1080");
                        var t = g(e);
                        switch (d(), $("#" + t.id).attr("tabindex", "-1"), h(), t.type) {
                            case "background-chrome":
                            case "background":
                                e.target.mute(), t.$parentSlide.closest("." + P.slickSlide).hasClass(P.currentSlide) && s(t.id);
                        }
                        t.$parentSlide.addClass(P.loaded)
                    },
                    onStateChange: function(e) {
                        var t = g(e);
                        switch (e.data) {
                            case 0:
                                l(t);
                                break;
                            case 1:
                                c(t);
                                break;
                            case 2:
                                p(t);
                        }
                    }
                }
            },
            P = {
                playing: "video-is-playing",
                paused: "video-is-paused",
                loading: "video-is-loading",
                loaded: "video-is-loaded",
                slideshowWrapper: "slideshow-wrapper",
                slide: "slideshow__slide",
                slideBackgroundVideo: "slideshow__slide--background-video",
                slideDots: "slick-dots",
                videoChrome: "slideshow__video--chrome",
                videoBackground: "slideshow__video--background",
                playVideoBtn: "slideshow__video-control--play",
                closeVideoBtn: "slideshow__video-control--close",
                currentSlide: "slick-current",
                slickSlide: "slick-slide",
                slickClone: "slick-cloned",
                supportsAutoplay: "autoplay",
                supportsNoAutoplay: "no-autoplay"
            };
        return {
            init: e,
            loadVideos: function() {
                for (var e in T)
                    if (T.hasOwnProperty(e)) {
                        var t = $.extend({}, A, T[e]);
                        t.playerVars.controls = t.controls, I[e] = new YT.Player(e, t)
                    } b(), S = !0
            },
            loadVideo: a,
            playVideo: t,
            pauseVideo: function(e) {
                I[e] && "function" == typeof I[e].pauseVideo && I[e].pauseVideo()
            },
            removeEvents: function() {
                $(document).off(".videoPlayer"), $(window).off(".videoPlayer")
            }
        }
    }(),
    function() {
        var e = $("#BlogTagFilter");
        e.length && e.on("change", function() {
            location.href = $(this).val()
        })
    }(), window.theme = theme || {}, theme.customerTemplates = function() {
        function e() {
            $(document).off("click", "#RecoverPassword"), $(document).on("click", "#RecoverPassword", function(e) {
                e.preventDefault(), t()
            }), $(document).off("click", "#HideRecoverPasswordLink"), $(document).on("click", "#HideRecoverPasswordLink", function(e) {
                e.preventDefault(), t()
            })
        }

        function t() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide")
        }

        function a() {
            var e = $(".reset-password-success");
            e.length && $("#ResetSuccess").removeClass("hide")
        }

        function s() {
            var e = $("#AddressNewForm");
            e.length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                hideElement: "AddressProvinceContainerNew"
            }), $(".address-country-option").each(function() {
                var e = $(this).data("form-id");
                new Shopify.CountryProvinceSelector("AddressCountry_" + e, "AddressProvince_" + e, {
                    hideElement: "AddressProvinceContainer_" + e
                })
            }), $(".address-new-toggle").on("click", function() {
                e.toggleClass("hide")
            }), $(".address-edit-toggle").on("click", function() {
                var e = $(this).data("form-id");
                $("#EditAddress_" + e).toggleClass("hide")
            }), $(".address-delete").on("click", function() {
                var e = $(this),
                    t = e.data("form-id"),
                    a = e.data("confirm-message");
                confirm(a || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, {
                    parameters: {
                        _method: "delete"
                    }
                })
            }))
        }

        function o() {
            var e = window.location.hash;
            "#recover" === e && t()
        }
        return {
            init: function() {
                o(), e(), a(), s()
            }
        }
    }(), theme.Cart = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                namespace: "#CartSection-" + a,
                sectionId: a
            }, this.selectors = {
                quantity: ".item__qty-" + a,
                agree: "#cart__agree-" + a,
                checkout: ".cart__checkout-" + a + " [name=\"checkout\"], .cart__checkout-" + a + " [name=\"goto_pp\"], .cart__checkout-" + a + " [name=\"goto_gc\"]",
                remove: ".item__remove-" + a,
                update: ".cart__update-" + a
            }, this._qtyCart(), this._checkoutCart(), this._removeCart(), this._updateCart(), this._productsSlider()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _removeCart: function() {
                var e = this;
                $(document).off("click", e.selectors.remove), $(document).on("click", e.selectors.remove, function(t) {
                    t.preventDefault();
                    var a = $(this),
                        s = a.attr("href"),
                        o = $(e.settings.namespace);
                    o.addClass("loading"), $.post(s, function() {
                        $.get("/cart?view=popup", function(t) {
                            o.html($(t).find(e.settings.namespace).html()), setTimeout(function() {
                                o.removeClass("loading"), theme.MiniCart.update();
                                var e = new theme.Sections;
                                e.register("cart-gift-popup", theme.CartGift), e.register("shipping-calculator-popup", theme.ShippingCalculator)
                            }, 100)
                        })
                    })
                })
            },
            _updateCart: function() {
                var e = this;
                $(document).off("click", e.selectors.update), $(document).on("click", e.selectors.update, function(t) {
                    t.preventDefault();
                    var a = $(this).closest("form"),
                        s = $(e.settings.namespace);
                    return $.ajax({
                        type: "POST",
                        url: "/cart/update.js",
                        async: !0,
                        cache: !1,
                        data: a.serialize(),
                        dataType: "json",
                        beforeSend: function() {
                            s.addClass("loading")
                        },
                        success: function() {
                            $.get("/cart?view=popup", function(t) {
                                s.html($(t).find(e.settings.namespace).html()), setTimeout(function() {
                                    s.removeClass("loading"), theme.MiniCart.update();
                                    var e = new theme.Sections;
                                    e.register("cart-gift-popup", theme.CartGift), e.register("shipping-calculator-popup", theme.ShippingCalculator)
                                }, 100)
                            })
                        }
                    }), !1
                })
            },
            _qtyCart: function() {
                var e = this;
                $(document).off("click", e.selectors.quantity + " .plus"), $(document).on("click", e.selectors.quantity + " .plus", function() {
                    var e = $(this).parent(),
                        t = e.find(".qty"),
                        a = parseInt(t.val());
                    ++a, t.val(a)
                }), $(document).off("click", e.selectors.quantity + " .minus"), $(document).on("click", e.selectors.quantity + " .minus", function() {
                    var e = $(this).parent(),
                        t = e.find(".qty"),
                        a = parseInt(t.val());
                    0 < a && (--a, t.val(a))
                })
            },
            _checkoutCart: function() {
                var e = this;
                $(e.selectors.agree).length && ($(document).off("click", e.selectors.checkout), $(document).on("click", e.selectors.checkout, function() {
                    if ($(e.selectors.agree).length) {
                        var t = $(this),
                            a = $(e.selectors.agree);
                        if (a.is(":checked")) t.submit();
                        else {
                            var s = a.data("message");
                            return alert(s), !1
                        }
                    }
                }), $(document).on("change", e.selectors.agree, function() {
                    var t = $(this);
                    t.is(":checked") ? $(e.selectors.checkout).removeClass("btn-disabled") : $(e.selectors.checkout).addClass("btn-disabled")
                }))
            },
            _productsSlider: function() {
                var e = new theme.Sections;
                e.register("products-slider-sub", theme.ProductsSlider)
            },
            _lineItem: function() {
                theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
                var e = new theme.Sections;
                e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer)
            },
            onLoad: function() {
                this._lineItem()
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), e
    }(), theme.ShippingCalculator = function() {
        function ShippingCalculator(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.selectors = {
                shipping_btn: "#cart__shipping-btn-" + a,
                shipping_calculator: "#shipping__calculator-" + a,
                get_rates: "#shipping__calculator-btn-" + a,
                response: "#shipping__calculator-response-" + a,
                template: "<p id =\"shipping-rates-feedback-" + a + "\" class=\"shipping-rates-feedback\"></p>",
                address_country: "address_country-" + a,
                address_province: "address_province-" + a,
                address_zip: "address_zip-" + a,
                address_province_label: "address_province_label-" + a,
                address_province_container: "address_province_container-" + a
            }, this.strings = {
                submitButton: theme.strings.shippingButton,
                submitButtonDisabled: theme.strings.shippingButtonDisabled,
                customerIsLoggedIn: theme.settings.customerIsLoggedIn,
                moneyFormat: theme.settings.moneyFormat
            }, this._init()
        }
        return ShippingCalculator.prototype = _.assignIn({}, ShippingCalculator.prototype, {
            _disableButtons: function() {
                var e = this.selectors,
                    t = this.strings;
                $(e.get_rates).text(t.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled")
            },
            _enableButtons: function() {
                var e = this.selectors,
                    t = this.strings;
                $(e.get_rates).removeAttr("disabled").removeClass("disabled").text(t.submitButton)
            },
            _render: function(e) {
                var t = this.selectors,
                    a = this.strings,
                    s = $(t.template),
                    o = $(t.response);
                if (o.length) {
                    if (!e.success) s.addClass("error"), s.append(e.errorFeedback);
                    else if (s.addClass("success"), e.rates) {
                        s.append(e.rates);
                        var r = e.rates;
                        if (r[0]) {
                            var n = r[0];
                            s.append("Rates start at <span class=\"money\">" + n.price + "</span>.")
                        }
                    } else s.append("We do not ship to this destination.");
                    s.appendTo(o)
                }
            },
            _formatRate: function(e) {
                function t(e, t) {
                    return "undefined" == typeof e ? t : e
                }

                function a(e, a, s, o) {
                    if (a = t(a, 2), s = t(s, ","), o = t(o, "."), isNaN(e) || null == e) return 0;
                    e = (e / 100).toFixed(a);
                    var r = e.split("."),
                        n = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s),
                        d = r[1] ? o + r[1] : "";
                    return n + d
                }
                var s = this.selectors,
                    o = this.strings;
                if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(e, o.moneyFormat);
                "string" == typeof e && (e = e.replace(".", ""));
                var r = "",
                    n = /\{\{\s*(\w+)\s*\}\}/,
                    d = o.moneyFormat;
                switch (d.match(n)[1]) {
                    case "amount":
                        r = a(e, 2);
                        break;
                    case "amount_no_decimals":
                        r = a(e, 0);
                        break;
                    case "amount_with_comma_separator":
                        r = a(e, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        r = a(e, 0, ".", ",");
                }
                return d.replace(n, r)
            },
            _onCartShippingRatesUpdate: function(e, t) {
                var a = this,
                    s = this.selectors,
                    o = this.strings;
                a._enableButtons();
                var r = "";
                if (t.zip && (r += t.zip + ", "), t.province && (r += t.province + ", "), r += t.country, e.length)
                    for (var n = 0; n < e.length; n++) e[n].price = a._formatRate(e[n].price);
                a._render({
                    rates: e,
                    address: r,
                    success: !0
                }), $(s.response).fadeIn()
            },
            _pollForCartShippingRatesForDestination: function(e) {
                var t = this,
                    a = this.selectors,
                    s = this.strings,
                    o = function() {
                        $.ajax("/cart/async_shipping_rates", {
                            dataType: "json",
                            success: function(a, s, r) {
                                200 === r.status ? t._onCartShippingRatesUpdate(a.shipping_rates, e) : setTimeout(o, 500)
                            },
                            error: function(e, a) {
                                t._onError(e, a, t)
                            }
                        })
                    };
                return o
            },
            _fullMessagesFromErrors: function(e) {
                var t = this.selectors,
                    a = this.strings,
                    s = [];
                return $.each(e, function(e, t) {
                    $.each(t, function(t, a) {
                        s.push(e + " " + a)
                    })
                }), s
            },
            _onError: function(XMLHttpRequest, textStatus, self) {
                var selectors = self.selectors,
                    strings = self.strings;
                self._enableButtons();
                var feedback = "",
                    data = eval("(" + XMLHttpRequest.responseText + ")");
                feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + self._fullMessagesFromErrors(data).join("; ") + ".", "Error : country is not supported." == feedback && (feedback = "We do not ship to this destination."), self._render({
                    rates: [],
                    errorFeedback: feedback,
                    success: !1
                }), $(selectors.response).show()
            },
            _getCartShippingRatesForDestination: function(e) {
                var t = this,
                    a = this.selectors,
                    s = this.strings;
                $.ajax({
                    type: "POST",
                    url: "/cart/prepare_shipping_rates",
                    data: $.param({
                        shipping_address: e
                    }),
                    success: t._pollForCartShippingRatesForDestination(e),
                    error: function(e, a) {
                        t._onError(e, a, t)
                    }
                })
            },
            _init: function() {
                var e = this,
                    t = this.selectors,
                    a = this.strings;
                if ($(t.shipping_calculator).length) {
                    new Shopify.CountryProvinceSelector(t.address_country, t.address_province, {
                        hideElement: t.address_province_container
                    });
                    var s = $("#" + t.address_country),
                        o = $("#" + t.address_province_label).get(0);
                    "undefined" != typeof Countries && (Countries.updateProvinceLabel(s.val(), o), s.change(function() {
                        Countries.updateProvinceLabel(s.val(), o)
                    })), $(t.get_rates).off("click"), $(t.get_rates).click(function() {
                        e._disableButtons(), $(t.response).empty().hide();
                        var a = {};
                        a.zip = $("#" + t.address_zip).val() || "", a.country = $("#" + t.address_country).val() || "", a.province = $("#" + t.address_province).val() || "", e._getCartShippingRatesForDestination(a)
                    }), a.customerIsLoggedIn && $(t.get_rates + ":eq(0)").trigger("click"), $(t.shipping_btn).off("click"), $(t.shipping_btn).click(function() {
                        $(t.shipping_calculator).slideToggle()
                    })
                }
            }
        }), ShippingCalculator
    }(), theme.CartGift = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.selectors = {
                gift: "#gift__wrapping-" + a,
                namespace: "#CartSection-" + a,
                redirect: !0
            }, this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            check: function() {
                var e = this,
                    t = this.selectors;
                if ($(t.gift).length) {
                    var a = $(t.gift).data("gift_case");
                    1 === a ? e.remove() : 2 === a ? e.set() : 3 === a ? e.set() : 3 === a ? e.set() : void 0
                }
            },
            set: function() {
                var e = this,
                    t = this.selectors;
                if ($(t.gift).length) {
                    var a = $(t.gift).data("product_id"),
                        s = {};
                    s[a] = 1;
                    var o = {};
                    o["gift-wrapping"] = !0;
                    var r = {};
                    r.updates = s, r.attributes = o, $.ajax({
                        type: "POST",
                        url: "/cart/update.js",
                        data: r,
                        dataType: "json",
                        beforeSend: function() {
                            t.redirect || $(t.namespace).addClass("loading")
                        },
                        success: function() {
                            if (t.redirect) location.href = "/cart";
                            else {
                                var e = $(t.namespace);
                                $.get("/cart?view=popup", function(a) {
                                    e.html($(a).find(t.namespace).html()), setTimeout(function() {
                                        e.removeClass("loading"), theme.MiniCart.update();
                                        var t = new theme.Sections;
                                        t.register("shipping-calculator-popup", theme.ShippingCalculator)
                                    }, 100)
                                })
                            }
                        }
                    })
                }
            },
            remove: function() {
                var e = this,
                    t = this.selectors;
                if ($(t.gift).length) {
                    var a = $(t.gift).data("product_id"),
                        s = {};
                    s[a] = 0;
                    var o = {};
                    o["gift-wrapping"] = "";
                    var r = {};
                    r.updates = s, r.attributes = o, $.ajax({
                        type: "POST",
                        url: "/cart/update.js",
                        data: r,
                        dataType: "json",
                        beforeSend: function() {
                            t.redirect || $(t.namespace).addClass("loading")
                        },
                        success: function() {
                            if (t.redirect) location.href = "/cart";
                            else {
                                var e = $(t.namespace);
                                $.get("/cart?view=popup", function(a) {
                                    e.html($(a).find(t.namespace).html()), setTimeout(function() {
                                        e.removeClass("loading"), theme.MiniCart.update();
                                        var t = new theme.Sections;
                                        t.register("shipping-calculator-popup", theme.ShippingCalculator)
                                    }, 100)
                                })
                            }
                        }
                    })
                }
            },
            init: function() {
                var e = this,
                    t = this.selectors;
                $(t.gift).length && (!1 == $(t.gift).data("redirect") && (this.selectors.redirect = !1), e.check(), $(document).off("change", t.gift), $(document).on("change", t.gift, function() {
                    $(this).is(":checked") ? e.set() : e.remove()
                }))
            }
        }), e
    }(), theme.Filters = function() {
        function e(e) {
            var t = this.$container = $(e);
            this.$limitSelect = $(a.limitSelection, t), this.$sortSelect = $(a.sortSelection, t), this.$selects = $(a.limitSelection, t).add($(a.sortSelection, t)), this.defaultLimit = this._getDefaultLimitValue(), this.defaultSort = this._getDefaultSortValue(), this._resizeSelect(this.$selects), this.$selects.removeClass("hidden"), this.$limitSelect.on("change", this._onLimitChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this)), $(document).on("change", a.filterSelection, this._onFilterChange.bind(this)), $(document).on("click", a.filterClear, this._onFilterClear.bind(this)), $(document).on("click", a.pageSelection, this._onPageClick.bind(this)), $(document).on("click", a.loadMoreSelection, this._onLoadMoreClick.bind(this)), $(document).on("click", a.viewSelection, this._onViewClick.bind(this)), this._onLoadMoreInfinite(a.loadMoreSelection), this._initFiltersHtml(), this._initFiltersActive(), this._filterClearAll()
        }
        var t = {
                SORT_BY: "sort_by",
                LIMIT: "limit",
                PAGE: "page",
                VIEW: "view",
                CONSTRAINT: "constraint"
            },
            a = {
                limitSelection: "#PerPage",
                defaultLimit: "#DefaultPerPage",
                sortSelection: "#SortBy",
                defaultSort: "#DefaultSortBy",
                viewSelection: ".shop__view",
                pageSelection: "#site-pagination a.btn",
                loadMoreSelection: "#site-pagination .loadmore",
                filtersSelection: ".sidebar__btn",
                filterSelection: ".advanced-filter .filter",
                filterClear: ".site-widget.filtering .clear"
            };
        return e.prototype = _.assignIn({}, e.prototype, {
            _initFiltersHtml: function() {
                $(".shop__filtering").length && $(".shop__filtering-inner").empty().append($(".site-sidebar").html())
            },
            _initFiltersActive: function() {
                if ($(".filters__active").length) {
                    var e = $(".filters__active .clear_nav").empty();
                    $(".site-sidebar .site-widget.filtering").each(function() {
                        var t = $(this);
                        if (t.find(".filter-tag.active").length) {
                            var a = t.find(".filter-tag.active label").clone();
                            e.append(a)
                        } else if (t.find(".filter-tag select").length && "" != t.find(".filter-tag select").val()) {
                            var a = "<label for=\"" + t.find(".filter-tag input").attr("id") + "\">" + t.find(".filter-tag select").val() + "</label>";
                            e.append(a)
                        }
                    }), e.find("label").length ? $(".filters__active").show() : $(".filters__active").hide()
                }
            },
            _filterClearAll: function() {
                var e = this;
                $(".filters__active").length && $(".filters__active").on("click", ".clear_all", function() {
                    delete Shopify.queryParams[t.CONSTRAINT], e._filterAjaxClick(!0)
                })
            },
            _onFilterClear: function(e) {
                var a = [];
                Shopify.queryParams[t.CONSTRAINT] && (a = Shopify.queryParams[t.CONSTRAINT].split("+"));
                var s = $(e.currentTarget),
                    o = s.closest(".site-widget.filtering"),
                    r = o.find("select");
                0 < r.length && r.find("option").each(function() {
                    var e = $(this).val();
                    if (e) {
                        var t = a.indexOf(e);
                        0 <= t && a.splice(t, 1)
                    }
                });
                var n = o.find("input");
                0 < n.length && n.each(function() {
                    var e = $(this).val();
                    if (e) {
                        var t = a.indexOf(e);
                        0 <= t && a.splice(t, 1)
                    }
                }), a.length ? Shopify.queryParams[t.CONSTRAINT] = a.join("+") : delete Shopify.queryParams[t.CONSTRAINT], this._filterAjaxClick(!0)
            },
            _onFilterChange: function(e) {
                var a = $(e.currentTarget),
                    s = a.closest(".advanced-filter"),
                    o = a.closest(".filter-tag"),
                    r = s.data("multi_choice"),
                    n = [];
                if (Shopify.queryParams[t.CONSTRAINT] && (n = Shopify.queryParams[t.CONSTRAINT].split("+")), !1 == r && !o.hasClass("active")) {
                    var d = s.find(".active input");
                    0 < d.length && d.each(function() {
                        var e = $(this).val();
                        if (e) {
                            var t = n.indexOf(e);
                            0 <= t && n.splice(t, 1)
                        }
                    })
                }
                var l = s.find("select");
                0 < l.length && l.find("option").each(function() {
                    var e = $(this).val();
                    if (e) {
                        var t = n.indexOf(e);
                        0 <= t && n.splice(t, 1)
                    }
                });
                var c = a.val();
                if (c) {
                    var p = n.indexOf(c);
                    0 <= p ? n.splice(p, 1) : n.push(c)
                }
                n.length ? Shopify.queryParams[t.CONSTRAINT] = n.join("+") : delete Shopify.queryParams[t.CONSTRAINT], this._filterAjaxClick(!0)
            },
            _onViewClick: function(e) {
                e.preventDefault();
                var s = $(e.currentTarget),
                    o = $(a.viewSelection),
                    r = s.data("view");
                "grid" == r && (r = r + "-" + s.data("per_row")), Shopify.queryParams[t.VIEW] = r, this._filterAjaxClick(), o.removeClass("active"), s.addClass("active")
            },
            _onLoadMoreInfinite: function(e) {
                var t = $(e),
                    a = t.closest(".ajax_load_button");
                if (a.hasClass("ajax_load_hidden")) {
                    var s = Math.abs(0);
                    $(window).scroll(function() {
                        if ($("#site-primary .products").length && $("#site-pagination").find("a.next").length) {
                            var t = $("#site-primary .products").offset().top + $("#site-primary .products").outerHeight(),
                                a = t - $(window).scrollTop();
                            a - s < $(window).height() && 0 == parseInt($(e).attr("data-processing")) && $(e).trigger("click")
                        }
                    })
                }
            },
            _onLoadMoreClick: function(e) {
                e.preventDefault();
                var t = this,
                    a = "#site-pagination .loadmore",
                    s = "#site-pagination .ajax_load_button",
                    o = "#site-primary .products .product",
                    r = "#site-pagination";
                if (1 != parseInt($(a).attr("data-processing")))
                    if ($(r).find("a.next").length) {
                        $(a).attr("data-processing", 1);
                        var n = $(r).find("a.next").attr("href"),
                            d = $(a).data("no_more");
                        $(s).addClass("loading"), $.get(n, function(e) {
                            $(r).empty().html($(e).find(r).html()), $(e).find(o).each(function() {
                                $(o).last().after($(this))
                            }), $(s).removeClass("loading"), $(a).attr("data-processing", 0), 0 == $(r).find("a.next").length && ($(s).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(a).show().html(d).addClass("disabled").prop("disabled", !0))
                        })
                    } else {
                        var d = $(a).attr("data-no-more");
                        $(s).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(a).show().html(d).addClass("disabled").prop("disabled", !0)
                    }
            },
            _onPageClick: function(e) {
                e.preventDefault();
                var t = $(e.currentTarget),
                    a = t.attr("href");
                this._filterGetContent(a)
            },
            _onSortChange: function(e) {
                var a = this.$sortSelect.val() || this.defaultSort;
                Shopify.queryParams[t.SORT_BY] = a, this._filterAjaxClick(), this._resizeSelect($(e.target))
            },
            _onLimitChange: function(e) {
                var a = this.$limitSelect.val() || this.defaultLimit;
                Shopify.queryParams[t.LIMIT] = a, this._filterAjaxClick(), this._resizeSelect($(e.target))
            },
            _getDefaultLimitValue: function() {
                return $(a.defaultLimit, this.$container).val()
            },
            _getDefaultSortValue: function() {
                return $(a.defaultSort, this.$container).val()
            },
            _resizeSelect: function(e) {
                e.each(function() {
                    var e = $(this),
                        t = e.find("option:selected").text(),
                        a = $("<span>").html(t);
                    a.appendTo("body");
                    var s = a.width();
                    a.remove(), e.width(s + 3)
                })
            },
            _filterAjaxClick: function(e) {
                "undefined" == typeof e && (e = !1), delete Shopify.queryParams.page;
                var t = this._filterCreateUrl();
                this._filterGetContent(t, e)
            },
            _filterCreateUrl: function() {
                var e = $.param(Shopify.queryParams).replace(/%2B/g, "+");
                return location.pathname + "?" + e
            },
            _filterGetContent: function(e, t) {
                "undefined" == typeof t && (t = !1);
                var a = "#site-primary .product-found",
                    s = "#site-primary .products .product",
                    o = "#site-pagination",
                    r = "#site-secondary .site-sidebar",
                    n = this;
                $("body").removeClass("sidebar-open"), $(".shop__filtering").slideUp();
              	$('#site-secondary').hide();
                var d = 40;
                $("#shopify-section-header-sticky").length && $("#shopify-section-header-sticky").is(":visible") ? d += $("#shopify-section-header-sticky").outerHeight() : $("#shopify-section-header-mobile").length && $("#shopify-section-header-mobile").is(":visible") && (d += $("#shopify-section-header-mobile").outerHeight()), $("html, body").animate({
                    scrollTop: $("#site-primary").offset().top - d
                }, 1200), $.ajax({
                    type: "GET",
                    url: e,
                    beforeSend: function() {
                        $("body").addClass("loading")
                    },
                    complete: function() {
                        $("body").removeClass("loading")
                    },
                    success: function(d) {
                        if ($.fn.countdown && $("#site-primary .products").find(".product__countdown .is-countdown").each(function() {
                                $(this).countdown("destroy")
                            }), $(o).empty().html($(d).find(o).html()), t) {
                            $(r).empty().html($(d).find(r).html()), $("#site-primary .shop__filtering-inner").empty().append($(r).html());
                            var l = new theme.Sections;
                            l.register("sidebar-sticky", theme.SidebarSticky)
                        }
                        $("#site-primary .products").empty().attr("class", $(d).find("#site-primary .products").attr("class")), 0 < $(d).find(s).length ? $(d).find(s).each(function() {
                            $("#site-primary .products").append($(this))
                        }) : $("#site-primary .products").append($(d).find("#site-primary .no-products")), $(a).empty().html($(d).find(a).html()), n._initFiltersActive();
                        var c = $(d).filter("title").text();
                        History.pushState({
                            param: Shopify.queryParams
                        }, c, e)
                    }
                })
            },
            _lineItem: function() {
                theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
                var e = new theme.Sections;
                e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer)
            },
            onLoad: function() {
                this._lineItem()
            },
            onUnload: function() {
                this.$limitSelect.off("change", this._onLimitChange), this.$sortSelect.off("change", this._onSortChange), $(document).off("click", a.viewSelection, this._onViewClick), $(document).off("click", a.pageSelection, this._onPageClick), $(document).off("click", a.loadMoreSelection, this._onLoadMoreClick)
            }
        }), e
    }(), theme.SidebarSticky = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                selector: "#site-secondary .site-sidebar",
                primary: "#site-primary",
                toggle: "#site-secondary .site-widget__toggle"
            }, this.init(), this.update()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function() {
                var e = $(this.settings.selector);
                if (!(992 > $(window).width())) {
                    var t = 40,
                        a = $(this.settings.primary);
                    $(".site-header").hasClass("header-sticky") && (t = 60);
                    var s = e.outerHeight() - a.outerHeight(); - 100 > s ? e.stick_in_parent({
                        offset_top: t
                    }) : 100 < s && a.stick_in_parent({
                        offset_top: t
                    }), $(window).resize(function() {
                        992 > $(window).width() ? (e.trigger("sticky_kit:detach"), a.trigger("sticky_kit:detach")) : e.outerHeight() < a.outerHeight() ? e.stick_in_parent({
                            offset_top: t
                        }) : a.stick_in_parent({
                            offset_top: t
                        })
                    })
                }
            },
            update: function() {
                var e = this;
                $(e.settings.toggle).on("change", function() {
                    $(document.body).trigger("sticky_kit:recalc")
                })
            }
        }), e
    }(), theme.HeaderMobile = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.selectors = {
                headerFixed: ".header__mobile.is-fixed",
                navOpenIcon: ".mobile-nav__open",
                navCloseIcon: ".mobile-nav__close",
                navWrapper: ".mobile-header__nav .mobile__menu",
                megaMenu: "#phantom__menu"
            }, this._initHeaderFixed(), this._initMenu(), this._productsSlider(), theme.Search.init(), theme.MiniCart.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _animMenu: function() {
                var e = new TimelineLite,
                    t = $(".mobile__menu .listitem-0"),
                    a = $(".mobile__menu .listitem-0 > .listitem > .site-nav__link");
                theme.settings.rtl ? (e.fromTo(t, .1, {
                    autoAlpha: 0
                }, {
                    autoAlpha: 1
                }, 0), e.staggerFromTo(a, 2, {
                    opacity: 0,
                    y: 150,
                    x: -30,
                    rotation: -10
                }, {
                    opacity: 1,
                    y: 0,
                    x: 0,
                    rotation: 0,
                    ease: Power4.easeInOut
                }, .08, -.8)) : (e.fromTo(t, .1, {
                    autoAlpha: 0
                }, {
                    autoAlpha: 1
                }, 0), e.staggerFromTo(a, 2, {
                    opacity: 0,
                    y: 150,
                    x: 30,
                    rotation: 10
                }, {
                    opacity: 1,
                    y: 0,
                    x: 0,
                    rotation: 0,
                    ease: Power4.easeInOut
                }, .08, -.8))
            },
            _initHeaderFixed: function() {
                if ($(this.selectors.headerFixed).length) {
                    function a() {
                        if (e.is(":visible")) {
                            var a = e.outerHeight();
                            e.addClass("finished"), t.css("height", a)
                        }
                    }

                    function s() {
                        var a = $(window).scrollTop(),
                            s = $(t).offset().top + 10;
                        s <= a ? $(e).removeClass("unstick").addClass("stick") : $(e).removeClass("stick").addClass("unstick")
                    }
                    var e = $(this.selectors.headerFixed),
                        t = e.parent();
                    a(), $(window).resize(function() {
                        a()
                    });
                    $(t).offset().top + 10;
                    s(), $(window).scroll(function() {
                        s()
                    })
                }
            },
            _initMenu: function() {
                if ("undefined" == typeof $.fn.roarmenu) return !1;
                var e = this,
                    t = e.selectors;
                if ($(t.navWrapper).hasClass("has-megamenu") && $(t.megaMenu).length) {
                    var a = $($(t.megaMenu).val());
                    a.find(".product__form").remove(), a.find(".site-nav__dropdown:not(.drilldown)").removeAttr("class").removeAttr("style"), a.find(".drilldown").removeAttr("class").addClass("drilldown"), a.find(".text-left").removeClass("text-left"), a.find(".text-center").removeClass("text-center"), a.find(".text-right").removeClass("text-right"), $(t.navWrapper).find(".listitem-1").remove(), $(t.navWrapper + " .listitem-0").prepend(a.find(".site-nav__items > .site-nav__item").removeAttr("class"))
                }
                $(t.navWrapper).length && $(t.navWrapper).roarmenu({
                    navbar: {
                        add: !0,
                        close: "mobile-nav__close",
                        back: theme.strings.back,
                        title: theme.strings.menu,
                        titleLink: "anchor"
                    }
                }), $(document).off("click", t.navOpenIcon), $(document).on("click", t.navOpenIcon, function(t) {
                    t.preventDefault(), $("body").addClass("menu-opened"), e._animMenu()
                }), $(document).off("click", t.navCloseIcon), $(document).on("click", t.navCloseIcon, function(e) {
                    e.preventDefault(), $("body").removeClass("menu-opened")
                })
            },
            _productsSlider: function() {
                var e = new theme.Sections;
                e.register("products-slider-sub", theme.ProductsSlider)
            },
            _lineItem: function() {
                theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
                var e = new theme.Sections;
                e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer)
            },
            onLoad: function() {
                this._lineItem()
            }
        }), e
    }(), theme.HeaderSection = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this._initElements(), this._initSticky()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _initElements: function() {
                theme.Search.init(), theme.CurrencyPicker.init(), theme.LanguagePicker.init(), theme.MiniCart.init();
                var e = new theme.Sections;
                e.register("mega-menu", theme.MegaMenu)
            },
            _initSticky: function() {
                function e() {
                    var e = $(window).scrollTop(),
                        t = $("#shopify-section-header").offset().top + $("#shopify-section-header").outerHeight() + $("#shopify-section-header-topbar").outerHeight() + 200;
                    t <= e && $("#shopify-section-header-sticky").addClass("stick")
                }
                var t = "#shopify-section-header";
                if ($("#shopify-section-header-sticky").length) {
                    var a = 0,
                        s = $(t).offset().top + $(t).outerHeight() + $("#shopify-section-header-topbar").outerHeight() + 200;
                    $(window).scroll(function() {
                        var e = $(this).scrollTop();
                        $("#shopify-section-header-sticky").is(":visible") && (s > e ? $("#shopify-section-header-sticky").hasClass("stick") && ($("#shopify-section-header-sticky").removeClass("stick").removeClass("sticky-hide").addClass("unstick"), a = e) : !$("#shopify-section-header-sticky").hasClass("stick") && ($("#shopify-section-header-sticky").removeClass("unstick").addClass("stick"), a = e))
                    }), e()
                }
            }
        }), e
    }(), theme.MegaMenu = function() {
        function e() {
            this._initMenu(), this._navigationInit(), this._productsSlider()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _initMenu: function() {
                var e = ".header__menu",
                    t = ".header__menu-left",
                    a = ".header__menu-right";
                if ($("#phantom__menu").length && $(e).length && $(e).each(function() {
                        var e = $("#phantom__menu").val();
                        $(this).empty().append(e)
                    }), $("#phantom__menu").length && $(t).length) {
                    var s = $($("#phantom__menu").val());
                    s.find(".site-nav__items > .site-nav__item").each(function() {
                        $(this).hasClass("pull-right") && $(this).remove()
                    }), $(t).each(function() {
                        var e = s.clone();
                        $(this).empty().append(e)
                    })
                }
                if ($("#phantom__menu").length && $(a).length) {
                    var s = $($("#phantom__menu").val());
                    s.find(".site-nav__items > .site-nav__item").each(function() {
                        $(this).hasClass("pull-right") || $(this).remove()
                    }), $(a).each(function() {
                        var e = s.clone();
                        $(this).empty().append(e)
                    })
                }
            },
            _navigationInit: function() {
                var e = [".site-navigation .site-nav__items > .site-nav--has-dropdown", ".my-account-has-drop", ".currency__picker .has-drop", ".language__picker .has-drop"].join(", ");
                $(e).mouseenter(function() {
                    $(this).closest(".site-header-main, .header-sticky__placeholder").attr("data-sticky", "visible"), $(".site-overlay").addClass("visible")
                }).mouseleave(function() {
                    $(".site-overlay").removeClass("visible"), $(this).closest(".site-header-main, .header-sticky__placeholder").removeAttr("data-sticky", "visible")
                })
            },
            _productsSlider: function() {
                var e = new theme.Sections;
                e.register("products-slider-sub", theme.ProductsSlider)
            },
            _lineItem: function() {
                theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
                var e = new theme.Sections;
                e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer)
            },
            onLoad: function() {
                this._lineItem()
            }
        }), e
    }(), theme.VerticalMenu = function() {
        function e() {
            this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function() {
                var e = ".header__menu-vertical";
                $(".phantom__menu-vertical .site-nav__vertical").length && $(e).length && $(e).each(function() {
                    var e = $(".phantom__menu-vertical .site-nav__vertical").clone();
                    $(this).empty().append(e)
                })
            }
        }), e
    }(), theme.Maps = function() {
        function e(e) {
            this.$container = $(e), this.$map = this.$container.find(d.map), this.key = this.$map.data("api-key"), "undefined" == typeof this.key || ("loaded" === o ? this.createMap() : (r.push(this), "loading" != o && (o = "loading", "undefined" == typeof window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function() {
                o = "loaded", t()
            }))))
        }

        function t() {
            $.each(r, function(e, t) {
                t.createMap()
            })
        }

        function a(e) {
            var t = $.Deferred(),
                a = new google.maps.Geocoder,
                s = e.data("address-setting");
            return a.geocode({
                address: s
            }, function(e, a) {
                a !== google.maps.GeocoderStatus.OK && t.reject(a), t.resolve(e)
            }), t
        }
        var s = {
                zoom: 19
            },
            o = null,
            r = [],
            n = {
                addressNoResults: theme.strings.addressNoResults,
                addressQueryLimit: theme.strings.addressQueryLimit,
                addressError: theme.strings.addressError,
                authError: theme.strings.authError
            },
            d = {
                section: "[data-section-type=\"map\"]",
                map: "[data-map]",
                mapOverlay: "[data-map-overlay]"
            },
            l = {
                mapError: "map-section--load-error",
                errorMsg: "map-section__error errors text-center"
            };
        return window.gm_authFailure = function() {
            Shopify.designMode && ($(d.section).addClass(l.mapError), $(d.map).remove(), $(d.mapOverlay).after("<div class=\"" + l.errorMsg + "\">" + theme.strings.authError + "</div>"))
        }, e.prototype = _.assignIn({}, e.prototype, {
            createMap: function() {
                var t = this.$map;
                return a(t).then(function(o) {
                    var r = [];
                    r[0] = {}, r[1] = {}, r[2] = {};
                    var e = [];
                    e[0] = {}, e[1] = {}, e[2] = {}, e[3] = {}, e[4] = {}, e[5] = {}, e[6] = {}, e[7] = {}, e[8] = {}, e[9] = {}, e[10] = {}, e[11] = {}, e[12] = {};
                    var a = [{
                            featureType: "poi",
                            elementType: "labels",
                            stylers: [{
                                visibility: "off"
                            }]
                        }, {
                            featureType: "road.local",
                            elementType: "labels.icon",
                            stylers: [{
                                visibility: "off"
                            }]
                        }, {
                            featureType: "road.arterial",
                            elementType: "labels.icon",
                            stylers: [{
                                visibility: "off"
                            }]
                        }, {
                            featureType: "road",
                            elementType: "geometry.stroke",
                            stylers: [{
                                visibility: "off"
                            }]
                        }, {
                            featureType: "transit",
                            elementType: "geometry.fill",
                            stylers: [{
                                hue: "#dadeef"
                            }, {
                                visibility: "on"
                            }, {
                                lightness: 1
                            }, {
                                saturation: 7
                            }]
                        }, {
                            elementType: "labels",
                            stylers: [{
                                saturation: -100
                            }]
                        }, {
                            featureType: "poi",
                            elementType: "geometry.fill",
                            stylers: [{
                                hue: "#dadeef"
                            }, {
                                visibility: "on"
                            }, {
                                lightness: 20
                            }, {
                                saturation: 7
                            }]
                        }, {
                            featureType: "landscape",
                            stylers: [{
                                hue: "#dadeef"
                            }, {
                                visibility: "on"
                            }, {
                                lightness: 20
                            }, {
                                saturation: 20
                            }]
                        }, {
                            featureType: "road",
                            elementType: "geometry.fill",
                            stylers: [{
                                hue: "#dadeef"
                            }, {
                                visibility: "on"
                            }, {
                                lightness: 1
                            }, {
                                saturation: 7
                            }]
                        }, {
                            featureType: "water",
                            elementType: "geometry",
                            stylers: [{
                                hue: "#dadeef"
                            }, {
                                visibility: "on"
                            }, {
                                lightness: 1
                            }, {
                                saturation: 7
                            }]
                        }, e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], r[0], r[1], r[2]],
                        n = new google.maps.StyledMapType(a, {
                            name: "Styled Map"
                        }),
                        d = {
                            center: o[0].geometry.location,
                            zoom: s.zoom,
                            mapTypeControlOptions: {
                                mapTypeIds: [google.maps.MapTypeId.ROADMAP, "map_style"]
                            },
                            scrollwheel: !1,
                            panControl: !1,
                            zoomControl: 1,
                            disableDoubleClickZoom: 1,
                            zoomControlOptions: {
                                style: google.maps.ZoomControlStyle.LARGE,
                                position: google.maps.ControlPosition.LEFT_CENTER
                            },
                            mapTypeControl: !1,
                            scaleControl: !1,
                            streetViewControl: !1,
                            fullscreenControlOptions: {
                                position: google.maps.ControlPosition.RIGHT_BOTTOM
                            }
                        },
                        l = this.map = new google.maps.Map(t[0], d);
                    l.mapTypes.set("map_style", n), l.setMapTypeId("map_style");
                    var c = this.center = l.getCenter(),
                        p = new google.maps.OverlayView;
                    p.draw = function() {
                        var a = this,
                            t = this.div_;
                        t || ((t = this.div_ = $("<div><div class=\"animated-dot\"><div class=\"pin\"></div><div class=\"pulse\"></div></div></div>")[0]).style.position = "absolute", t.style.paddingLeft = "0px", t.style.cursor = "pointer", this.getPanes().overlayImage.appendChild(t))
                    }, p.setMap(l), google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                        google.maps.event.trigger(l, "resize"), l.setCenter(c), t.removeAttr("style")
                    }))
                }.bind(this)).fail(function() {
                    var e;
                    e = "ZERO_RESULTS" === status ? n.addressNoResults : "OVER_QUERY_LIMIT" === status ? n.addressQueryLimit : "REQUEST_DENIED" === status ? n.authError : n.addressError, Shopify.designMode && t.parent().addClass(l.mapError).html("<div class=\"" + l.errorMsg + "\">" + e + "</div>")
                })
            },
            onUnload: function() {
                0 === this.$map.length || google.maps.event.clearListeners(this.map, "resize")
            }
        }), e
    }(), theme.Product = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                mediaQueryLargeUp: "screen and (min-width: 992px)",
                mediaQueryMedium: "screen and (max-width: 991px)",
                mediaQueryMediumUp: "screen and (min-width: 768px)",
                mediaQuerySmall: "screen and (max-width: 767px)",
                enableHistoryState: t.data("enable-history-state") || !1,
                namespace: ".ProductSection-" + a,
                sectionId: a,
                sectionType: t.data("section-type"),
                zoomEnabled: !1,
                sliderThumbsActive: !1,
                sliderImagesActive: !1,
                swatchColor: t.data("product_swatch_color"),
                swatchColorAdvanced: t.data("product_swatch_color_advanced"),
                swatchSize: t.data("product_swatch_size")
            }, this.selectors = {
                container: t,
                inComing: ".InComing-" + a,
                addToCart: ".AddToCart-" + a,
                addToCartText: ".AddToCartText-" + a,
                comparePrice: ".ComparePrice-" + a,
                originalPrice: ".ProductPrice-" + a,
                SKU: ".product-single__sku",
                originalSelectorId: ".ProductSelect-" + a,
                productImage: ".ProductImage-" + a,
                productImages: ".product-single__photos-" + a,
                productImageWraps: ".product-single__photo-" + a,
                productVideo: ".product-single__video-" + a,
                productVideoWrap: ".product-single__video-wrapper",
                productPrices: ".product-single__price-" + a,
                productThumbs: ".product-single__thumbnails-" + a,
                productNav: ".product-single__nav-" + a,
                sizeChart: ".sizechart_btn",
                productContent: ".product-single__content",
                productQuantity: ".product-form__item--quantity",
                productTabs: ".product-single__tabs",
                productReviews: ".product-single__review",
                productGalleryTrigger: ".product-single__photo.photoswipe-enabled",
                productVideoTrigger: ".product-single__show-video",
                recentlyViewed: ".recently-viewed-" + a,
                cartAgree: "#product-cart__agree-" + a,
                cartCheckout: "#product-buy__1click-" + a,
                stockCountdown: "#product-single__stock-" + a,
                visitorCounter: "#product-single__visitor-" + a,
                totalSold: "#product-single__sold-" + a,
                singleOptionSelector: ".single-option-selector-" + a,
                singleOptionSelectorId: "#SingleOptionSelector-" + a,
                singleOptionSwatchesWrapper: ".wrapper-swatches-" + a,
                singleOptionSwatchesRadio: ".swatch-radio-" + a,
                productThumbImages: ".product-single__thumbnail--" + a,
                productThumbImagesWrapper: ".product-single__thumbnails-" + a,
                productThumbListItem: ".product-single__thumbnails-item",
                productMediaWrapper: "[data-product-single-media-wrapper]",
                productMediaTypeVideo: ":not(.slick-cloned)[data-product-media-type-video]",
                productMediaTypeModel: "[data-product-media-type-model]"
            }, this.classes = {
                hidden: "classes-hide",
                visibilityHidden: "visibility-hidden",
                activeClass: "active-thumb",
                jsZoomEnabled: "js-zoom-enabled"
            }, $(".ProductJson-" + a, t).html() && (this.productSingleObject = JSON.parse($(".ProductJson-" + a, t).html()), this.productSwatchSingleObject = JSON.parse($(".ProductSwatchJson-" + a, t).html()), this.productMoreSingleObject = JSON.parse($(".ProductMoreJson-" + a, t).html()), this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass("zoom-enabled"), this._updateProductObject(), this._initBreakpoints(), this._initVariants(), this._initSwatches(), this._initMediaSwitch(), this._initReviews(), this._initQuantity(), this._productInView(), "product-template" == this.settings.sectionType && (this._initGalleryZoom(), this._initVideoZoom(), this._initTabs(), this._stickyDetails(), this._recordRecentlyViewed(), this._sizeChart(), this._checkoutCart(), this._initStockCountdown(), this._visitorCounter(), this._totalSold(), this._productNav(), this._productsSlider()), this._initProductVideo(), this._initModelViewerLibraries(), this._initShopifyXrLaunch())
        }

        function t(e) {
            var t = $(e).data("zoom");
            $(e).zoom({
                duration: 500,
                url: t,
                onZoomIn: function() {
                    $(this).addClass("active")
                },
                onZoomOut: function() {
                    $(this).removeClass("active")
                }
            })
        }

        function a(e) {
            $(e).trigger("zoom.destroy")
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _initMediaSwitch: function() {
                if ($(this.selectors.productThumbImages).length) {
                    $.fn.visible = function(t) {
                        var a = $(this),
                            s = $(window),
                            o = s.scrollTop(),
                            r = o + s.height(),
                            e = a.offset().top,
                            n = e + a.height(),
                            d = !0 === t ? n : e,
                            l = !0 === t ? e : n;
                        return l <= r && d >= o
                    };
                    var e = this;
                    $(this.selectors.productThumbImages).on("click", function(t) {
                        t.preventDefault();
                        var a = $(this),
                            s = a.data("thumbnail-id");
                        e._switchMedia(s), e._setActiveThumbnail(s)
                    }).on("keyup", e._handleMediaFocus.bind(e)), $(e.selectors.productThumbs).on("beforeChange", function(t, a, s, o) {
                        var r = $(e.selectors.productThumbs).find(".slick-slide").eq([o]);
                        if (r.find(".product-single__thumbnail").length) {
                            var n = r.find(".product-single__thumbnail"),
                                d = n.data("thumbnail_id");
                            $(e.selectors.productVideo).data("thumbnail_prev", d), $(e.selectors.productVideoWrap).hide(), $(e.selectors.productImages).show(), e._pauseVideo()
                        }
                    }), $(e.selectors.productImages).on("afterChange", function(t, a, s) {
                        var o = $(e.selectors.productImages).find(".slick-slide").eq([s]),
                            r = o.data("media-id");
                        e._switchMedia(r)
                    }), $(e.selectors.productVideo).on("click", function() {
                        var t = $(this),
                            a = t.data("thumbnail_prev");
                        if (t.hasClass("played")) {
                            var s = $(e.selectors.productThumbImages + "[data-thumbnail_id='" + a + "']")[0];
                            s.click()
                        } else $(e.selectors.productThumbs).find(".slick-slide").removeClass("slick-current"), $(e.selectors.productImages).hide(), $(e.selectors.productVideoWrap).show(), e._playVideo(a)
                    }), $(window).scroll(function() {
                        $(e.selectors.productImageWraps).each(function(e, t) {
                            var a = $(t);
                            a.visible(!0) && a.addClass("come-in")
                        })
                    })
                }
            },
            _setActiveThumbnail: function(e) {
                "undefined" == typeof e && (e = $(this.selectors.productMediaWrapper + ":not(." + this.classes.hidden + ")", this.$container).data("media-id"));
                var t = $(this.selectors.productThumbListItem + ":not(.slick-cloned)", this.$container),
                    a = t.find(this.selectors.productThumbImages + "[data-thumbnail-id='" + e + "']");
                if ($(this.selectors.productThumbImages).removeClass(this.classes.activeClass).removeAttr("aria-current"), a.addClass(this.classes.activeClass), a.attr("aria-current", !0), !!t.hasClass("slick-slide")) {
                    var s = a.parent().data("slick-index");
                    $(this.selectors.productThumbImagesWrapper).slick("slickGoTo", s, !0)
                }
            },
            _initProductVideo: function() {
                var e = this.settings.sectionId;
                $(this.selectors.productMediaTypeVideo, this.$container).each(function() {
                    var t = $(this);
                    theme.ProductVideo.init(t, e)
                })
            },
            _initModelViewerLibraries: function() {
                var e = $(this.selectors.productMediaTypeModel, this.$container);
                1 > e.length || theme.ProductModel.init(e, this.settings.sectionId)
            },
            _initShopifyXrLaunch: function() {
                var e = this;
                $(document).on("shopify_xr_launch", function() {
                    var t = $(e.selectors.productMediaWrapper + ":not(." + e.classes.hidden + ")", e.$container);
                    t.trigger("xrLaunch")
                })
            },
            _updateMedia: function(e) {
                var t = e.variant,
                    a = t.featured_media.id,
                    s = this.settings.sectionId + "-" + a;
                this._switchMedia(s), this._setActiveThumbnail(s)
            },
            _switchMedia: function(e) {
                var t = $(this.selectors.productMediaWrapper + ":not(." + this.classes.hidden + ")", this.$container),
                    a = $(this.selectors.productMediaWrapper + "[data-media-id='" + e + "']", this.$container),
                    s = $(this.selectors.productMediaWrapper + ":not([data-media-id='" + e + "'])", this.$container);
                t.trigger("mediaHidden"), a.trigger("mediaVisible"), a.removeClass(this.classes.hidden).trigger("mediaVisible"), s.addClass(this.classes.hidden)
            },
            _handleMediaFocus: function(e) {
                if (e.keyCode === slate.utils.keyboardKeys.ENTER) {
                    var t = $(e.currentTarget).data("thumbnail-id");
                    $(this.selectors.productMediaWrapper + "[data-media-id='" + t + "']", this.$container).focus()
                }
            },
            _initImageSlider: function(e) {
                "undefined" == typeof e && (e = !0);
                var t = this,
                    a = !1;
                "1" == $(t.selectors.productImages).data("adaptive_height") && (a = !0);
                var s = {
                    infinite: 1,
                    adaptiveHeight: a,
                    rtl: theme.settings.rtl,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: !0,
                    dots: !0,
                    arrows: !0,
                    prevArrow: "<button class=\"slick-prev\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-prev2\"></use></svg></button>",
                    nextArrow: "<button class=\"slick-next\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-next2\"></use></svg></button>",
                    asNavFor: t.selectors.productThumbs,
                    responsive: [{
                        breakpoint: 767,
                        settings: {
                            adaptiveHeight: !0
                        }
                    }]
                };
                if (!1 == e ? !0 == $(t.selectors.productImages).data("center_mode") && (s.centerMode = !0, s.centerPadding = "25%", s.fade = !1, s.arrows = !0) : (s.slidesToShow = 1, s.fade = !1, s.dots = !0, s.arrows = !1), $(t.selectors.productImages).closest(".product-single__photos").find(".carousel-status").length) {
                    var o = $(t.selectors.productImages).closest(".product-single__photos").find(".carousel-status");
                    $(t.selectors.productImages).on("beforeChange", function(e, t, a, s) {
                        o.html("<span>" + (s + 1) + "</span>/<span>" + t.$slides.length + "</span>")
                    })
                }
                theme.settings.animation && $(t.selectors.productImages).on("init", function(e, t) {
                    var a = new TimelineLite,
                        s = t.$slider,
                        o = s.parent();
                    a.fromTo(s, 1, {
                        opacity: 0
                    }, {
                        ease: Power4.easeInOut,
                        opacity: 1
                    }, 0), a.fromTo(o, 2, {
                        scale: 1.1,
                        opacity: 0
                    }, {
                        ease: Power4.easeInOut,
                        scale: 1,
                        opacity: 1
                    }, .3)
                }), t.settings.sliderImagesActive = !0, $(t.selectors.productImages).slick(s)
            },
            _initThumbnailSlider: function(e) {
                "undefined" == typeof e && (e = !0);
                var t = this,
                    a = !1;
                !1 == e && !0 == $(t.selectors.productThumbs).data("vertical") && (a = !0);
                var s = {
                    rtl: theme.settings.rtl,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    vertical: a,
                    verticalSwiping: a,
                    asNavFor: t.selectors.productImages,
                    focusOnSelect: !0,
                    arrows: !1,
                 
                };
               var s2 = {
                    rtl: theme.settings.rtl,
                    
                  slidesPerRow:$(t.selectors.productThumbs).data("count"),
                    slidesToScroll: 1,
                    vertical: a,
                    verticalSwiping: a,
                    asNavFor: t.selectors.productImages,
                    focusOnSelect: !0,
                    arrows: !1
                };
              	function isMobile() {
                       try{ document.createEvent("TouchEvent"); return true; }
                       catch(e){ return false; }
                    }
              
              
              	if (window.screen.width < 800) {
                  theme.settings.animation && $(t.selectors.productThumbs).on("init", function(e, t) {
                      var a = new TimelineLite,
                          s = t.$slider;
                      a.fromTo(s.find(".slick-list"), 1.4, {
                          y: 20,
                          opacity: 0
                      }, {
                          ease: Power4.easeInOut,
                          y: 0,
                          opacity: 1,
                          onStart: function() {
                              setTimeout(function() {
                                  s.addClass("shadow")
                              }, 600)
                          }
                      }, 1)
                  }), t.settings.sliderThumbsActive = !0, $(t.selectors.productThumbs).slick(s2)
                }else{
                	theme.settings.animation && $(t.selectors.productThumbs).on("init", function(e, t) {
                      var a = new TimelineLite,
                          s = t.$slider;
                      a.fromTo(s.find(".slick-list"), 1.4, {
                          y: 20,
                          opacity: 0
                      }, {
                          ease: Power4.easeInOut,
                          y: 0,
                          opacity: 1,
                          onStart: function() {
                              setTimeout(function() {
                                  s.addClass("shadow")
                              }, 600)
                          }
                      }, 1)
                  }), t.settings.sliderThumbsActive = !0, $(t.selectors.productThumbs).slick(s)
                }
            },
            _destroyImageSlider: function() {
                $(this.selectors.productImages).slick("unslick"), this.settings.sliderImagesActive = !1
            },
            _destroyThumbnailSlider: function() {
                $(this.selectors.productThumbs).slick("unslick"), this.settings.sliderThumbsActive = !1
            },
            _initImageSwitch: function() {
                if ($(this.selectors.productThumbImages).length) {
                    $.fn.visible = function(t) {
                        var a = $(this),
                            s = $(window),
                            o = s.scrollTop(),
                            r = o + s.height(),
                            e = a.offset().top,
                            n = e + a.height(),
                            d = !0 === t ? n : e,
                            l = !0 === t ? e : n;
                        return l <= r && d >= o
                    };
                    var e = this;
                    $(document).off("click", e.selectors.productThumbImages), $(document).on("click", e.selectors.productThumbImages, function(e) {
                        e.preventDefault()
                    }), $(e.selectors.productThumbs).on("beforeChange", function(t, a, s, o) {
                        var r = $(e.selectors.productThumbs).find(".slick-slide").eq([o]);
                        if (r.find(".product-single__thumbnail").length) {
                            var n = r.find(".product-single__thumbnail"),
                                d = n.data("thumbnail_id");
                            $(e.selectors.productVideo).data("thumbnail_prev", d), $(e.selectors.productVideoWrap).hide(), $(e.selectors.productImages).show(), e._pauseVideo()
                        }
                    }), $(e.selectors.productVideo).on("click", function() {
                        var t = $(this),
                            a = t.data("thumbnail_prev");
                        if (t.hasClass("played")) {
                            var s = $(e.selectors.productThumbImages + "[data-thumbnail_id='" + a + "']")[0];
                            s.click()
                        } else $(e.selectors.productThumbs).find(".slick-slide").removeClass("slick-current"), $(e.selectors.productImages).hide(), $(e.selectors.productVideoWrap).show(), e._playVideo(a)
                    }), $(window).scroll(function() {
                        $(e.selectors.productImageWraps).each(function(e, t) {
                            var a = $(t);
                            a.visible(!0) && a.addClass("come-in")
                        })
                    })
                }
            },
            _switchImage: function(e) {
                if ("product-quickview" == this.settings.sectionType) {
                    var t = $(this.selectors.productImage, this.selectors.container);
                    return void t.attr("data-bgset", theme.roarJs.bgSet(e)).removeClass("lazyloaded").addClass("lazyload")
                }
                if ($(this.selectors.productThumbImages).length) {
                    var a = $(this.selectors.productThumbImages + "[data-thumbnail_id='" + e.id + "']")[0];
                    a.click()
                }
            },
            _initBreakpoints: function() {
                var e = this;
                enquire.register(e.settings.mediaQueryMedium, {
                    match: function() {
                        e.settings.sliderThumbsActive && e._destroyThumbnailSlider(), e._initThumbnailSlider()
                    }
                }), enquire.register(e.settings.mediaQueryLargeUp, {
                    match: function() {
                        e.settings.sliderThumbsActive && e._destroyThumbnailSlider(), e._initThumbnailSlider(!1)
                    }
                }), enquire.register(e.settings.mediaQuerySmall, {
                    match: function() {
                        e.settings.sliderImagesActive && e._destroyImageSlider(), e._initImageSlider(), e.settings.zoomEnabled && $(e.selectors.productImageWraps).each(function() {
                            a(this)
                        })
                    }
                }), enquire.register(e.settings.mediaQueryMediumUp, {
                    match: function() {
                        e.settings.sliderImagesActive && e._destroyImageSlider(), e._initImageSlider(!1), e.settings.zoomEnabled && $(e.selectors.productImageWraps).each(function() {
                            t(this)
                        })
                    }
                })
            },
            _productNav: function() {
                var e = this;
                if ($(e.selectors.productNav).length) {
                    var t = $(e.selectors.productNav),
                        a = $(".product-template__end"),
                        s = function() {
                            var e = t.offset().top / 3,
                                s = a.offset().top - 400,
                                o = $(window).scrollTop();
                            e < o ? t.addClass("visible") : t.removeClass("visible"), s < o && t.removeClass("visible")
                        };
                    s(), $(window).scroll(s), $(window).resize(s)
                }
            },
            _productInView: function() {
                return "undefined" != typeof ScrollReveal && !1 != theme.settings.animation && void(window.sr = ScrollReveal(), sr.reveal(".product-single__inview:not(.no-anim)", {
                    mobile: !0,
                    beforeReveal: function(e) {
                        e.visuelRevealTL = new TimelineLite, $(e).addClass("anim"), e.visuelRevealTL.fromTo(e, 2, {
                            y: 40,
                            opacity: 0
                        }, {
                            ease: Power4.easeInOut,
                            y: 0,
                            opacity: 1
                        }, 0).call(function() {
                            $(e).removeClass("anim").addClass("no-anim")
                        })
                    }
                }))
            },
            _updateProductObject: function() {
                var e = this;
                $.each(e.productMoreSingleObject.variants, function(t, a) {
                    $.each(a, function(a, s) {
                        e.productSingleObject.variants[t][a] = s
                    })
                })
            },
            _totalSold: function() {
                if ($(this.selectors.totalSold).length) {
                    var e = $(this.selectors.totalSold),
                        t = e.data("qty_min"),
                        a = e.data("qty_max"),
                        s = e.data("time_min"),
                        o = e.data("time_max");
                    t = Math.ceil(t), a = Math.floor(a), s = Math.ceil(s), o = Math.floor(o);
                    var r = Math.floor(Math.random() * (a - t + 1)) + t;
                    r = parseInt(r), r <= t && (r = t), r > a && (r = a), e.html(e.html().replace("/count/", r));
                    var n = Math.floor(Math.random() * (o - s + 1)) + s;
                    n = parseInt(n), n <= s && (n = s), n > o && (n = o), e.html(e.html().replace("/time/", n)), e.addClass("active"), e.find("img").first().length && setInterval(function() {
                        e.find("img").first().fadeIn(function() {
                            $(this).css("visibility", "visible")
                        }).delay(1600).fadeIn(function() {
                            $(this).css("visibility", "hidden")
                        }).delay(400)
                    }, 2e3)
                }
            },
            _visitorCounter: function() {
                if ($(this.selectors.visitorCounter).length) {
                    var s = $(this.selectors.visitorCounter),
                        d = 1,
                        c = s.data("max"),
                        p = s.data("interval"),
                        u = d,
                        g = c;
                    u = Math.ceil(u), g = Math.floor(g);
                    var m = Math.floor(Math.random() * (g - u + 1)) + u,
                        f = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"],
                        n = "",
                        y = "",
                        v = ["10", "20", "15"],
                        n = "",
                        y = "",
                        l = "";
                    setInterval(function() {
                        if (n = Math.floor(Math.random() * f.length), y = f[n], m = parseInt(m) + parseInt(y), d >= m) {
                            l = Math.floor(Math.random() * v.length);
                            var e = v[l];
                            m += e
                        }(1 > m || m > c) && (m = Math.floor(Math.random() * (g - u + 1)) + u), s.find("strong").first().text(parseInt(m)), s.addClass("active")
                    }, 1e3 * p)
                }
            },
            _initStockCountdown: function() {
                if ($(this.selectors.stockCountdown).length) {
                    var e = this,
                        t = $(e.selectors.stockCountdown);
                    if (t.hasClass("is-fake")) {
                        function e(e, t) {
                            return Math.floor(Math.random() * (t - e + 1) + e)
                        }

                        function d() {
                            t.find(".stock-countdown-message").first().html(theme.strings.onlyLeft.replace("{{ count }}", o)), r = setTimeout(function() {
                                o--, 1 > o && (o = e(a, s)), t.find(".stock-countdown-message strong").text(o), l(), o < a && clearTimeout(r)
                            }, 3000), n = setInterval(function() {
                                o--, 1 > o && (o = e(a, s)), t.find(".stock-countdown-message strong").text(o), l(), o < a && clearInterval(n)
                            }, 102000)
                        }

                        function l() {
                            var e = 100 * o / 60;
                            t.find(".progress-bar span").css("width", e + "%")
                        }
                        var a = t.data("min"),
                            s = t.data("max"),
                            o = e(a, s),
                            r = null,
                            n = null;
                        d(), t.hasClass("is-visible") && t.removeClass("hide")
                    }
                }
            },
            _updateStockCountdown: function(e) {
                var t = $(this.selectors.stockCountdown);
              console.log(e+' sd '+theme.strings.onlyLeft.replace("{{ count }}", e));
                t.hasClass("is-fake") ? t.removeClass("hide") : (t.find(".stock-countdown-message").html(theme.strings.onlyLeft.replace("{{ count }}", e)), t.find(".progress-bar span").first().css("width", "100%"), t.removeClass("hide"), setTimeout(function() {
                    t.find(".progress-bar span").first().css("width", "28%")
                }, 500))
                
                
                $(".stock-countdown-message").html(theme.strings.onlyLeft.replace("{{ count }}", e))
            },
            _checkoutCart: function() {
                var e = this;
                $(e.selectors.cartAgree).length && ($(document).on("DOMNodeInserted", e.selectors.cartCheckout, function() {
                    var t = $(this);
                    setTimeout(function() {
                        var a = t.find(".shopify-payment-button__button");
                        a.length && (t.hide(), setTimeout(function() {
                            var s = $(e.selectors.cartAgree);
                            s.is(":checked") ? a.removeClass("btn-disabled") : a.addClass("btn-disabled"), t.fadeIn()
                        }, 300))
                    }, 0)
                }), $(document).on("change", e.selectors.cartAgree, function() {
                    var t = $(this),
                        a = $(e.selectors.cartCheckout).find(".shopify-payment-button__button");
                    t.is(":checked") ? a.removeClass("btn-disabled") : a.addClass("btn-disabled")
                }))
            },
            _pauseVideo: function() {
                var e = $(this.selectors.productVideoWrap).find("video")[0];
                e && e.played && (e.pause(), e.load()), $(this.selectors.productVideo).removeClass("played")
            },
            _playVideo: function(e) {
                var t = this,
                    a = $(t.selectors.productVideoWrap).find("video")[0];
                if (a) {
                    a.play();
                    var s = 1;
                    a.addEventListener("ended", function() {
                        if (2 > s) a.play(), s++;
                        else {
                            var o = $(t.selectors.productThumbImages + "[data-thumbnail_id='" + e + "']")[0];
                            o.click()
                        }
                    }, !1)
                }
                $(t.selectors.productVideo).addClass("played")
            },
            _initVideoZoom: function() {
                function e() {
                    var e = [{
                        html: $(t.selectors.productVideoWrap + " .product-single__video").html()
                    }];
                    return e
                }
                var t = this,
                    a = $(".pswp")[0];
                $(document).off("click", t.selectors.productVideoTrigger), $(document).on("click", t.selectors.productVideoTrigger, function(t) {
                    t.preventDefault();
                    var s = $(this).parent(),
                        o = new PhotoSwipe(a, PhotoSwipeUI_Default, e(), {
                            index: 0,
                            closeOnScroll: !1,
                            bgOpacity: .1,
                            tapToClose: !0,
                            tapToToggleControls: !1
                        });
                    o.init(), $("body").addClass("blurred"), $(".pswp__item").fadeTo(1e3, 1), o.listen("close", function() {
                        $(".pswp__item .pswp__video").each(function() {
                            $(this).attr("src", $(this).attr("src"))
                        }), $(".pswp__item").fadeOut("slow", 0), $("body").removeClass("blurred")
                    })
                })
            },
            _initGalleryZoom: function() {
                function e() {
                    var e = [];
                    return $(t.selectors.productImages + " .product-single__photo-container:not(.slick-cloned) .feature-row__image").each(function() {
                        var t = $(this).data("large_image"),
                            a = $(this).data("large_image_width"),
                            s = $(this).data("large_image_height");
                        e.push({
                            src: t,
                            w: a,
                            h: s,
                            title: !1
                        })
                    }), e
                }
                var t = this,
                    a = $(".pswp")[0];
                $(document).off("click", t.selectors.productGalleryTrigger), $(document).on("click", t.selectors.productGalleryTrigger, function(t) {
                    t.preventDefault();
                    var s = $(this).parent(),
                        o = $(this).data("index"),
                        r = new PhotoSwipe(a, PhotoSwipeUI_Default, e(), {
                            index: o,
                            closeOnScroll: !1,
                            bgOpacity: .1,
                            tapToClose: !0,
                            tapToToggleControls: !1
                        });
                    r.init(), r.listen("imageLoadComplete", function() {
                        $(".pswp__item").fadeTo(1e3, 1), $("body").addClass("blurred")
                    }), r.listen("close", function() {
                        $(".pswp__item").fadeOut("slow", 0), $("body").removeClass("blurred")
                    })
                })
            },
            _initQuantity: function() {
                function e(e) {
                    var a = 0;
                    $(e).closest(t.selectors.productContent).find(t.selectors.productQuantity + " .quantity").each(function() {
                        a += parseInt($(this).val())
                    }), 0 < a ? $(t.selectors.addToCart).prop("disabled", !1) : $(t.selectors.addToCart).prop("disabled", !0)
                }
             	
                var t = this;
                $(document).off("click", t.selectors.productQuantity + " .plus"), $(document).on("click", t.selectors.productQuantity + " .plus", function() {
                    var a = $(this).closest(t.selectors.productQuantity).find(".quantity"),
                        s = parseInt(a.val());
                    ++s, a.val(s), e(this)
                     $('.product-form__cart-submit').prop("disabled", 0);
                }), $(document).off("click", t.selectors.productQuantity + " .minus"), $(document).on("click", t.selectors.productQuantity + " .minus", function() {
                    var a = $(this).closest(t.selectors.productQuantity).find(".quantity"),
                        s = parseInt(a.val());
                    0 < s && (--s, a.val(s), e(this))
                     $('.product-form__cart-submit').prop("disabled", 0);
                })
            },
            _stickyDetails: function() {
                var e = $(this.selectors.productContent);
                !e.data("sticky") || 992 > $(window).width() || e.each(function() {
                    var e = $(this).parent(),
                        t = $(this),
                        a = e.closest(".product-single").find(".product-single__photos"),
                        s = t.outerHeight() - a.outerHeight(); - 100 > s ? t.stick_in_parent({
                        offset_top: 20
                    }) : 100 < s && a.stick_in_parent({
                        offset_top: 20
                    }), $(window).resize(function() {
                        992 > $(window).width() ? (t.trigger("sticky_kit:detach"), a.trigger("sticky_kit:detach")) : t.outerHeight() < a.outerHeight() ? t.stick_in_parent({
                            offset_top: 20
                        }) : a.stick_in_parent({
                            offset_top: 20
                        })
                    })
                })
            },
            _initTabs: function() {
                var e = $(this.selectors.productTabs),
                    t = ".product-tabs__title";
                (e.hasClass("tabs-layout-tabs") || e.hasClass("tabs-layout-accordion")) && ($(document).off("click", t), $(document).on("click", t, function(a) {
                    a.preventDefault();
                    var s = $(this),
                        o = s.attr("href"),
                        r = $(t, e),
                        n = $(".product-tabs__panel", e);
                    $(".product-tabs", e).is(":visible") ? (r.removeClass("active"), n.removeClass("active"), s.addClass("active"), $(o).addClass("active")) : (s.hasClass("active") ? (s.removeClass("active"), $(o).removeClass("active")) : (r.removeClass("active"), n.removeClass("active"), s.addClass("active"), $(o).addClass("active")), n.each(function() {
                        $(this).hasClass("active") ? $(this).slideDown(250) : $(this).slideUp(250)
                    }))
                }))
            },
            _initReviews: function() {
                if (!$(this.selectors.productTabs).length) return !1;
                var e = this.selectors.productTabs;
                $(document).off("click", this.selectors.productReviews), $(document).on("click", this.selectors.productReviews, function() {
                    if ($(e).hasClass("tabs-layout-tabs") || $(e).hasClass("tabs-layout-accordion")) {
                        var t = $(e + " #tab-reviews").prev();
                        $(".product-tabs", e).is(":visible") && (t = $(e + " .reviews_tab .product-tabs__title")), t.hasClass("active") || t.trigger("click")
                    }
                    var a = $(e + " #tab-reviews").parent();
                    $(".product-tabs", e).is(":visible") && (a = $(e)), setTimeout(function() {
                        $("html, body").animate({
                            scrollTop: a.offset().top
                        }, 500, "swing")
                    }, 250)
                })
            },
            _initSwatches: function() {
                function e(a, t, e) {
                    if (1 < a.options.length)
                        for (var r = 0; r < a.options.length; r++) r != t && $(n + "-" + r + " option").each(function(s, d) {
                            var l = "unavailable",
                                c = $(d).attr("value"),
                                p = $(d).attr("data-swatch");
                            for (j = 0; j < a.variants.length; j++) {
                                var u = a.variants[j];
                                if (u.options[t] != e) continue;
                                else if (u.options[r] == c) {
                                    l = !0 == u.available ? "available" : "sold_out";
                                    break
                                }
                            }
                            var n = $(d).closest(o).find(".swatch-element." + p);
                            n.removeClass("available"), n.removeClass("sold_out"), n.removeClass("unavailable"), n.addClass(l)
                        });
                    else
                        for (var r = 0; r < a.options.length; r++) $(n + "-" + r + " option").each(function(e, t) {
                            var s = "unavailable",
                                d = $(t).attr("value"),
                                l = $(t).attr("data-swatch");
                            for (j = 0; j < a.variants.length; j++) {
                                var c = a.variants[j];
                                if (c.options[r] == d) {
                                    s = !0 == c.available ? "available" : "sold_out";
                                    break
                                }
                            }
                            console.log(l + " - " + s);
                          	
                            var n = $(t).closest(o).find(".swatch-element." + l);
                            n.removeClass("available"), n.removeClass("sold_out"), n.removeClass("unavailable"), n.addClass(s)
                        })
                }
                var t = $(this.selectors.singleOptionSwatchesRadio);
                if (0 != t.length) {
                    var a = this,
                        o = this.selectors.singleOptionSwatchesWrapper,
                        r = this.productSingleObject,
                        n = this.selectors.singleOptionSelectorId;
                    t.unbind("click"), t.on("click", function(t) {
                        t.preventDefault();
                        var a = $(this).data("value"),
                            s = $(this).closest(o).find("select"),
                            n = s.val();
                        if (n != a) {
                            s.val(a).trigger("change"), $(this).closest(o).find(".swatch-radio").removeClass("selected"), $(this).closest(o).find("label").removeClass("label-selected"), $(this).parent().addClass("label-selected"), $(this).closest(o).find(".option-select-value").length && $(this).closest(o).find(".option-select-value").html(a);
                            var d = this,
                                l = $(this).data("swatch"),
                                c = $(this).data("poption"),
                                p = $(this).data("value");
                            e(r, c, p, l, d)
                        }
                    })
                }
            },
            _initVariants: function() {
                var e = {
                    $container: this.$container,
                    enableHistoryState: this.$container.data("enable-history-state") || !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateMedia.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)), this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this))
            },
            _updateAddToCart: function(e) {
                var t = e.variant;
              	console.log('qty : '+t.inventory_quantity)
                $('#variantqty').html(t.inventory_quantity+"");
              	$('.quantity').val(1);
               $('.plus').unbind().click(function(){
					
                  var qtyval=$('.quantity').val();
      				var ava=t.inventory_quantity;
                 console.log(ava);
                    if(qtyval>=ava){
                    	$('.quantity').val(ava-1);
                      console.log('limit crossed');
                       alert('No more product in stock at the moment!!');
                    }

              	});
              
                t ? ($(this.selectors.productPrices).removeClass("visibility-hidden"), t.available ? ($(this.selectors.addToCart, this.selectors.container).prop("", !1), 0 >= t.inventory_quantity && "shopify" == t.inventory_management ? $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.preOrder) : $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.addToCart), $(this.selectors.productQuantity).removeClass("btn-disabled"), $(this.selectors.inComing, this.selectors.container).addClass("hide"), 0 < t.inventory_quantity && "shopify" == t.inventory_management ? this._updateStockCountdown(t.inventory_quantity) : $(this.selectors.stockCountdown).removeClass("hide"), $(this.selectors.totalSold).removeClass("hide")) : ($(this.selectors.addToCart, this.selectors.container).prop("disabled", !0), $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.soldOut), $(this.selectors.productQuantity).addClass("btn-disabled"), t.incoming ? $(this.selectors.inComing, this.selectors.container).html(theme.strings.inComing.replace("{{ date }}", t.next_incoming_date)).removeClass("hide") : $(this.selectors.inComing, this.selectors.container).addClass("hide"), $(this.selectors.stockCountdown).addClass("hide"), $(this.selectors.totalSold).addClass("hide"))) : ($(this.selectors.addToCart, this.selectors.container).prop("disabled", !0), $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.unavailable), $(this.selectors.productQuantity).addClass("btn-disabled"), $(this.selectors.productPrices).addClass("visibility-hidden"), $(this.selectors.inComing, this.selectors.container).addClass("hide"), $(this.selectors.stockCountdown).addClass("hide"), $(this.selectors.totalSold).addClass("hide"))
            	$('.product-form__cart-submit').prop("disabled", 0);	 
                  
            },
            _updateImages: function(e) {
                var t = e.variant;
                this._switchImage(t.featured_image)
                
            },
            _updatePrice: function(e) {
                var t = e.variant;
                $(this.selectors.originalPrice, this.selectors.container).html(theme.CurrencyPicker.formatMoney(t.price)), t.compare_at_price > t.price ? $(this.selectors.comparePrice, this.selectors.container).html(theme.CurrencyPicker.formatMoney(t.compare_at_price)).removeClass("hide") : $(this.selectors.comparePrice, this.selectors.container).addClass("hide")
            },
            _updateSKU: function(e) {
                var t = e.variant;
                $(this.selectors.SKU).html(t.sku)
            },
            _recordRecentlyViewed: function() {
                var e = localStorage.getItem("roarStorage_recentlyViewed") || "[]";
                try {
                    e = JSON.parse(e)
                } catch (t) {
                    localStorage.removeItem("roarStorage_recentlyViewed"), e = JSON.parse("[]")
                }
                var t = this.productSingleObject.id;
                e.includes(t) || e.unshift(t);
                var a = e.filter(function(e) {
                    return null != e
                });
                try {
                    localStorage.setItem("roarStorage_recentlyViewed", JSON.stringify(a.slice(0, 180)))
                } catch (e) {}
            },
            _sizeChart: function() {
                var e = this,
                    t = $("body"),
                    a = $(".sizechart-modal");
                $(document).off("click", e.selectors.sizeChart), $(document).on("click", e.selectors.sizeChart, function(e) {
                    e.preventDefault(), a.addClass("opened"), t.addClass("sizechart-opened")
                }), $(document).off("click", ".sizechart_overlay, .sizechart_close"), $(document).on("click", ".sizechart_overlay, .sizechart_close", function(e) {
                    e.preventDefault(), a.removeClass("opened"), t.removeClass("sizechart-opened")
                }), $(document).keyup(function(e) {
                    "27" == e.which && (a.removeClass("opened"), t.removeClass("sizechart-opened"))
                }), $("body").append(a)
            },
            _productsSlider: function() {
                var e = new theme.Sections;
                e.register("products-slider-sub", theme.ProductsSlider)
            },
            _lineItem: function() {
                theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
                var e = new theme.Sections;
                e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer)
            },
            onLoad: function() {
                this._lineItem()
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace), theme.ProductVideo.removeSectionVideos(this.settings.sectionId), theme.ProductModel.removeSectionModels(this.settings.sectionId)
            }
        }), e
    }(), theme.ProductModel = function() {
        function e(t) {
            if (!t) {
                if (!window.ShopifyXR) return void document.addEventListener("shopify_xr_initialized", function() {
                    e()
                });
                for (var a in s)
                    if (s.hasOwnProperty(a)) {
                        var o = s[a];
                        if (o.loaded) continue;
                        var r = $("#ModelJson-" + a);
                        window.ShopifyXR.addModels(JSON.parse(r.html())), o.loaded = !0
                    } window.ShopifyXR.setupXRElements()
            }
        }

        function t(e) {
            if (!e)
                for (var t in o)
                    if (o.hasOwnProperty(t)) {
                        var s = o[t];
                        s.modelViewerUi || (s.modelViewerUi = new Shopify.ModelViewerUI(s.$element)), a(s)
                    }
        }

        function a(e) {
            var t = r[e.sectionId];
            e.$container.on("mediaVisible", function() {
                t.$element.attr("data-shopify-model3d-id", e.modelId);
                theme.Helpers.isTouch() || e.modelViewerUi.play()
            }), e.$container.on("mediaHidden", function() {
                t.$element.attr("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause()
            }).on("xrLaunch", function() {
                e.modelViewerUi.pause()
            })
        }
        var s = {},
            o = {},
            r = {},
            n = {
                mediaGroup: "[data-product-single-media-group]",
                xrButton: "[data-shopify-xr]"
            };
        return {
            init: function(a, d) {
                s[d] = {
                    loaded: !1
                }, a.each(function(e) {
                    var t = $(this),
                        a = t.data("media-id"),
                        s = $(t.find("model-viewer")[0]),
                        l = s.data("model-id");
                    if (0 === e) {
                        var c = t.closest(n.mediaGroup).find(n.xrButton);
                        r[d] = {
                            $element: c,
                            defaultId: l
                        }
                    }
                    o[a] = {
                        modelId: l,
                        sectionId: d,
                        $container: t,
                        $element: s
                    }
                }), window.Shopify.loadFeatures([{
                    name: "shopify-xr",
                    version: "1.0",
                    onLoad: e
                }, {
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: t
                }]), theme.LibraryLoader.load("modelViewerUiStyles")
            },
            removeSectionModels: function(e) {
                for (var t in o)
                    if (o.hasOwnProperty(t)) {
                        var a = o[t];
                        a.sectionId === e && (o[t].modelViewerUi.destroy(), delete o[t])
                    } delete s[e]
            }
        }
    }(), theme.ProductVideo = function() {
        function e(e) {
            return e ? void r() : void o(d.html5)
        }

        function t() {
            window.YT.Player && o(d.youtube)
        }

        function a(e) {
            if (!e.player) {
                var t = e.container.closest(l.productMediaWrapper),
                    a = t.data(c.enableVideoLooping);
                switch (e.host) {
                    case d.html5:
                        e.player = new Shopify.Plyr(e.element, {
                            loop: {
                                active: a
                            }
                        });
                        break;
                    case d.youtube:
                        var s = t.data(c.videoId);
                        e.player = new YT.Player(e.element, {
                            videoId: s,
                            events: {
                                onStateChange: function(e) {
                                    0 === e.data && a && e.target.seekTo(0)
                                }
                            }
                        });
                }
                t.on("mediaHidden xrLaunch", function() {
                    e.player && (e.host === d.html5 && e.player.pause(), e.host === d.youtube && e.player.pauseVideo && e.player.pauseVideo())
                }), t.on("mediaVisible", function() {
                    theme.Helpers.isTouch() || !e.player || (e.host === d.html5 && e.player.play(), e.host === d.youtube && e.player.playVideo && e.player.playVideo())
                })
            }
        }

        function s(e) {
            return "VIDEO" === e.tagName ? d.html5 : "IFRAME" === e.tagName && /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e.src) ? d.youtube : null
        }

        function o(e) {
            for (var t in n)
                if (n.hasOwnProperty(t)) {
                    var a = n[t];
                    a.host === e && a.ready()
                }
        }

        function r() {
            for (var e in n)
                if (n.hasOwnProperty(e)) {
                    var t = n[e];
                    if (t.nativeVideo) continue;
                    t.host === d.html5 && (t.element.setAttribute("controls", "controls"), t.nativeVideo = !0)
                }
        }
        var n = {},
            d = {
                html5: "html5",
                youtube: "youtube"
            },
            l = {
                productMediaWrapper: "[data-product-single-media-wrapper]"
            },
            c = {
                enableVideoLooping: "enable-video-looping",
                videoId: "video-id"
            };
        return {
            init: function(o, r) {
                if (o.length) {
                    var l = o.find("iframe, video")[0],
                        c = o.data("mediaId");
                    if (l) {
                        n[c] = {
                            mediaId: c,
                            sectionId: r,
                            host: s(l),
                            container: o,
                            element: l,
                            ready: function() {
                                a(this)
                            }
                        };
                        var p = n[c];
                        switch (p.host) {
                            case d.html5:
                                window.Shopify.loadFeatures([{
                                    name: "video-ui",
                                    version: "1.0",
                                    onLoad: e
                                }]), theme.LibraryLoader.load("plyrShopifyStyles");
                                break;
                            case d.youtube:
                                theme.LibraryLoader.load("youtubeSdk", t);
                        }
                    }
                }
            },
            hosts: d,
            loadVideos: o,
            removeSectionVideos: function(e) {
                for (var t in n)
                    if (n.hasOwnProperty(t)) {
                        var a = n[t];
                        a.sectionId === e && (a.player && a.player.destroy(), delete n[t])
                    }
            }
        }
    }(), theme.LineItem = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                enableHistoryState: !1,
                namespace: ".ProductSection-" + a,
                sectionId: a,
                swatchColor: !0,
                swatchColorAdvanced: !0,
                swatchSize: !0
            }, this.selectors = {
                container: t,
                productImage: ".ProductImage-" + a,
                productColor: ".ProductColor-" + a,
                addToCart: ".AddToCart-" + a,
                addToCartText: ".AddToCartText-" + a,
                comparePrice: ".ComparePrice-" + a,
                originalPrice: ".ProductPrice-" + a,
                productPrices: ".product-single__price-" + a,
                originalSelectorId: ".ProductSelect-" + a,
                singleOptionSwatchesWrapper: ".wrapper-swatches-" + a,
                singleOptionSelector: ".single-option-selector-" + a,
                singleOptionSelectorId: "#SingleOptionSelector-" + a,
                singleOptionSwatches: "tawcvs-swatches-" + a,
                singleOptionSwatchesRadio: ".swatch-radio-" + a
            }, !$(".ProductJson-" + a, t).html() || t.data("section-state") || (this.productSingleObject = JSON.parse($(".ProductJson-" + a, t).html()), this.productSwatchSingleObject = JSON.parse($(".ProductSwatchJson-" + a, t).html()), this.productMoreSingleObject = JSON.parse($(".ProductMoreJson-" + a, t).html()), this._updateProductObject(), this._initVariants(), this._initSwatches(), t.data("section-state", !0))
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _updateProductObject: function() {
                var e = this;
                $.each(e.productMoreSingleObject.variants, function(t, a) {
                    $.each(a, function(a, s) {
                        e.productSingleObject.variants[t][a] = s
                    })
                })
            },
            _initSwatches: function() {
                function e(a, t, e) {
                    if (1 < a.options.length)
                        for (var r = 0; r < a.options.length; r++) r != t && $(n + "-" + r + " option").each(function(s, d) {
                            var l = "unavailable",
                                c = $(d).attr("value"),
                                p = $(d).attr("data-swatch");
                            for (j = 0; j < a.variants.length; j++) {
                                var u = a.variants[j];
                                if (u.options[t] != e) continue;
                                else if (u.options[r] == c) {
                                    l = !0 == u.available ? "available" : "sold_out";
                                    break
                                }
                            }
                            var n = $(d).closest(o).find(".swatch-element." + p);
                            n.removeClass("available"), n.removeClass("sold_out"), n.removeClass("unavailable"), n.addClass(l)
                        });
                    else
                        for (var r = 0; r < a.options.length; r++) $(n + "-" + r + " option").each(function(e, t) {
                            var s = "unavailable",
                                d = $(t).attr("value"),
                                l = $(t).attr("data-swatch");
                            for (j = 0; j < a.variants.length; j++) {
                                var c = a.variants[j];
                                if (c.options[r] == d) {
                                    s = !0 == c.available ? "available" : "sold_out";
                                    break
                                }
                            }
                            var n = $(t).closest(o).find(".swatch-element." + l);
                            n.removeClass("available"), n.removeClass("sold_out"), n.removeClass("unavailable"), n.addClass(s)
                        })
                }
                var t = $(this.selectors.singleOptionSwatchesRadio);
                if (0 != t.length) {
                    var a = this,
                        o = this.selectors.singleOptionSwatchesWrapper,
                        r = this.productSingleObject,
                        n = this.selectors.singleOptionSelectorId;
                    t.unbind("click"), t.on("click", function(t) {
                        t.preventDefault();
                        var a = $(this).data("value"),
                            s = $(this).closest(o).find("select"),
                            n = s.val();
                        if (n != a) {
                            s.val(a).trigger("change"), $(this).closest(o).find(".swatch-radio").removeClass("selected"), $(this).closest(o).find("label").removeClass("label-selected"), $(this).parent().addClass("label-selected"), $(this).closest(o).find(".option-select-value").length && $(this).closest(o).find(".option-select-value").html(a);
                            var d = this,
                                l = $(this).data("swatch"),
                                c = $(this).data("poption"),
                                p = $(this).data("value");
                            e(r, c, p, l, d)
                        }
                    })
                }
            },
            _initVariants: function() {
                var e = {
                    $container: this.$container,
                    enableHistoryState: !1,
                    singleOptionSelector: this.selectors.singleOptionSelector,
                    originalSelectorId: this.selectors.originalSelectorId,
                    product: this.productSingleObject
                };
                this.variants = new slate.Variants(e), this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)), this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)), this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this))
            },
            _updateAddToCart: function(e) {
                var t = e.variant;
                t ? ($(this.selectors.productPrices).removeClass("visibility-hidden"), t.available ? ($(this.selectors.addToCart, this.selectors.container).prop("disabled", !1), 0 >= t.inventory_quantity && "shopify" == t.inventory_management ? $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.preOrder) : $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.addToCart)) : ($(this.selectors.addToCart, this.selectors.container).prop("disabled", !0), $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.soldOut))) : ($(this.selectors.addToCart, this.selectors.container).prop("disabled", !0), $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.unavailable), $(this.selectors.productPrices).addClass("visibility-hidden"))
            },
            _updateImages: function(e) {
                var t = e.variant;
                this._switchImage(t.featured_image), this._switchColor(t)
            },
            _updatePrice: function(e) {
                var t = e.variant;
                $(this.selectors.originalPrice, this.selectors.container).html(theme.CurrencyPicker.formatMoney(t.price)), t.compare_at_price > t.price ? $(this.selectors.comparePrice, this.selectors.container).html(theme.CurrencyPicker.formatMoney(t.compare_at_price)).removeClass("hide") : $(this.selectors.comparePrice, this.selectors.container).addClass("hide")
            },
            _switchImage: function(e) {
                var t = $(this.selectors.productImage);
                t.attr("data-bgset", theme.roarJs.bgSet(e)).removeClass("lazyloaded").addClass("lazyload")
            },
            _switchColor: function(e) {
                var t = $(this.selectors.productColor + " .swatch-item");
                t.length && (t.removeClass("active"), t.each(function() {
                    $(this).data("variant_id") == e.id && $(this).addClass("active")
                }))
            },
            onUnload: function() {
                this.$container.off(this.settings.namespace)
            }
        }), e
    }(), theme.Instagram = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                template: "<div class=\"item\"><a href=\"{{href}}\" target=\"_blank\"><span class=\"meta d-flex align-items-center justify-content-center\"><span class=\"likes\">{{likes}}</span><span class=\"comments\">{{comments}}</span></span><img class=\"lazyload\" src=\"{{src}}\" data-srcset=\"{{srcset}}\" /></a></div>",
                accessToken: t.data("access_token"),
                count: t.data("count"),
                selector: "#instagram-" + a
            }, "" == this.settings.accessToken || 0 == this.settings.count || this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function() {
                var e = this,
                    t = e._buildUrl();
                $.get(t, function(t) {
                    if ("object" == typeof t && 200 == t.meta.code && 0 < t.data.length) {
                        var a = t.data,
                            s = "";
                        for (i = 0, len = a.length; i < len; i++) {
                            var o = "",
                                r = a[i],
                                n = r.images.thumbnail.url,
                                d = r.images.thumbnail.url + " 150w, " + r.images.low_resolution.url + " 320w, " + r.images.standard_resolution.url + " 480w";
                            o = e._makeTemplate(e.settings.template, {
                                href: r.link,
                                src: n,
                                srcset: d,
                                likes: r.likes.count,
                                comments: r.comments.count
                            }), s += o
                        }
                        $(e.settings.selector).append(s)
                    }
                })
            },
            _buildUrl: function() {
                var e, t, a;
                return e = "https://api.instagram.com/v1", t = "users/self/media/recent", a = e + "/" + t, a += "?access_token=" + this.settings.accessToken, a += "&count=" + this.settings.count, a
            },
            _makeTemplate: function(e, t) {
                var a, s, o, r, n;
                for (s = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, a = e; s.test(a);) r = a.match(s)[1], n = null == (o = this._getObjectProperty(t, r)) ? "" : o, a = a.replace(s, function() {
                    return "" + n
                });
                return a
            },
            _getObjectProperty: function(e, t) {
                var a, s;
                for (t = t.replace(/\[(\w+)\]/g, ".$1"), s = t.split("."); s.length;)
                    if (a = s.shift(), null != e && a in e) e = e[a];
                    else return null;
                return e
            }
        }), e
    }(), theme.CountdownTimer = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                selector: ".countdown-" + a + ":not(.is-countdown)"
            }, this.regional(), this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            regional: function() {
                return "undefined" != typeof $.fn.countdown && void($.countdown.regionalOptions.roar = {
                    labels: ["Years", "Months", "Weeks", theme.strings.days, theme.strings.hours, theme.strings.minutes, theme.strings.seconds],
                    labels1: ["Year", "Month", "Week", theme.strings.day, theme.strings.hour, theme.strings.minute, theme.strings.second],
                    compactLabels: ["y", "m", "w", "d"],
                    whichLabels: null,
                    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
                    timeSeparator: ":",
                    isRTL: theme.settings.rtl
                }, $.countdown.setDefaults($.countdown.regionalOptions.roar))
            },
            init: function() {
                if ("undefined" == typeof $.fn.countdown) return !1;
                var e = $(this.settings.selector);
                e.each(function() {
                    var e = $(this);
                    if ("" != e.data("end_date")) {
                        var t = e.data("end_date").split("-"),
                            a = new Date(t[2], parseInt(t[0]) - 1, t[1]),
                            s = new Date;
                        e.countdown({
                            until: a,
                            alwaysExpire: !0,
                            onExpiry: function() {
                                e.hide()
                            }
                        })
                    }
                })
            }
        }), e
    }(), theme.NewsletterPopup = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                selector: "#newsletter-popup-" + a
            }, this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function() {
                try {
                    function o() {
                        $(document.body).removeClass("newsletter-opened").removeClass("newsletter2-opened"), $(document.body).trigger("roarNewsletter_closed", [e])
                    }
                    var e = $(this.settings.selector),
                        t = e.data("period"),
                        a = e.data("delay"),
                        s = e.data("version");
                    if (0 < t && document.cookie.match(/^(.*;)?\s*roarStorage_newsletter\s*=\s*[^;]+(.*)?$/)) return;
                    $(window).on("load", function() {
                        setTimeout(function() {
                            "popup2" == s ? $(document.body).addClass("newsletter2-opened") : $(document.body).addClass("newsletter-opened")
                        }, 1e3 * a)
                    }), $(document.body).on("roarNewsletter_closed", function() {
                        var e = new Date,
                            a = e.getTime();
                        e.setTime(e.getTime() + 1e3 * (60 * (60 * (24 * t)))), document.cookie = "roarStorage_newsletter=" + a + ";expires=" + e.toGMTString() + ";path=/"
                    }), $(document.body).on("click", ".newsletter-popup-section .close_icon, .newsletter-popup2-section .close_icon, .newsletter-popup-backdrop", function(t) {
                        t.preventDefault(), o()
                    }), $(document).on("keyup", function(t) {
                        27 === t.keyCode && o()
                    })
                } catch (t) {}
            }
        }), e
    }(), theme.LookbookSection = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                init: !1
            }, this.selectors = {
                lookbookId: "#lookbook__id-" + a + " .roarlookbook",
                lookbookContent: "#lookbook__content-" + a
            }, this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            init: function() {
                var e = this;
                $(document).on("DOMNodeInserted", e.selectors.lookbookId, function() {
                    if (!1 == e.settings.init) {
                        e.settings.init = !0;
                        var t = $(this);
                        setTimeout(function() {
                            t.closest(".slideshow__slide").addClass("slide-active"), t.find(".media__blank-preview").append($(e.selectors.lookbookContent))
                        }, 0)
                    }
                })
            },
            onLoad: function() {
                roarLookbook.buildLookbook()
            }
        }), e
    }(), theme.ProductsSlider = function() {
        function ProductsSlider(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.settings = {
                finished: !1,
                cache: {},
                grid_num: 4,
                grid_row: 1,
                max_pages: 1,
                next_page: 1,
                cat_id: !1,
                storage_id: !1,
                storage_data: [],
                atts: {}
            }, this.selectors = {
                slider: ".slick-slider-" + a + ":not(.slick-initialized)"
            }, this._initSlider()
        }
        return ProductsSlider.prototype = _.assignIn({}, ProductsSlider.prototype, {
            _isEditor: function() {
                return !!(window !== window.parent && 0 <= window.top.location.pathname.indexOf("/admin") && 0 <= window.top.location.pathname.indexOf("/editor"))
            },
            _initSlider: function(evt) {
                var self = this,
                    that = $(self.selectors.slider);
                if (self.settings.atts = eval("({" + that.data("atts") + "})"), self.settings.max_pages = that.data("max_pages"), self.settings.cat_id = that.data("cat_id"), self.settings.storage_id = that.data("storage_id"), self.settings.storage_data = [], "undefined" != typeof self.settings.cat_id || "undefined" != typeof self.settings.storage_id) {
                    var parent = that.closest(".products-slider");
                    if (self.settings.grid_num = that.data("grid_num"), self.settings.grid_row = that.data("grid_row"), "undefined" != typeof self.settings.storage_id && self.settings.storage_id.length) {
                        var storageName = "roarStorage_" + self.settings.storage_id,
                            items = localStorage.getItem(storageName) || "[]";
                        try {
                            items = JSON.parse(items)
                        } catch (e) {
                            localStorage.removeItem(storageName), items = JSON.parse("[]")
                        }
                        var productId = 0;
                        productId = "undefined" == typeof window.ShopifyAnalytics ? weketingShop.productJson.id : window.ShopifyAnalytics.meta.product.id, items.includes(productId) && items.splice(items.indexOf(productId), 1), self.settings.storage_data = items;
                        var howManyToShow = Math.min(self.settings.storage_data.length, 180);
                        howManyToShow && (howManyToShow <= self.settings.grid_num * self.settings.grid_row && $(".slick-arrows", parent).remove(), self._buildSlider())
                    }
                    2 > self.settings.max_pages || ($(".slick-prev", parent).off("click").on("click", function(e) {
                        e.preventDefault(), self._isEditor() || (--self.settings.next_page, 0 >= self.settings.next_page && (self.settings.next_page = self.settings.max_pages), self._buildSlider())
                    }), $(".slick-next", parent).off("click").on("click", function(e) {
                        e.preventDefault(), self._isEditor() || (++self.settings.next_page, self.settings.next_page > self.settings.max_pages && (self.settings.next_page = 1), self._buildSlider())
                    }), $(window).scroll(function() {
                        var e = $(".slick-arrows", parent),
                            t = $(".slick-prev", parent),
                            a = $(".slick-next", parent),
                            s = $(window).height() / 2,
                            d = $(window).outerWidth(!0),
                            r = parent.outerWidth(!0),
                            o = $(window).scrollTop(),
                            c = parent.offset().top - s,
                            u = parent.offset().left - 50,
                            g = r + parent.offset().left + 50 - a.outerWidth(),
                            m = t.outerHeight(),
                            p = parent.height() - m,
                            n = "left";
                        theme.settings.rtl && (n = "right"), 1024 >= $(window).width() && (u += 35, g -= 35), t.css(n, u + "px"), a.css(n, g + "px"), o < c || o > c + p ? e.removeClass("show-arrow") : e.addClass("show-arrow")
                    }))
                }
            },
            _buildSlider: function() {
                var e = this,
                    t = !1,
                    a = 1e3;
                "undefined" == typeof e.settings.cache[e.settings.next_page] && (t = "undefined" == typeof e.settings.cat_id ? e._ajaxStorage() : e._ajaxCollection(), a = 0);
                var s = $(e.selectors.slider).closest(".products-slider");
                s.addClass("loading"), $.when(t).done(function() {
                    setTimeout(function() {
                        e._buildProducts(), e._lineItem()
                    }, a), setTimeout(function() {
                        s.removeClass("loading")
                    }, a + 250)
                })
            },
            _ajaxCollection: function() {
                var e = this,
                    t = $(e.selectors.slider).closest(".products-slider");
                if (!t.hasClass("loading") && !t.hasClass("finished")) {
                    var e = this;
                    return $.ajax({
                        url: "/collections/" + e.settings.cat_id,
                        type: "GET",
                        dataType: "html",
                        data: {
                            view: "custom",
                            limit: e.settings.grid_num + "*" + e.settings.grid_row,
                            page: e.settings.next_page,
                            type: e.settings.atts.image_ratio + "*" + 1 * e.settings.atts.image_ratio_crop + "*" + 1 * e.settings.atts.image_second + "*" + e.settings.atts.image_overlay + "*" + e.settings.atts.product_hover + "*" + 1 * e.settings.atts.vendor + "*" + 1 * e.settings.atts.review + "*" + 1 * e.settings.atts.quickview + "*" + 1 * e.settings.atts.wishlist + "*" + 1 * e.settings.atts.compare,
                            cache: !1
                        },
                        success: function(a) {
                            if ($(a).find(".product").length) {
                                if (e.settings.cache[e.settings.next_page] = a, !1 == $(a).data("is_next")) {
                                    e.settings.finished = !0;
                                    for (var s = 1; s <= e.settings.next_page; s++) "undefined" == typeof e.settings.cache[s] && (e.settings.finished = !1)
                                }
                                e._buildProducts()
                            } else e.settings.finished = !0;
                            e.settings.finished && t.addClass("finished")
                        }
                    })
                }
            },
            _ajaxStorage: function() {
                var e = this,
                    t = $(e.selectors.slider).closest(".products-slider");
                if (!t.hasClass("loading") && !t.hasClass("finished")) {
                    var e = this,
                        a = e.settings.grid_num * e.settings.grid_row,
                        s = (e.settings.next_page - 1) * a,
                        o = e.settings.storage_data.splice(s, a),
                        r = o.map(function(e) {
                            return "id:" + e
                        }).join(" OR ");
                    return $.ajax({
                        url: "/search",
                        data: {
                            view: "viewed",
                            type: "product",
                            q: r
                        },
                        dataType: "html",
                        type: "GET",
                        success: function(a) {
                            if ($(a).find(".product").length) {
                                if (e.settings.cache[e.settings.next_page] = a, t.closest(".products-slider_hide").removeClass("hide"), 0 == e.settings.storage_data.length) {
                                    e.settings.finished = !0;
                                    for (var s = 1; s <= e.settings.next_page; s++) "undefined" == typeof e.settings.cache[s] && (e.settings.finished = !1)
                                }
                                e._buildProducts()
                            } else e.settings.finished = !0;
                            e.settings.finished && t.addClass("finished")
                        }
                    })
                }
            },
            _buildProducts: function() {
                var e = this,
                    t = $(e.selectors.slider).closest(".products-slider"),
                    a = $(e.settings.cache[e.settings.next_page]),
                    s = t.find(".products");
                $.fn.countdown && s.find(".product__countdown .is-countdown").each(function() {
                    $(this).countdown("destroy")
                }), s.empty(), 0 < a.find(".product").length && (a.find(".product__image").removeClass("lazyloaded").removeClass("lazyloading").addClass("lazyload"), a.find(".product").each(function() {
                    s.append($(this))
                }))
            },
            _lineItem: function() {
                theme.roarJs.initReviews(), theme.roarJs.splitText(), theme.roarJs.animationProduct(), theme.roarJs.fixtooltipHover();
                var e = new theme.Sections;
                e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer)
            },
            onLoad: function() {
                this._lineItem()
            }
        }), ProductsSlider
    }(), theme.ProductTabs = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = t.attr("data-section-id");
            this.selectors = {
                container: ".tabs__container",
                title: ".tabs__title",
                panel: ".tabs__panel"
            }, this._initTabs(), this._productsSlider()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _initTabs: function() {
                var e = this;
                $(document).off("click", e.selectors.title), $(document).on("click", e.selectors.title, function(t) {
                    t.preventDefault();
                    var a = $(this),
                        s = a.closest(e.selectors.container),
                        o = $(a.attr("href")),
                        r = o.find(".slick-slider"),
                        n = s.find(e.selectors.title),
                        d = s.find(e.selectors.panel);
                    n.removeClass("active"), d.removeClass("active"), a.addClass("active"), o.addClass("active"), r.hasClass("slick-initialized") && r.slick("setPosition")
                })
            },
            _productsSlider: function() {
                var e = new theme.Sections;
                e.register("products-slider-sub", theme.ProductsSlider)
            },
            _lineItem: function() {
                theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
                var e = new theme.Sections;
                e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer)
            },
            onLoad: function() {
                this._lineItem()
            }
        }), e
    }(), theme.RichBanner = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = this.sectionId = t.attr("data-section-id");
            this.selectors = {
                bannerId: "#shopify-section-" + a,
                bannerNamspace: "#rich-banners-" + a,
                bannerAnime: "#rich-banners-" + a + " .has--anime-fx",
                bannerTilter: "#rich-banners-" + a + " .has--tilt-effect",
                bannerSlider: "#rich-banners-" + a + " .rich-banner--group.is-slick_slider"
            }, this.settings = {
                mediaQueryMediumUp: "screen and (min-width: 768px)",
                mediaQuerySmall: "screen and (max-width: 767px)",
                sliderActive: !1
            }, this._initBreakpoints(), this._initAnime(), this._initTilter()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            _initBreakpoints: function() {
                var e = this;
                enquire.register(this.settings.mediaQuerySmall, {
                    match: function() {
                        e.settings.sliderActive && e._destroySlider(), e._initSlider()
                    }
                }), enquire.register(this.settings.mediaQueryMediumUp, {
                    match: function() {
                        e.settings.sliderActive && e._destroySlider(), e._initSlider(!1)
                    }
                })
            },
            _destroySlider: function() {
                var e = this;
                $(e.selectors.bannerSlider).each(function() {
                    var t = $(this),
                        a = t.find(".rich-banner--slider.slick-initialized");
                    a.slick("unslick"), e.settings.sliderActive = !1
                })
            },
            _initSlider: function(e) {
                var t = this;
                $(t.selectors.bannerSlider).each(function() {
                    var a = $(this);
                    "undefined" == typeof e && (e = !0);
                    var s = a.find(".rich-banner--slider:not(.slick-initialized)"),
                        o = {
                            rtl: theme.settings.rtl,
                            dots: !1,
                            arrows: !0,
                            slidesToScroll: 1,
                            slidesToShow: a.data("per_slide"),
                            autoplay: a.data("autoplay"),
                            autoplaySpeed: a.data("interval"),
                            variableWidth: a.data("variable_width"),
                            centerMode: a.data("variable_width"),
                            appendArrows: $(".slick-arrows", s.parent()),
                            prevArrow: "<button class=\"slick-prev\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-prev\"></use></svg></button>",
                            nextArrow: "<button class=\"slick-next\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-next\"></use></svg></button>"
                        };
                    !0 == e && (o.slidesToShow = a.data("per_slide_mb")), s.slick(o), t.settings.sliderActive = !0
                })
            },
            _initTilter: function() {
                $(this.selectors.bannerTilter).each(function() {
                    var e = $(this);
                    e.on("mousemove", function(t) {
                        var e = $(this).offset().left,
                            a = $(this).offset().top,
                            s = t.pageX - e,
                            o = t.pageY - a,
                            r = $(this).width() / 2 - s,
                            n = $(this).height() / 2 - o;
                        $(this).css("transform", "perspective(500px) rotateX(" + n / 40 + "deg) rotateY(" + -(r / 40) + "deg) translateZ(10px)");
                        0 < Math.sign(r) ? -Math.abs(r) : Math.abs(r);
                        $(this).removeClass("tilt-leave")
                    }), e.on("mouseleave", function() {
                        $(this).addClass("tilt-leave")
                    })
                })
            },
            _initAnime: function() {
                $(this.selectors.bannerAnime).each(function() {
                    var e = $(this),
                        t = {
                            used: e.data("fx"),
                            type: e.data("fx_type")
                        };
                    t.used && ("dominos" == t.type ? anime.timeline({
                        loop: !0
                    }).add({
                        targets: e.find(".fx__dominos .letter").toArray(),
                        rotateY: [-90, 0],
                        duration: 1300,
                        delay: function(e, t) {
                            return 45 * t
                        }
                    }).add({
                        targets: e.find(".fx__dominos").toArray(),
                        opacity: 0,
                        duration: 1e3,
                        easing: "easeOutExpo",
                        delay: 1e3
                    }) : "vertical-lines" == t.type ? anime.timeline({
                        loop: !0
                    }).add({
                        targets: e.find(".fx__vertical-lines .letter").toArray(),
                        scale: [.3, 1],
                        opacity: [0, 1],
                        translateZ: 0,
                        easing: "easeOutExpo",
                        duration: 600,
                        delay: function(e, t) {
                            return 70 * (t + 1)
                        }
                    }).add({
                        targets: e.find(".fx__vertical-lines .line").toArray(),
                        scaleX: [0, 1],
                        opacity: [.5, 1],
                        easing: "easeOutExpo",
                        duration: 700,
                        offset: "-=875",
                        delay: function(e, t, a) {
                            return 80 * (a - t)
                        }
                    }).add({
                        targets: e.find(".fx__vertical-lines").toArray(),
                        opacity: 0,
                        duration: 1e3,
                        easing: "easeOutExpo",
                        delay: 1e3
                    }) : "fading" == t.type ? anime.timeline({
                        loop: !0
                    }).add({
                        targets: e.find(".fx__fading .letter").toArray(),
                        opacity: [0, 1],
                        easing: "easeInOutQuad",
                        duration: 2250,
                        delay: function(e, t) {
                            return 150 * (t + 1)
                        }
                    }).add({
                        targets: e.find(".fx__fading").toArray(),
                        opacity: 0,
                        duration: 1e3,
                        easing: "easeOutExpo",
                        delay: 1e3
                    }) : "intro" == t.type ? anime.timeline({
                        loop: !0
                    }).add({
                        targets: e.find(".fx__intro .letter").toArray(),
                        translateX: [40, 0],
                        translateZ: 0,
                        opacity: [0, 1],
                        easing: "easeOutExpo",
                        duration: 1200,
                        delay: function(e, t) {
                            return 500 + 30 * t
                        }
                    }).add({
                        targets: e.find(".fx__intro .letter").toArray(),
                        translateX: [0, -30],
                        opacity: [1, 0],
                        easing: "easeInExpo",
                        duration: 1100,
                        delay: function(e, t) {
                            return 100 + 30 * t
                        }
                    }) : "surprising" == t.type ? anime.timeline({
                        loop: !0
                    }).add({
                        targets: e.find(".fx__surprising .word").toArray(),
                        scale: [14, 1],
                        opacity: [0, 1],
                        easing: "easeOutCirc",
                        duration: 800,
                        delay: function(e, t) {
                            return 800 * t
                        }
                    }).add({
                        targets: e.find(".fx__surprising").toArray(),
                        opacity: 0,
                        duration: 1e3,
                        easing: "easeOutExpo",
                        delay: 1e3
                    }) : anime.timeline({
                        loop: !0
                    }).add({
                        targets: e.find(".fx__typing .line").toArray(),
                        scaleY: [0, 1],
                        opacity: [.5, 1],
                        easing: "easeOutExpo",
                        duration: 700
                    }).add({
                        targets: e.find(".fx__typing .line").toArray(),
                        translateX: [0, e.find(".fx__typing .letters").first().width()],
                        easing: "easeOutExpo",
                        duration: 700,
                        delay: 100
                    }).add({
                        targets: e.find(".fx__typing .letter").toArray(),
                        opacity: [0, 1],
                        easing: "easeOutExpo",
                        duration: 600,
                        offset: "-=775",
                        delay: function(e, t) {
                            return 34 * (t + 1)
                        }
                    }).add({
                        targets: e.find(".fx__typing").toArray(),
                        opacity: 0,
                        duration: 1e3,
                        easing: "easeOutExpo",
                        delay: 1e3
                    }))
                })
            },
            _lineItem: function() {
                theme.roarJs.initReviews(), theme.roarJs.fixtooltipHover();
                var e = new theme.Sections;
                e.register("line_item", theme.LineItem), e.register("countdown-timer", theme.CountdownTimer)
            },
            onLoad: function() {
                this._lineItem()
            },
            onUnload: function() {
                this.$container.off(this.bannerNamspace)
            }
        }), e
    }(), theme.CollectionsSlider = function() {
        function e(e) {
            var t = this.$container = $(e),
                a = this.sectionId = t.attr("data-section-id");
            this.selectors = {
                container: "#CollectionsSlider-" + a,
                carousel: "#CollectionsSlider-" + a + " .slider_large",
                carousel_small: "#CollectionsSlider-" + a + " .slider_small",
                carousel_content: "#CollectionsSlider-" + a + " .slider_content-wrapper"
            }, this.beforeInit(), this.init()
        }
        return e.prototype = _.assignIn({}, e.prototype, {
            beforeInit: function() {
                var e = .01 * window.innerHeight;
                if (document.documentElement.style.setProperty("--vh", e + "px"), window.addEventListener("resize", function() {
                        var e = .01 * window.innerHeight;
                        document.documentElement.style.setProperty("--vh", e + "px")
                    }), "undefined" == typeof Flickity.prototype._createPrevNextCells) {
                    function e(e, t, a) {
                        e && e.getCellElements().forEach(function(e) {
                            e.classList[t](a)
                        })
                    }
                    Flickity.createMethods.push("_createPrevNextCells"), Flickity.prototype._createPrevNextCells = function() {
                        this.on("select", this.setPrevNextCells)
                    }, Flickity.prototype.setPrevNextCells = function() {
                        e(this.previousSlide, "remove", "is-previous"), e(this.nextSlide, "remove", "is-next");
                        var t = fizzyUIUtils.modulo(this.selectedIndex - 1, this.slides.length),
                            a = fizzyUIUtils.modulo(this.selectedIndex + 1, this.slides.length);
                        this.previousSlide = this.slides[t], this.nextSlide = this.slides[a], e(this.previousSlide, "add", "is-previous"), e(this.nextSlide, "add", "is-next")
                    }
                }
            },
            init: function() {
                var e = this,
                    t = $(e.selectors.carousel),
                    a = $(e.selectors.carousel_small),
                    s = $(e.selectors.carousel_content),
                    o = Math.floor(a.find(".slideshow__slide").length) - 1,
                    r = t.data("autoplay"),
                    n = t.data("speed"),
                    d = t.find(".slideshow__image"),
                    l = a.find(".slideshow__image");
                theme.settings.rtl && (o = 1);
                var c = new Flickity(e.selectors.carousel_content, {
                        rightToLeft: theme.settings.rtl,
                        prevNextButtons: !0,
                        pageDots: !0,
                        wrapAround: !0,
                        autoPlay: !!r && n,
                        draggable: !1,
                        setGallerySize: !1,
                        sync: e.selectors.carousel,
                        arrowShape: "M3.1,28.9 28.6,3.4 32.9,7.7 14.7,25.9 68.1,25.9 68.1,32 14.7,32 32.9,50.2 28.6,54.5 z",
                        on: {
                            ready: function() {}
                        }
                    }),
                    p = new Flickity(e.selectors.carousel_small, {
                        rightToLeft: theme.settings.rtl,
                        bgLazyLoad: 1,
                        imagesLoaded: !0,
                        prevNextButtons: !1,
                        pageDots: !1,
                        wrapAround: !0,
                        autoPlay: !!r && n,
                        draggable: !1,
                        setGallerySize: !1,
                        initialIndex: o,
                        on: {
                            ready: function() {
                                var e = new TimelineLite,
                                    t = a.find(".flickity-slider");
                                e.fromTo(t, 2, {
                                    scale: 1.2
                                }, {
                                    ease: Power4.easeInOut,
                                    scale: 1
                                }, 0)
                            }
                        }
                    });
                p.on("scroll", function() {
                    p.slides.forEach(function(e, t) {
                        var a = l[t],
                            s = 0;
                        a && (s = 0 === t ? Math.abs(p.x) > p.slidesWidth ? p.slidesWidth + p.x + p.slides[p.slides.length - 1].outerWidth + e.target : e.target + p.x : t === u.slides.length - 1 ? Math.abs(p.x) + p.slides[t].outerWidth < p.slidesWidth ? e.target - p.slidesWidth + p.x - p.slides[t].outerWidth : e.target + p.x : e.target + p.x, "undefined" != typeof window.mobileCheck && !window.mobileCheck() && !theme.settings.rtl && (a.style.transform = "translateX(" + s * (-1 / 2) + "px)"))
                    })
                });
                var u = new Flickity(e.selectors.carousel, {
                    rightToLeft: theme.settings.rtl,
                    bgLazyLoad: 1,
                    imagesLoaded: !0,
                    accessibility: !1,
                    prevNextButtons: !1,
                    pageDots: !1,
                    contain: !0,
                    wrapAround: !0,
                    setGallerySize: !1,
                    sync: e.selectors.carousel_content,
                    autoPlay: !!r && n,
                    arrowShape: {
                        x0: 10,
                        x1: 60,
                        y1: 50,
                        x2: 60,
                        y2: 45,
                        x3: 15
                    },
                    on: {
                        ready: function() {
                            var e = new TimelineLite,
                                a = t.find(".flickity-slider"),
                                s = t.find(".slider-content-wrapper"),
                                o = t.find(".flickity-button svg"),
                                r = t.find(".flickity-page-dots");
                            e.fromTo(a, 2, {
                                scale: 1.2
                            }, {
                                ease: Power4.easeInOut,
                                scale: 1
                            }, 0), e.fromTo(s, 2.4, {
                                opacity: 0
                            }, {
                                ease: Power4.easeInOut,
                                opacity: 1
                            }, 1), e.fromTo([o, r], 2, {
                                opacity: 0
                            }, {
                                ease: Power4.easeInOut,
                                opacity: 1
                            }, 1.3)
                        }
                    }
                });
                $(document).on("click", e.selectors.carousel_content + " .flickity-prev-next-button.previous", function() {
                    p.previous()
                }), $(document).on("click", e.selectors.carousel_content + " .flickity-prev-next-button.next", function() {
                    p.next()
                });
                var g = null,
                    m = null;
                u.on("dragMove", function(t, a, s) {
                    g = u.selectedIndex, m = e.getSwipeDirection(s), r && p.stopPlayer()
                }), u.on("dragEnd", function() {
                    u.selectedIndex !== g && ("left" === m ? p.next() : p.previous())
                }), $(e.selectors.container).on("mouseenter", function() {
                    u.stopPlayer(), p.stopPlayer(), c.stopPlayer()
                }), u.on("scroll", function() {
                    u.slides.forEach(function(e, t) {
                        var a = d[t],
                            s = 0;
                        a && (s = 0 === t ? Math.abs(u.x) > u.slidesWidth ? u.slidesWidth + u.x + u.slides[u.slides.length - 1].outerWidth + e.target : e.target + u.x : t === u.slides.length - 1 ? Math.abs(u.x) + u.slides[t].outerWidth < u.slidesWidth ? e.target - u.slidesWidth + u.x - u.slides[t].outerWidth : e.target + u.x : e.target + u.x, "undefined" != typeof window.mobileCheck && !window.mobileCheck() && !theme.settings.rtl && (a.style.transform = "translateX(" + s * (-1 / 2) + "px)"))
                    })
                })
            },
            getSwipeDirection: function(e) {
                var t = null;
                return t = 0 < e.x ? "right" : "left", t
            },
            onSelect: function() {
                "undefined" != typeof theme.roarAdminJs && theme.roarAdminJs.refresh()
            },
            onLoad: function() {},
            onUnload: function() {}
        }), e
    }();
var roarLookbook = {
    getSizedImageUrl: function(s, t) {
        var e = document.createElement("a");
        if (e.href = s, "cdn.shopify.com" != e.hostname) return s;
        if (null == t) return s;
        if ("master" == t) return roarLookbook.removeProtocol(s);
        var r = s.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != r) {
            var e = s.split(r[0]),
                n = r[0];
            return roarLookbook.removeProtocol(e[0] + "_" + t + n)
        }
        return null
    },
    removeProtocol: function(e) {
        return e.replace(/http(s)?:/, "")
    },
    isProductUrl: function(e) {
        var t = window.location.hostname,
            a = document.createElement("a");
        return a.href = e, a.hostname == t
    },
    isImageUrl: function(e) {
        return new Promise(function(t) {
            var a = new Image;
            $(a).load(function() {
                t(!0)
            }).error(function() {
                t(!1)
            }).attr("src", e)
        })
    },
    buildLookbook: function() {
        $(".roarlookbook").each(function() {
            var e = $(this);
            if (!e.hasClass("roarlookbook_init")) {
                var t = e.find(".image-preview"),
                    a = roarLookbook.isImageUrl(t.attr("src"));
                a.then(function() {
                    var t = e.find(".media__blank-preview");
                    e.addClass("roarlookbook_init"), t.addClass("sfx-fadeIn")
                })
            }
        })
    },
    resetHotspots: function(e) {
        var t = $(".hotspot", e),
            a = e.attr("data-lookbook");
        t.each(function() {
            var t = $(this),
                s = t.attr("data-id"),
                o = $("#" + a + "-" + s, e);
            o.fadeOut("fast", function() {
                o.remove(), t.removeClass("hotspot_init")
            })
        })
    },
    hotspotPopup: function() {
        $(".roarlookbook").on("click", ".hotspot", function() {
            var e = $(this);
            if (!e.hasClass("hotspot_init")) {
                var t = e.closest(".roarlookbook"),
                    a = e.attr("data-id"),
                    s = e.closest(".roarlookbook").attr("data-lookbook") + "-" + a,
                    o = "#" + e.closest(".roarlookbook").attr("data-lookbook") + "-" + a,
                    r = e.attr("data-title"),
                    n = e.attr("data-image"),
                    d = e.attr("data-price"),
                    l = e.attr("data-url"),
                    c = "";
                if ("" == r && "" == l) return !1;
                if (e.addClass("hotspot_loading"), roarLookbook.resetHotspots(t), c += "<div id=\"" + s + "\" class=\"hotspot-widget hotspot-loading\">", c += "<div class=\"hotspot-content\">", c += "<span class=\"hotspot-close\">\xD7</span>", c += "<div class=\"hotspot-inner\">", "" != n) {
                    var p = "<img src=\"" + roarLookbook.getSizedImageUrl(n, "80x") + "\" src=\"" + roarLookbook.getSizedImageUrl(n, "300x") + "\" data-srcset=\"" + roarLookbook.getSizedImageUrl(n, "300x") + " 1x, " + roarLookbook.getSizedImageUrl(n, "600x") + " 2x\" alt=\"\" />";
                    c += "" == l ? p : "<a href=\"" + l + "\">" + p + "</a>"
                }
                if ("" != r && (c += "<h3>", c += "" == l ? r : "<a href=\"" + l + "\">" + r + "</a>", c += "</h3>"), "" != d && (c += "<div class=\"price\"><span class=\"money\">" + d + "</span></div>", roarLookbook.isProductUrl(l) && (c += "<div class=\"hotspot-btns\">", c += "<div class=\"hotspot-btn\"><a href=\"" + l + "\">" + theme.apps.details + "</a></div>", c += "<div class=\"hotspot-btn\"><a class=\"roar_add_to_cart\" href=\"" + l + "?add-to-cart=true\">" + theme.apps.buyNow + "</a></div>", c += "</div>")), c += "</div>", c += "</div>", c += "</div>", $(o).length || t.append(c), $(o).find("img").length) {
                    var u = $(o).find("img");
                    u.attr("src", u.attr("data-src")).removeAttr("data-src").attr("srcset", u.attr("data-srcset")).removeAttr("data-srcset")
                }
                var g = roarLookbook.isImageUrl(n);
                g.then(function() {
                    setTimeout(function() {
                        var a = $(o),
                            s = e.offset().left,
                            r = e.offset().top,
                            n = a.outerWidth(),
                            d = a.outerHeight(),
                            l = t.offset().left,
                            c = t.offset().top,
                            p = t.outerWidth() - (s + n),
                            u = "hotspot-right";
                        s > n + 5 ? (s = s - n - 5, u = "hotspot-left") : s = s + e.outerWidth() + 5, r = r + e.outerHeight() / 2 - d / 2, a.css({
                            left: s - l,
                            top: r - c
                        }).removeClass("hotspot-left").removeClass("hotspot-right").addClass(u), e.removeClass("hotspot_loading").addClass("hotspot_init"), a.removeClass("hotspot-loading").fadeIn("fast")
                    }, 600)
                })
            } else {
                var t = e.closest(".roarlookbook");
                roarLookbook.resetHotspots(t)
            }
        }), $(document).on("click", ".hotspot-close", function() {
            var e = $(this),
                t = e.closest(".hotspot-widget"),
                a = t.attr("id"),
                s = a.split("-"),
                o = s[1];
            $(".roarlookbook .hotspot[data-id=\"" + o + "\"]").removeClass("hotspot_init"), t.fadeOut("fast", function() {
                t.remove()
            })
        }), $(".roarlookbook").on("click", ".image-preview", function() {
            var e = $(this).closest(".roarlookbook");
            roarLookbook.resetHotspots(e)
        }), $(window).resize(function() {
            $(".roarlookbook .hotspot_init").length && $(".roarlookbook .hotspot_init").each(function() {
                var e = $(this);
                e.removeClass("hotspot_init").trigger("click")
            })
        })
    },
    addToCart: function() {
        $(document).on("click", ".roar_add_to_cart", function(e) {
            e.preventDefault();
            var t = $(this),
                a = t.closest(".roarlookbook"),
                s = t.attr("href");
            $.ajax({
                type: "GET",
                url: s,
                beforeSend: function() {},
                success: function(e) {
                    var t = $(e).find("form[action=\"/cart/add\"]");
                    t.appendTo(a).submit().remove()
                },
                dataType: "html"
            })
        })
    },
    init: function() {
        $(".roarlookbook").length && (roarLookbook.buildLookbook(), roarLookbook.hotspotPopup(), roarLookbook.addToCart())
    }
};
theme.roarJs = function() {
    function e() {
        $(document).off("click", ".section__anchor"), $(document).on("click", ".section__anchor", function(e) {
            e.preventDefault();
            var t = $(this).closest(".container-section"),
                a = t.offset().top + t.outerHeight();
            $(".header-sticky__placeholder").length && !$(".header-sticky__placeholder").hasClass("hide") && (a -= $(".header-sticky__placeholder").outerHeight()), $("html, body").animate({
                scrollTop: a
            }, 500, "swing")
        })
    }

    function t() {
        var e = [{}, {
            movement: {
                imgWrapper: {
                    translation: {
                        x: 10,
                        y: 10,
                        z: 30
                    },
                    rotation: {
                        x: 0,
                        y: -10,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 200,
                        easing: "easeOutQuad"
                    }
                },
                lines: {
                    translation: {
                        x: 10,
                        y: 10,
                        z: [0, 70]
                    },
                    rotation: {
                        x: 0,
                        y: 0,
                        z: -2
                    },
                    reverseAnimation: {
                        duration: 2e3,
                        easing: "easeOutExpo"
                    }
                },
                caption: {
                    rotation: {
                        x: 0,
                        y: 0,
                        z: 2
                    },
                    reverseAnimation: {
                        duration: 200,
                        easing: "easeOutQuad"
                    }
                },
                overlay: {
                    translation: {
                        x: 10,
                        y: -10,
                        z: 0
                    },
                    rotation: {
                        x: 0,
                        y: 0,
                        z: 2
                    },
                    reverseAnimation: {
                        duration: 2e3,
                        easing: "easeOutExpo"
                    }
                },
                shine: {
                    translation: {
                        x: 100,
                        y: 100,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 200,
                        easing: "easeOutQuad"
                    }
                }
            }
        }, {
            movement: {
                imgWrapper: {
                    rotation: {
                        x: -5,
                        y: 10,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 900,
                        easing: "easeOutCubic"
                    }
                },
                caption: {
                    translation: {
                        x: 30,
                        y: 30,
                        z: [0, 40]
                    },
                    rotation: {
                        x: [0, 15],
                        y: 0,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 1200,
                        easing: "easeOutExpo"
                    }
                },
                overlay: {
                    translation: {
                        x: 10,
                        y: 10,
                        z: [0, 20]
                    },
                    reverseAnimation: {
                        duration: 1e3,
                        easing: "easeOutExpo"
                    }
                },
                shine: {
                    translation: {
                        x: 100,
                        y: 100,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 900,
                        easing: "easeOutCubic"
                    }
                }
            }
        }, {
            movement: {
                imgWrapper: {
                    rotation: {
                        x: -5,
                        y: 10,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 50,
                        easing: "easeOutQuad"
                    }
                },
                caption: {
                    translation: {
                        x: 20,
                        y: 20,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 200,
                        easing: "easeOutQuad"
                    }
                },
                overlay: {
                    translation: {
                        x: 5,
                        y: -5,
                        z: 0
                    },
                    rotation: {
                        x: 0,
                        y: 0,
                        z: 6
                    },
                    reverseAnimation: {
                        duration: 1e3,
                        easing: "easeOutQuad"
                    }
                },
                shine: {
                    translation: {
                        x: 50,
                        y: 50,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 50,
                        easing: "easeOutQuad"
                    }
                }
            }
        }, {
            movement: {
                imgWrapper: {
                    translation: {
                        x: 0,
                        y: -8,
                        z: 0
                    },
                    rotation: {
                        x: 3,
                        y: 3,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 1200,
                        easing: "easeOutExpo"
                    }
                },
                lines: {
                    translation: {
                        x: 15,
                        y: 15,
                        z: [0, 15]
                    },
                    reverseAnimation: {
                        duration: 1200,
                        easing: "easeOutExpo"
                    }
                },
                overlay: {
                    translation: {
                        x: 0,
                        y: 8,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 600,
                        easing: "easeOutExpo"
                    }
                },
                caption: {
                    translation: {
                        x: 10,
                        y: -15,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 900,
                        easing: "easeOutExpo"
                    }
                },
                shine: {
                    translation: {
                        x: 50,
                        y: 50,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 1200,
                        easing: "easeOutExpo"
                    }
                }
            }
        }, {
            movement: {
                lines: {
                    translation: {
                        x: -5,
                        y: 5,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 1e3,
                        easing: "easeOutExpo"
                    }
                },
                caption: {
                    translation: {
                        x: 15,
                        y: 15,
                        z: 0
                    },
                    rotation: {
                        x: 0,
                        y: 0,
                        z: 3
                    },
                    reverseAnimation: {
                        duration: 1500,
                        easing: "easeOutElastic",
                        elasticity: 700
                    }
                },
                overlay: {
                    translation: {
                        x: 15,
                        y: -15,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 500,
                        easing: "easeOutExpo"
                    }
                },
                shine: {
                    translation: {
                        x: 50,
                        y: 50,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 500,
                        easing: "easeOutExpo"
                    }
                }
            }
        }, {
            movement: {
                imgWrapper: {
                    translation: {
                        x: 5,
                        y: 5,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 800,
                        easing: "easeOutQuart"
                    }
                },
                caption: {
                    translation: {
                        x: 10,
                        y: 10,
                        z: [0, 50]
                    },
                    reverseAnimation: {
                        duration: 1e3,
                        easing: "easeOutQuart"
                    }
                },
                shine: {
                    translation: {
                        x: 50,
                        y: 50,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 800,
                        easing: "easeOutQuart"
                    }
                }
            }
        }, {
            movement: {
                lines: {
                    translation: {
                        x: 40,
                        y: 40,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 1500,
                        easing: "easeOutElastic"
                    }
                },
                caption: {
                    translation: {
                        x: 20,
                        y: 20,
                        z: 0
                    },
                    rotation: {
                        x: 0,
                        y: 0,
                        z: -5
                    },
                    reverseAnimation: {
                        duration: 1e3,
                        easing: "easeOutExpo"
                    }
                },
                overlay: {
                    translation: {
                        x: -30,
                        y: -30,
                        z: 0
                    },
                    rotation: {
                        x: 0,
                        y: 0,
                        z: 3
                    },
                    reverseAnimation: {
                        duration: 750,
                        easing: "easeOutExpo"
                    }
                },
                shine: {
                    translation: {
                        x: 100,
                        y: 100,
                        z: 0
                    },
                    reverseAnimation: {
                        duration: 750,
                        easing: "easeOutExpo"
                    }
                }
            }
        }];
        (function() {
            var t = 0;
            [].slice.call(document.querySelectorAll(".tilter")).forEach(function(a, s) {
                t = 0 == s % 30 ? t + 1 : t, new TiltFx(a, e[t - 1])
            })
        })()
    }

    function a() {
        $("#site-loader").length && (NProgress.configure({
            template: "<div class=\"bar\" role=\"bar\"></div>",
            parent: "#site-loader",
            showSpinner: !1,
            easing: "ease",
            minimum: .3,
            speed: 500
        }), NProgress.start(), $(window).on("pagehide", function(e) {
            e.persisted && ($("#site-container").addClass("loading").removeClass("loaded"), $("#site-loader").removeClass("loaded"))
        }), $(window).load(function() {
            $("#site-container").addClass("loaded").removeClass("loading"), $("#site-loader").addClass("loaded"), NProgress.done()
        }))
    }

    function s() {
        var e = function(e) {
            try {
                for (var t, a = e + "=", s = document.cookie.split(";"), o = 0; o < s.length; o++) {
                    for (t = s[o];
                        " " == t.charAt(0);) t = t.substring(1, t.length);
                    if (0 == t.indexOf(a)) return t.substring(a.length, t.length)
                }
                return null
            } catch (t) {
                return null
            }
        }("roarStorage_isAnAdult");
        e ? $("#age__check").remove() : $("#age__check").addClass("active"), $(document).off("click", "#age__check .btn-birthdate"), $(document).on("click", "#age__check .btn-birthdate", function() {
            var e = new Date;
            e.setTime(e.getTime() + 1209600000);
            var t = "; expires=" + e.toGMTString();
            document.cookie = "roarStorage_isAnAdult=true;" + t + "; path=/", $("#age__check").remove()
        })
    }

    function o() {
        function e() {
            var e = new TimelineLite,
                t = $(".site-sidebar .widget-area"),
                a = $(".site-sidebar .site-widget");
            theme.settings.rtl ? (e.fromTo(t, 1, {
                autoAlpha: 0
            }, {
                autoAlpha: 1,
                ease: Power0.easeInOut
            }, .1), e.staggerFromTo(a, .5, {
                opacity: 0,
                skewX: -10,
                x: 40
            }, {
                opacity: 1,
                skewX: 0,
                x: 0
            }, .1, .2)) : (e.fromTo(t, 1, {
                autoAlpha: 0
            }, {
                autoAlpha: 1,
                ease: Power0.easeInOut
            }, .1), e.staggerFromTo(a, .5, {
                opacity: 0,
                skewX: 10,
                x: -40
            }, {
                opacity: 1,
                skewX: 0,
                x: 0
            }, .1, .2))
        }
        $(document).off("click", ".sidebar__btn, .sidebar__close, .sidebar__overlay"), $(document).on("click", ".sidebar__btn, .sidebar__close, .sidebar__overlay", function() {
            $("body").hasClass("sidebar-open") ? $("body").removeClass("sidebar-open") : ($("body").addClass("sidebar-open"), e())
        }), $(document).off("click", ".filters__btn"), $(document).on("click", ".filters__btn", function() {
            $(".shop__filtering").slideToggle()
        })
    }

    function r() {
        $(document).off("click", ".header__toggle"), $(document).on("click", ".header__toggle", function() {
            $(this).toggleClass("active"), $(".collection-header ul").slideToggle()
        })
    }

    function n() {
        $(document).off("click", ".alert-message"), $(document).on("click", ".alert-message", function() {
            $(this).hide();
            var e = 0,
                t = theme.settings.afterAddition;
            $("body").hasClass("quickview-opened") && (t = "message", e = 300, $(".cd-quick-view .cd-close").trigger("click")), $(this).hasClass("cart_message") && "message" == t && setTimeout(function() {
                theme.MiniCart.open()
            }, e)
        })
    }

    function d(e, t, a) {
        "undefined" == typeof a && (a = !1), $(".alert-message").remove();
        var s = "<div class=\"alert alert-" + ("check" == e ? "success" : "error") + " alert-message\"><div class=\"alert__icon\"><i class=\"ris ri-" + e + "\"></i></div><div class=\"alert__content\">" + t + "</div></div>";
        !0 == a && (s = "<div class=\"alert alert-message cart_message\"><div class=\"alert__background\" style=\"background-image:url(" + e + ");\"></div><div class=\"alert__description\">" + t + "</div></div>"), $("body").append(s)
    }

    function l() {
        return !!$(".product__colors .swatch-item").length && void($(document).off("click", ".product__colors .swatch-item"), $(document).on("click", ".product__colors .swatch-item", function(e) {
            e.preventDefault();
            var t = $(this);
            if (!t.hasClass("active")) {
                var a = t.closest(".product__item").find(".product__image-featured"),
                    s = t.data("bgset");
                a.attr("data-bgset", s).removeClass("lazyloaded").addClass("lazyload"), t.closest(".product__colors").find(".swatch-item").removeClass("active"), t.addClass("active")
            }
        }))
    }

    function c() {
        return !!$(".quickview_btn").length && void($(document).off("click", ".quickview_btn"), $(document).on("click", ".quickview_btn", function(e) {
            e.preventDefault();
            var t = $(this),
                a = t.data("collection_handle"),
                s = t.data("product_handle"),
                o = t.closest(".product__item"),
                r = o.find(".product__image"),
                n = r.css("background-image").replace(/^url\(['"](.+)['"]\)/, "$1");
            $.ajax({
                url: "/collections/" + a + "/products/" + s + "?view=quickview&cache=false",
                beforeSend: function() {
                    t.addClass("adding")
                },
                complete: function() {
                    t.removeClass("adding")
                },
                success: function(e) {
                    $(".cd-quick-view .cd-content").empty().html(e), setTimeout(function() {
                        $(".cd-quick-view").addClass("opened")
                    }, 300), setTimeout(function() {
                        $("body").addClass("blurred").addClass("quickview-opened")
                    }, 500), theme.roarJs.productInfoAnimation($(".cd-quick-view"));
                    var t = new theme.Sections;
                    t.register("product-quickview", theme.Product), Shopify.PaymentButton.init()
                }
            })
        }), $(document).off("click", ".cd-close, .cd-overlay"), $(document).on("click", ".cd-close, .cd-overlay", function() {
            $("body").removeClass("blurred").removeClass("quickview-opened"), $(".cd-quick-view").removeClass("opened"), theme.ProductVideo.removeSectionVideos("product-quickview-template"), theme.ProductModel.removeSectionModels("product-quickview-template")
        }), $(document).keyup(function(e) {
            "27" == e.which && $(".cd-quick-view").hasClass("opened") && $(".cd-close").trigger("click")
        }))
    }

    function p() {
        $(document).off("click", ".products-grid .product .options_btn"), $(document).on("click", ".products-grid .product .options_btn", function(e) {
            e.preventDefault();
            var t = $(this).closest(".product");
            t.addClass("opened")
        }), $(document).off("click", ".products-grid .product .close_btn"), $(document).on("click", ".products-grid .product .close_btn", function(e) {
            e.preventDefault();
            var t = $(this).closest(".product");
            t.removeClass("opened")
        })
    }

    function u() {
        $(document).off("click", ".addcart_btn:not(.added), .product-form__cart-submit"), $(document).on("click", ".addcart_btn:not(.added), .product-form__cart-submit", function(e) {
            e.preventDefault();
            var t = $(this),
                a = t.closest("form"),
                s = $("body");
            return !0 == theme.settings.cartAjax ? ($.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !0,
                cache: !1,
                data: a.serialize(),
                dataType: "json",
                beforeSend: function() {
                    t.addClass("adding")
                },
                success: function(e) {
                    if ("redirect" == theme.settings.afterAddition) return window.location = "/cart", !1;
                    var a = theme.MiniCart.update();
                    a.promise().done(function() {
                        var a = 0;
                        t.hasClass("progress-btn") && (a = 500), t.addClass("active"), setTimeout(function() {
                            t.removeClass("adding").text(t.data("added")).addClass("added"), a && setTimeout(function() {
                                t.removeClass("active").removeClass("added")
                            }, 2e3)
                        }, a);
                        var o = theme.settings.afterAddition,
                            r = 0;
                        a && (r = a + 800), (s.hasClass("compare-opened") || s.hasClass("quickview-opened")) && (r = 0, o = "message"), setTimeout(function() {
                            switch (o) {
                                case "minicart":
                                    theme.MiniCart.open();
                                    break;
                                case "message":
                                    var t = e;
                                    if (void 0 !== t.id) {
                                        var a = theme.Images.getSizedImageUrl(t.image, "200x"),
                                            s = t.title,
                                            r = theme.strings.productAdded.replace("{{ product_name }}", s);
                                        d(a, r, !0)
                                    } else {
                                        var r = t.message + ": " + t.description;
                                        d("alert", r)
                                    }
                            }
                        }, r)
                    })
                }, error: function(e) {
                  
                   var a = 0;
                        t.hasClass("progress-btn") && (a = 500), t.addClass("active"), setTimeout(function() {
                            t.removeClass("adding").text("Failed To Add").addClass("added"), a && setTimeout(function() {
                                t.removeClass("active").removeClass("added").text("Add To Cart")
                            }, 2e3)
                        }, a);
                  
                }
            }), !1) : (a.submit(), !1)
        }), $(document).off("click", ".product-form__cart-submit--grouped"), $(document).on("click", ".product-form__cart-submit--grouped", function(e) {
            e.preventDefault();
            var t = $(this),
                a = t.closest(".product-single__content").find(".product-single__grouped .product-form__input");
            return a.length && (Shopify.queue = [], a.each(function() {
                0 < parseInt($(this).val()) && Shopify.queue.push({
                    variantId: $(this).data("variant_id"),
                    quantity: parseInt($(this).val())
                })
            }), Shopify.moveAlong = function() {
                if (Shopify.queue.length) {
                    var e = Shopify.queue.shift();
                    Shopify.addItem(e.variantId, e.quantity, e.properties, Shopify.moveAlong)
                } else t.removeClass("adding"), theme.MiniCart.update(), "redirect" == theme.settings.afterAddition ? location.href = "/cart" : "minicart" == theme.settings.afterAddition && theme.MiniCart.open()
            }, Shopify.addItem = function(e, t, a, s) {
                var o = {
                    quantity: t,
                    id: e
                };
                !1 != a && (o.properties = a), $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: o,
                    success: function() {
                        "function" == typeof s && s()
                    },
                    error: function() {}
                })
            }, Shopify.queue.length && (t.addClass("adding"), Shopify.moveAlong())), !1
        })
    }

    function g() {
        return !!$(".addwishlist_btn").length && void($(document).off("click", ".addwishlist_btn:not(.added)"), $(document).on("click", ".addwishlist_btn:not(.added)", function(e) {
            e.preventDefault();
            var t = $(this),
                a = parseInt(t.data("customer_id"));
            if (0 < a) {
                var s = t.data("shop_domain"),
                    o = parseInt(t.data("product_id")),
                    r = t.data("product_handle").toString();
                if (s.length && r.length && o) {
                    var n = document.createElement("form");
                    n.setAttribute("action", "/contact"), n.setAttribute("method", "POST"), n.setAttribute("style", "display:none");
                    var l = document.createElement("input");
                    l.setAttribute("type", "hidden"), l.setAttribute("name", "customer"), l.setAttribute("value", a);
                    var c = document.createElement("input");
                    c.setAttribute("type", "hidden"), c.setAttribute("name", "shop"), c.setAttribute("value", s);
                    var p = document.createElement("input");
                    p.setAttribute("type", "hidden"), p.setAttribute("name", "id"), p.setAttribute("value", o);
                    var u = document.createElement("input");
                    u.setAttribute("type", "hidden"), u.setAttribute("name", "handle"), u.setAttribute("value", r);
                    var g = document.createElement("input");
                    g.setAttribute("type", "hidden"), g.setAttribute("name", "action"), g.setAttribute("value", "add_wishlist"), n.appendChild(l), n.appendChild(c), n.appendChild(p), n.appendChild(u), n.appendChild(g), $("body").append(n);
                    var m = $(n).serialize();
                    $.ajax({
                        type: "POST",
                        url: "/a/wishlist",
                        async: !0,
                        cache: !1,
                        data: m,
                        dataType: "json",
                        beforeSend: function() {
                            t.addClass("adding")
                        },
                        complete: function() {
                            t.removeClass("adding")
                        },
                        success: function(e) {
                            if (d("check", theme.strings.wishlistAdded), t.addClass("added").find(".tooltip").text(t.data("added")), $(n).remove(), 1 == e.code) {
                                var a = parseInt(e.json);
                                a ? $(".wishlist__count").removeClass("hide").text(a) : $(".wishlist__count").addClass("hide").text(0)
                            }
                        }
                    })
                }
            } else window.location = "/account/login"
        }))
    }

    function m() {
        return !!$(".removewishlist_btn").length && void($(document).off("click", ".removewishlist_btn"), $(document).on("click", ".removewishlist_btn", function() {
            var e = $(this),
                t = parseInt(e.data("customer_id"));
            if (0 < t) {
                var a = e.data("shop_domain"),
                    s = parseInt(e.data("product_id"));
                if (a.length && s) {
                    var o = document.createElement("form");
                    o.setAttribute("action", "/contact"), o.setAttribute("method", "POST"), o.setAttribute("style", "display:none");
                    var r = document.createElement("input");
                    r.setAttribute("type", "hidden"), r.setAttribute("name", "customer"), r.setAttribute("value", t);
                    var n = document.createElement("input");
                    n.setAttribute("type", "hidden"), n.setAttribute("name", "shop"), n.setAttribute("value", a);
                    var l = document.createElement("input");
                    l.setAttribute("type", "hidden"), l.setAttribute("name", "product"), l.setAttribute("value", s);
                    var c = document.createElement("input");
                    c.setAttribute("type", "hidden"), c.setAttribute("name", "action"), c.setAttribute("value", "remove_wishlist"), o.appendChild(r), o.appendChild(n), o.appendChild(l), o.appendChild(c), $("body").append(o);
                    var p = $(o).serialize();
                    $.ajax({
                        type: "POST",
                        url: "/a/wishlist",
                        async: !0,
                        cache: !1,
                        data: p,
                        dataType: "json",
                        beforeSend: function() {
                            $(".wishlist__table").addClass("loading")
                        },
                        complete: function() {
                            $(".wishlist__table").removeClass("loading")
                        },
                        success: function(t) {
                            if ($(o).remove(), 1 == t.code) {
                                var a = parseInt(t.json);
                                a ? e.closest("tr").slideUp("fast", function() {
                                    $(this).remove(), d("check", theme.strings.wishlistRemoved), $(".wishlist__count").removeClass("hide").text(a)
                                }) : location.reload()
                            }
                        }
                    })
                }
            } else window.location = "/account/login"
        }))
    }

    function h() {
        return !!$(".page-wishlist .ajax_load_button .loadmore").length && void($(document).off("click", ".page-wishlist .ajax_load_button .loadmore"), $(document).on("click", ".page-wishlist .ajax_load_button .loadmore", function() {
            var e = ".page-wishlist .ajax_load_button",
                t = ".page-wishlist .wishlist__item",
                a = ".page-wishlist .pagination";
            if ($(a).find("a.next").length) {
                $(".page-wishlist .ajax_load_button .loadmore").attr("data-processing", 1);
                var s = $(a).find("a.next").attr("href"),
                    o = $(".page-wishlist .ajax_load_button .loadmore").data("no_more");
                $(e).addClass("loading"), $.get(s, function(s) {
                    $(a).empty().html($(s).find(a).html()), $(s).find(t).each(function() {
                        $(t).last().after($(this))
                    }), $(e).removeClass("loading"), $(".page-wishlist .ajax_load_button .loadmore").attr("data-processing", 0), 0 == $(a).find("a.next").length && ($(e).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(".page-wishlist .ajax_load_button .loadmore").show().html(o).addClass("disabled").prop("disabled", !0))
                })
            } else {
                var o = $(".page-wishlist .ajax_load_button .loadmore").attr("data-no-more");
                $(e).addClass("ajax_load_finished").removeClass("ajax_load_hidden"), $(".page-wishlist .ajax_load_button .loadmore").show().html(o).addClass("disabled").prop("disabled", !0)
            }
        }))
    }

    function f(e) {
        var t = $("body");
        t.addClass("compare-opened");
        var a = $(".compare__modal");
        a.removeClass("opened"), e && e.length && a.find(".compare__content").empty().html(e), a.addClass("opened"), $(".compare__list tr").each(function() {
            $(this).css("height", $(this).outerHeight())
        }), $(".compare__list").clone().appendTo(".compare__left"), $(".compare__left td").remove()
    }

    function y() {
        var e = $("body");
        e.removeClass("compare-opened");
        var t = $(".compare__modal");
        t.removeClass("opened")
    }

    function v() {
        var e = localStorage.getItem("roarStorage_compare") || "[]";
        try {
            e = JSON.parse(e)
        } catch (t) {
            localStorage.removeItem("roarStorage_compare"), e = JSON.parse("[]")
        }
        var t = e.filter(function(e) {
            return null != e
        });
        return 10 < t.length ? t.slice(0, 10) : t
    }

    function b(e) {
        var t = 10 < e.length ? e.slice(0, 10) : e;
        try {
            localStorage.setItem("roarStorage_compare", JSON.stringify(t))
        } catch (e) {}
        return t
    }

    function C() {
        var e = v(),
            t = $(".compare__link"),
            a = $(".compare__count");
        if (0 < a.length) {
            var s = e.length;
            a.text(s), 0 < s ? (a.removeClass("hide"), t.removeClass("deactive")) : (a.addClass("hide"), t.addClass("deactive"))
        }
    }

    function k() {
        var e = v();
        e.length && $(".addcompare_btn").each(function() {
            var t = $(this),
                a = t.data("product_id");
            e.includes(a) && t.addClass("added").find(".tooltip").text(t.data("added"))
        }), C(), $(document).off("click", ".compare__close"), $(document).on("click", ".compare__close", function() {
            y()
        }), $(document).keyup(function(e) {
            "27" == e.which && $(".compare__modal").hasClass("opened") && y()
        }), $(document).off("click", ".compare__link"), $(document).on("click", ".compare__link", function() {
            var e = $(this),
                t = v(),
                a = t.map(function(e) {
                    return "id:" + e
                }).join(" OR ");
            $.ajax({
                url: "/search",
                data: {
                    view: "compare",
                    type: "product",
                    q: a
                },
                dataType: "html",
                type: "GET",
                beforeSend: function() {
                    e.addClass("loading")
                },
                complete: function() {
                    e.removeClass("loading")
                },
                success: function(e) {
                    f(e), C()
                }
            })
        })
    }

    function w() {
        $(document).off("click", ".addcompare_btn"), $(document).on("click", ".addcompare_btn", function(e) {
            e.preventDefault();
            var t = $(this),
                a = v(),
                s = t.data("product_id");
            a.includes(s) || a.unshift(s), 10 <= a.length && d("alert", theme.strings.compareLimit);
            var o = b(a),
                r = o.map(function(e) {
                    return "id:" + e
                }).join(" OR ");
            $.ajax({
                url: "/search",
                data: {
                    view: "compare",
                    type: "product",
                    q: r
                },
                dataType: "html",
                type: "GET",
                beforeSend: function() {
                    t.removeClass("added").addClass("adding")
                },
                complete: function() {
                    t.removeClass("adding")
                },
                success: function(e) {
                    f(e), t.addClass("added").find(".tooltip").text(t.data("added")), C()
                }
            })
        })
    }

    function x() {
        $(document).off("click", ".removecompare_btn"), $(document).on("click", ".removecompare_btn", function(e) {
            e.preventDefault();
            var t = $(this),
                a = t.data("product_id"),
                s = ".product__" + a,
                o = v();
            o.includes(a) && o.splice(o.indexOf(a), 1);
            var r = b(o);
            r.length ? $(".compare__list " + s).remove() : y();
            var t = $(s + " .addcompare_btn");
            t.removeClass("added").find(".tooltip").text(t.data("tooltip")), C()
        })
    }

    function S() {
        $(".slick__gallery").each(function() {
            var e = $(this);
            e.slick({
                rtl: theme.settings.rtl,
                prevArrow: "<button class=\"slick-prev\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-prev\"></use></svg></button>",
                nextArrow: "<button class=\"slick-next\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-next\"></use></svg></button>"
            })
        }), $(".soundcloud__audio").each(function() {
            var e = $(this),
                t = e.data("video");
            $.ajax({
                async: !0,
                crossDomain: !0,
                url: "https://soundcloud.com/oembed",
                method: "GET",
                headers: {},
                data: {
                    format: "json",
                    url: t
                }
            }).done(function(t) {
                e.replaceWith(t.html)
            })
        })
    }

    function T() {
        $(document).off("click", ".password-login"), $(document).on("click", ".password-login", function(e) {
            e.preventDefault(), $("body").addClass("password-opened"), setTimeout(function() {
                $(".password-modal input").focus()
            }, 250)
        }), $(document).off("click", ".password-modal .modal__close, .password__overlay"), $(document).on("click", ".password-modal .modal__close, .password__overlay", function() {
            $("body").removeClass("password-opened")
        }), $(document).keyup(function(e) {
            27 == e.keyCode && $("body").removeClass("password-opened")
        }), $(".password-modal").find(".errors").length && ($("body").addClass("password-opened"), setTimeout(function() {
            $(".password-modal input").focus()
        }, 250))
    }

    function I() {
        function e(e, t) {
            for (var a = 0; a < t.length; a++)
                if (e.match((".*" + t[a].trim() + ".*").replace(" ", ".*"))) return !0;
            return !1
        }
        var t = ["/cart?", "/search?", "/collections/"];
        $(document).ajaxComplete(function(a, s, o) {
            var r = o.url;
            if (e(r, t)) {
                theme.roarJs.initReviews(), theme.roarJs.splitText(), theme.roarJs.animationProduct(), theme.roarJs.fixtooltipHover();
                var n = new theme.Sections;
                n.register("line_item", theme.LineItem), n.register("countdown-timer", theme.CountdownTimer)
            }
        })
    }

    function A() {
        $(".lookbook-section.is-slick_slider .lookbook-listing").length && $(".lookbook-section.is-slick_slider .lookbook-listing").each(function() {
            var e = $(this),
                t = {
                    rtl: theme.settings.rtl,
                    centerMode: !0,
                    centerPadding: "20%",
                    slidesToShow: 1,
                    appendArrows: $(".slick-arrows", e.parent()),
                    prevArrow: "<button class=\"slick-prev\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-prev\"></use></svg></button>",
                    nextArrow: "<button class=\"slick-next\" type=\"button\"><svg class=\"svg-icon\"><use xlink:href=\"#global__symbols-next\"></use></svg></button>"
                },
                a = e.find(".lookbook__item").length,
                s = setInterval(function() {
                    var o = e.find("img.image-preview").length;
                    a <= o && (e.imagesLoaded(function() {
                        setTimeout(function() {
                            e.slick(t)
                        }, 500)
                    }), clearInterval(s))
                }, 300)
        })
    }

    function P() {
        function e() {
            var e = $(".page-header").outerHeight(),
                t = $(window).height(),
                a = $("#site-footer").height();
            0 < t - e - a ? ($("#site-content").css({
                "min-height": t - e - a - 1
            }), $("#site-container").css({
                "margin-bottom": a - 1
            })) : $("#site-container").css({
                "margin-bottom": a - 1
            })
        }
        $("#site-footer").hasClass("is-reveal") && (e(), $(window).resize(function() {
            e()
        }))
    }

    function O() {
        var e = $(".progress-section"),
            t = $(".progress-page");
        if (t.length && e.length) {
            e.append(t), $(".scrolltotop").on("click", function() {
                return $("html, body").animate({
                    scrollTop: 0
                }, 800), !1
            }), $(window).scroll(function() {
                var e = $(window).scrollTop();
                300 <= e ? t.addClass("is-active") : t.removeClass("is-active")
            });
            var a = 0;
            $(window).scroll(function() {
                var e = $(window).scrollTop();
                e > a ? t.addClass("is-visible") : e < a && t.removeClass("is-visible"), a = e
            });
            var s = document.querySelector(".progress-page path"),
                o = s.getTotalLength();
            s.style.transition = s.style.WebkitTransition = "none", s.style.strokeDasharray = o + " " + o, s.style.strokeDashoffset = o, s.getBoundingClientRect(), s.style.transition = s.style.WebkitTransition = "stroke-dashoffset 10ms linear";
            var r = function() {
                var e = $(window).scrollTop(),
                    t = $(document).height() - $(window).height();
                s.style.strokeDashoffset = o - e * o / t
            };
            r(), $(window).scroll(r)
        }
    }

    function M() {
        return "undefined" != typeof $.fn.imagesLoaded && !1 != theme.settings.animation && void $(".page-header-bg").imagesLoaded({
            background: !0
        }, function() {
            $(".page-header-bg-wrapper").addClass("loaded");
            var e = new TimelineLite,
                t = $(".site-header__main"),
                a = $(".site-header__top"),
                s = $(".page-title"),
                o = $(".term-description"),
                r = $(".breadcrumbs"),
                n = $(".page-categories, .page-meta_list"),
                d = $(".page-delimiter"),
                l = $(".back-btn svg"),
                c = $(".content-area"),
                p = $(".site-pagination"),
                u = $("#site-footer"),
                g = $("body");
            g.addClass("run-anim"), e.fromTo([t, a], 1, {
                autoAlpha: 0,
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                autoAlpha: 1,
                opacity: 1
            }, .2).call(function() {
                g.removeClass("run-anim")
            });
            e.fromTo(s, 1.2, {
                y: 100,
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                y: 0,
                opacity: 1
            }, .3), e.fromTo(o, 1.4, {
                scale: 1.4,
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                scale: 1,
                opacity: 1
            }, .2), e.fromTo(l, 1, {
                x: 20,
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                x: 0,
                opacity: 1
            }, .5), $("body").hasClass("template-collection") ? e.fromTo(r, 1.2, {
                y: 40,
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                y: 0,
                opacity: 1
            }, .25) : $("body").hasClass("template-product") ? e.fromTo(r, 1.2, {
                y: 40,
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                y: 0,
                opacity: 1
            }, .6) : e.fromTo(r, 1.2, {
                y: 40,
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                y: 0,
                opacity: 1
            }, .25), e.fromTo(n, 1.4, {
                y: -40,
                opacity: 0
            }, {
                ease: Power4.easeInOut,
                y: 0,
                opacity: 1
            }, .25), e.fromTo(d, 1, {
                opacity: 0,
                width: 0
            }, {
                opacity: 1,
                width: 70
            }, .8), e.fromTo([c, p], 1, {
                opacity: 0
            }, {
                opacity: 1
            }, .8), e.fromTo(u, 1, {
                opacity: 0
            }, {
                opacity: 1
            }, 1.5)
        })
    }

    function V() {
        return !("undefined" == typeof ParallaxScroll || "undefined" == typeof window.mobileCheck || window.mobileCheck() || !1 == theme.settings.animation) && void ParallaxScroll.init()
    }

    function z() {
        function e(e) {
            function t() {
                n = r.scrollTop(), o.allowScrollUpdate = !0
            }

            function a(e) {
                !0 === o.options.debug && console.log(e)
            }

            function s(e) {
                return e && "[object Function]" === {}.toString.call(e)
            }
            var o = this,
                r = $(window),
                n = r.scrollTop(),
                d = !0,
                l = r.width(),
                c = r.height(),
                p = null,
                u = null,
                g = null,
                m = !1;
            o.init = function(e) {
                return o.options = $.extend({
                    target: null,
                    tween: null,
                    ease: Linear.easeNone,
                    min: 0,
                    max: 1,
                    minSize: 0,
                    speed: .3,
                    defaultProgress: 1,
                    debug: !1,
                    onMin: null,
                    onMax: null,
                    onOutside: null,
                    onInside: null,
                    onUpdate: null
                }, e), null === o.options.target || 1 > o.options.target.length ? (console.warn("Extra Scroll Animator: no target specified"), !1) : null === o.options.tween ? (console.warn("Extra Scroll Animator: no tween specified"), !1) : void(o.allowScrollUpdate = !0, o.update(), o.repaint())
            }, o.updatePosition = function(e) {
                if (d) {
                    var t, r = void 0 !== e && e ? 0 : o.options.speed,
                        l = o.options.target.data("coords");
                    l && (t = 1 - (n - l.max) / (l.min - l.max), 0 >= t && !0 !== p ? (p = !0, s(o.options.onMin) && o.options.onMin(), o.options.target.trigger("extra:scrollanimator:min")) : 0 < t && !1 !== p && (p = !1), 1 <= t && !0 !== u ? (u = !0, s(o.options.onMax) && o.options.onMax(), o.options.target.trigger("extra:scrollanimator:max")) : 1 >= t && !1 !== u && (u = !1), (!0 === p || !0 === u) && !1 !== g ? (g = !1, s(o.options.onOutside) && o.options.onOutside(), o.options.target.trigger("extra:scrollanimator:outside")) : 1 >= t && 0 <= t && !0 !== g && (g = !0, s(o.options.onInside) && o.options.onInside(), o.options.target.trigger("extra:scrollanimator:inside")), !1 === g && (u ? t = 1 : t = 0), t = Math.max(0, Math.min(t)), a(t), TweenLite.to(o.options.tween, r, {
                        progress: t,
                        ease: o.options.ease
                    }))
                }
            }, o.update = function() {
                l = r.width(), c = r.height();
                var e = {},
                    a = o.options.target.offset().top,
                    n = o.options.target.height(),
                    d = o.options.min,
                    p = o.options.max;
                e.min = a - c + c * d, e.max = a - c + n + c * p, o.options.target.data("coords", e), o.options.tween.paused(!0), o.options.tween.progress(o.options.defaultProgress), l < o.options.minSize ? r.off("scroll", t) : (r.on("scroll", t), o.updatePosition(!0)), s(o.options.onUpdate) && o.options.onUpdate(e), o.options.target.trigger("extra:scrollanimator:update", [e])
            }, r.on("extra:resize", o.update), r.on("extra:scrollanimator:resize", o.update), r.on("extra:scrollanimator:tick", o.updatePosition), o.repaint = function() {
                return d ? o.allowScrollUpdate ? void(o.updatePosition(), o.allowScrollUpdate = !1, window.requestAnimationFrame(o.repaint)) : void window.requestAnimationFrame(o.repaint) : void 0
            }, o.init(e), o.updateTween = function(e) {
                o.options.tween && o.options.tween.kill(), o.options.tween = e, o.options.tween.paused(!0), o.options.tween.progress(o.options.defaultProgress), o.allowScrollUpdate = !0, o.update()
            }, o.pause = function() {
                m || (r.off("scroll", t), r.off("extra:resize", o.update), d = !1, m = !0)
            }, o.resume = function() {
                m && (l < o.options.minSize ? r.off("scroll", t) : r.on("scroll", t), r.on("extra:resize", o.update), d = !0, m = !1, o.repaint())
            }, o.destroy = function() {
                d = !1, r.off("scroll", t), r.off("extra:resize", o.update), r.off("extra:scrollanimator:tick", o.updatePosition), o.options.tween && (o.options.tween.paused(!0), o.options.tween.progress(o.options.defaultProgress), o.options.tween.kill()), o.allowScrollUpdate = !1
            }
        }
        window.initPrllx = function(t) {
            if ($(".site-main .article__image").length) {
                var t = $(".site-main"),
                    a = t.find(".article__image");
                a.each(function() {
                    var t, a, s = $(this),
                        o = s.children(),
                        r = s.find(".prllx"),
                        n = o.width();
                    t = new TimelineLite({
                        onUpdate: function() {}
                    }), t.set(r, {
                        y: -1 * r.attr("data-prllx")
                    }).to(r, 1, {
                        y: r.attr("data-prllx"),
                        overwrite: "all",
                        ease: Power0.easeNone
                    }, "-=0.5"), a = new e({
                        target: s,
                        tween: t,
                        defaultProgress: 0,
                        speed: 0,
                        min: -.2,
                        max: 1.3
                    }), s.on("extra:scrollanimator:update", function(e) {
                        e.stopPropagation()
                    })
                })
            }
        }, window.initSkrollr = function() {
            if (0 == $(".site-main .skrollable").length || "undefined" == typeof skrollr) return !1;
            $(".section__bground.skrollable").css("height", "120%").closest(".container-section").addClass("overflow-hidden");
            skrollr.init({
                forceHeight: !1,
                smoothScrolling: !1,
                mobileCheck: function() {
                    return !1
                }
            })
        }, $(window).on("load", function() {
            "undefined" == typeof window.mobileCheck || window.mobileCheck() || (window.initPrllx(), window.initSkrollr())
        })
    }

    function E() {
        return 0 != $(".blog-main .article__listing").length && "undefined" != typeof ScrollReveal && !1 != theme.settings.animation && void(window.sr = ScrollReveal(), sr.reveal(".blog-main .article__listing", {
            opacity: 0,
            duration: 1600,
            mobile: !0,
            viewFactor: 0
        }))
    }

    function L() {
        if ("undefined" == typeof window.mobileCheck) return !1;
        if (992 < $(window).width() && !window.mobileCheck() && 0 < $(".products-grid.layout-2").length) {
            var e = $(".products-grid.layout-2 .category__title:not(.split-text), .products-grid.layout-2 .product__link:not(.split-text), .product-single__notify label:not(.split-text)");
            e.each(function() {
                var e = $(this),
                    t = new SplitText(e, {
                        type: "lines"
                    });
                e.addClass("split-text").find("div").wrapInner("<span></span>")
            })
        }
    }

    function R(e) {
        if (!1 == theme.settings.animation) return !1;
        var t = new TimelineLite,
            a = $(".product-single__title", e),
            s = $(".product-single .product__labels", e),
            o = $(".product-single .sidebar-container", e),
            r = $(".product-single__top .box-share-master-container", e),
            n = $(".product-single__right, .product-single__tools", e),
            d = $(".product-single__nav", e),
            l = $(".product-single__middle", e),
            c = $(".product-single__bottom", e);
        t.fromTo(a, 1.6, {
            y: 100,
            opacity: 0
        }, {
            ease: Power4.easeInOut,
            y: 0,
            opacity: 1
        }, .7), t.fromTo(l, 2, {
            y: 40,
            opacity: 0
        }, {
            ease: Power4.easeInOut,
            y: 0,
            opacity: 1
        }, .8), t.fromTo(c, 2, {
            y: 40,
            opacity: 0
        }, {
            ease: Power4.easeInOut,
            y: 0,
            opacity: 1
        }, 1), t.fromTo([s, r, n, d, o], 2, {
            opacity: 0
        }, {
            ease: Power4.easeInOut,
            opacity: 1
        }, .7)
    }

    function D() {
        return "undefined" != typeof ScrollReveal && !1 != theme.settings.animation && void(window.sr = ScrollReveal(), sr.reveal(".products-grid .product:not(.active)", {
            opacity: 0,
            viewFactor: .2,
            afterReveal: function(e) {
                if ("undefined" == typeof window.mobileCheck || !1 == theme.settings.animation) return !1;
                e.classList.add("active");
                var t = $(e).find(".product__link div span, .category__title div span"),
                    a = $(e).find(".product__review, .more-products"),
                    s = $(e).find(".product__price");
                e.visuelRevealTL = new TimelineLite, 992 < $(window).width() && !window.mobileCheck() && 0 < $(".products-grid.layout-2").length && (e.visuelRevealTL.fromTo(t, 1, {
                    ease: Power4.easeOut,
                    x: 30,
                    y: 100,
                    skewX: 60,
                    opacity: 0
                }, {
                    ease: Power4.easeOut,
                    x: 0,
                    y: 0,
                    skewX: 0,
                    opacity: 1
                }, 0), null !== a && e.visuelRevealTL.fromTo(a, 2, {
                    y: 10,
                    opacity: 0
                }, {
                    ease: Power4.easeOut,
                    y: 0,
                    opacity: 1
                }, .4), null !== s && e.visuelRevealTL.fromTo(s, 2, {
                    y: 10
                }, {
                    ease: Power4.easeOut,
                    y: 0,
                    opacity: 1
                }, .2))
            },
            beforeReveal: function(e) {
                e.classList.add("active");
                var t = $(e).find(".product__image, .category__image");
                null !== t && (e.visuelRevealTL = new TimelineLite, e.visuelRevealTL.fromTo(t, 2, {
                    scale: 1.1
                }, {
                    ease: Power4.easeOut,
                    scale: 1
                }, 0))
            }
        }, 150))
    }

    function W() {
        V(), z(), M(), R($(".product-template__container")), E(), L(), D()
    }

    function q() {
        return 0 != $(".social-sharing").length && "undefined" != typeof $.fn.socialShare && void $(".social-sharing").each(function() {
            var e = $(this);
            e.socialShare({
                name: e.data("name"),
                title: e.data("title"),
                mediaUrl: e.data("share_img"),
                social: e.data("share_elem"),
                animation: "launchpadReverse",
                blur: !0
            })
        })
    }

    function U() {
        $("body").on("click", ".barberry-show-categories", function(e) {
            e.preventDefault();
            var t = $(this),
                a = t.closest(".page-categories-wrapper");
            if (t.hasClass("opened")) {
                var s = new TimelineLite,
                    o = a.find(".barberry-categories"),
                    r = a.find(".barberry-categories .category_item");
                s.fromTo(o, 1, {
                    "max-height": 1e3,
                    autoAlpha: 1
                }, {
                    autoAlpha: 0,
                    "max-height": 0,
                    ease: Power3.easeInOut
                }, 0), setTimeout(function() {
                    t.removeClass("opened"), o.removeClass("opened")
                }, 700)
            } else {
                var s = new TimelineLite,
                    o = a.find(".barberry-categories"),
                    r = a.find(".barberry-categories .category_item");
                s.fromTo(o, 1, {
                    "max-height": 0,
                    autoAlpha: 0
                }, {
                    "max-height": 1e3,
                    autoAlpha: 1,
                    ease: Power4.easeIn
                }, 0), s.staggerFromTo(r, 1, {
                    opacity: 0,
                    scale: 2,
                    skewX: 30
                }, {
                    opacity: 1,
                    scale: 1,
                    skewX: 0,
                    ease: Power4.easeOut
                }, .1, .3), setTimeout(function() {
                    o.addClass("opened"), t.addClass("opened")
                }, 500)
            }
        })
    }

    function F() {
        $("[data-roarslider]").each(function() {
            var e = $(this),
                t = "revapi" + e.data("roarslider");
            document.addEventListener(t, function() {
                e.addClass("loaded")
            }, !1)
        })
    }

    function H() {
        $(".products .product .product__item").hover(function() {
            setTimeout(function() {
                $(this).addClass("phover")
            }.bind(this), 200)
        }, function() {
            setTimeout(function() {
                $(this).removeClass("phover")
            }.bind(this), 200)
        })
    }
    return {
        init: function() {
            a(), s(), q(), W(), U(), roarLookbook.init(), A(), F(), e(), t(), S(), o(), r(), c(), l(), u(), p(), g(), m(), h(), k(), w(), x(), n(), T(), I(), P(), O(), H()
        },
        bgSet: function(e) {
            if (e) {
                var t = e.width / e.height,
                    a = "";
                return [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2048].forEach(function(s) {
                    e.width > s && (a += theme.Images.getSizedImageUrl(e.src, s + "x") + " " + s + "w " + Math.round(s / t) + "h,")
                }), a += theme.Images.getSizedImageUrl(e.src, "master") + " " + e.width + "w " + e.height + "h", a
            }
        },
        backHistory: function() {
            history.go(-1)
        },
        initReviews: function() {
            "undefined" != typeof jQuery && "undefined" != typeof SPR && (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges())
        },
        splitText: L,
        animationProduct: D,
        productInfoAnimation: R,
        fixtooltipHover: H
    }
}(), $(document).ready(function() {
    var e = new theme.Sections;
    e.register("cart-template", theme.Cart), e.register("cart-gift", theme.CartGift), e.register("shipping-calculator", theme.ShippingCalculator), e.register("collection-template", theme.Filters), e.register("sidebar-sticky", theme.SidebarSticky), e.register("product-template", theme.Product), e.register("header-mobile", theme.HeaderMobile), e.register("header-section", theme.HeaderSection), e.register("map", theme.Maps), e.register("slideshow-section", theme.SlideshowSection), e.register("line_item", theme.LineItem), e.register("instagram", theme.Instagram), e.register("countdown-timer", theme.CountdownTimer), e.register("products-slider", theme.ProductsSlider), e.register("product-tabs", theme.ProductTabs), e.register("newsletter-popup", theme.NewsletterPopup), e.register("lookbook-section", theme.LookbookSection), e.register("rich-banner", theme.RichBanner), e.register("collections-slider", theme.CollectionsSlider)
}), theme.init = function() {
    theme.roarJs.init(), theme.customerTemplates.init(), $("a[href=\"#\"]").on("click", function(e) {
        e.preventDefault()
    }), $(document).one("touchstart", function() {
        theme.Helpers.setTouch()
    })
}, $(theme.init), document.addEventListener("lazybeforeunveil", function(t) {
    var e = t.target.getAttribute("data-bg");
    e && (t.target.style.backgroundImage = "url(" + e + ")")
});


var supports_video = function() {
    return !!document.createElement('video').canPlayType;
}

var videoSection = {
    init: function() {

        //Loop through all video sections present.
        $('.js-video.lazyframe').each(function(i, videoElement) {
            if ($(videoElement).hasClass('showPosterImage--true')) {
                var videoParentSection = $(videoElement).closest('.video-section').attr('id');
                lazyframe('#' + videoParentSection + ' .lazyframe.showPosterImage--true', {
                    initinview: false
                });
            } else {
                var videoParentSection = $(videoElement).closest('.video-section').attr('id');
                lazyframe('#' + videoParentSection + ' .lazyframe.showPosterImage--false', {
                    initinview: true,
                    onLoad: function(lazyframe) {
                        $(videoElement).find('iframe').slice(1).remove();
                    }
                });
            }
        })

        function hideTextElements(parent) {
            parent.find('.caption').not('.display-mobile-text').hide();
            parent.find('.caption').not('.display-mobile-text').find('.action_button').hide();
        }

        if ($('.js-video').hasClass('hide-text-on-video') && $('.js-video').hasClass('video-autoplay--true')) {
            var videoSection = $('.js-video.hide-text-on-video.video-autoplay--true');
            hideTextElements(videoSection);
        }

        $(".video-section .lazyvideo.hide-text-on-video").on('click', function() {
            var videoSection = $(this).parents('.js-video-section');
            hideTextElements(videoSection);
        })

        $('[data-play-video-button], video.hide-text-on-video').on('click', function() {
            //Target parent lazyframe
            var videoSection = $(this).parents('.js-video-section');
            var lazyElement = videoSection.find('.lazyframe');
            var videoWrapper = videoSection.find('.js-video');
            if (videoWrapper.data('mp4') || videoWrapper.data('ogv')) {
                if (videoSection.find('.js-video.hide-text-on-video').length) {
                    hideTextElements(videoSection);
                }
            } else {
                //create iframe and add settings
                var lazyIframe = document.createElement('iframe');
                iframeSrc = lazyElement.data('src');
                cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf('?')) + '?&autoplay=1';
                lazyIframe.src = cleanIframeSrc;
                lazyIframe.setAttribute('allowfullscreen', true);
                lazyIframe.setAttribute('frameborder', 0);
                //Append iframe to lazyframe
                lazyElement.append(lazyIframe);
                if (videoSection.find('.js-video.hide-text-on-video').length) {
                    hideTextElements(videoSection);
                }
            }
        });
    },
    unload: function($target) {
        $target.find('[data-play-video]').off('click');
        $target.find('video.hide-text-on-video').off('click');
    }
}